/* AUTO-GENERATED by scripts/codegen/generate-audit-field-catalog.mjs — do not edit. */
export const AUDIT_FIELD_CATALOG_GENERATED = Object.freeze({
    "generatedAt": "codegen",
    "modelCount": 231,
    "models": [
        "AccessLog",
        "Action",
        "ApplicationMethod",
        "ApplicationRequestInformation",
        "ApplicationTracking",
        "Assessment",
        "AssessmentQuestion",
        "Asset",
        "AssetCategory",
        "AssetDisposal",
        "AssetGroup",
        "AssetGroupCriticalityEvaluation",
        "AssetGroupCriticalitySurveyResponse",
        "AssetGroupMeasureApplicability",
        "AssetGroupMeasureEvaluation",
        "AssetLicense",
        "AssetLifecycleEvent",
        "AssetNumberSequence",
        "AssignmentTemplate",
        "AuditAssignment",
        "AuditFinding",
        "AuditPlan",
        "BcmInitialResponseLibrary",
        "BcmRpo",
        "BcmSettings",
        "Bcp",
        "BcpLocation",
        "Bia",
        "BiaImpactConfiguration",
        "BiaRpoCalculation",
        "BiaRpoRecommendation",
        "BigdesCompensatoryControl",
        "BigdesCurrentSituationEvaluationScope",
        "BigdesImplementationProcessEvaluation",
        "BigdesMeasure",
        "BigdesRoadMapWorkPackage",
        "ChangeRequest",
        "Classification",
        "CollectionMethod",
        "Communication",
        "CommunicationChannelPolicy",
        "CommunicationPlan",
        "CommunicationProvider",
        "Company",
        "Competence",
        "ComplianceFramework",
        "ComplianceObligation",
        "ConsentRecord",
        "Context",
        "Control",
        "CookieInventory",
        "CrisisEvent",
        "CrisisRecoveryActivity",
        "CustomFieldDefinition",
        "CustomPermissionDefinition",
        "CustomerImportIdentityLink",
        "CustomerImportMappingProfile",
        "CustomerImportMutation",
        "CustomerImportPackage",
        "CustomerImportPackageRun",
        "CustomerImportRelationMutation",
        "CustomerImportRow",
        "CustomerImportRun",
        "CustomerImportSession",
        "DataBreach",
        "DataDisposalMethod",
        "DataProcessingAgreement",
        "DataSource",
        "DataSubjectRequest",
        "DeadLetterEvent",
        "Delegation",
        "DeliveryReceipt",
        "DetailedReportArchive",
        "DetailedReportJob",
        "DetailedReportNarrative",
        "DetailedReportProfile",
        "DetailedReportSnapshot",
        "DisposalRecord",
        "DisposalRun",
        "Document",
        "DocumentRevision",
        "DocumentType",
        "DpiaAssessment",
        "DpiaTemplate",
        "DutyDefinition",
        "EntityFormLayout",
        "EntityUpdateDraft",
        "EvidenceBundle",
        "Exercise",
        "ExerciseEvaluation",
        "ExerciseParticipant",
        "ExerciseRecoveryActivity",
        "ExplicitConsent",
        "ExplicitConsentMethod",
        "ExplicitConsentReason",
        "ExportJob",
        "FormSubmission",
        "FormTask",
        "FormTemplate",
        "Gap",
        "GeneratedReport",
        "GovernanceReportDefinition",
        "Incident",
        "IncidentComment",
        "IncidentTemplate",
        "IntegrationConnection",
        "IntegrationConnector",
        "IntegrationCredentialSet",
        "IntegrationEndpoint",
        "IntegrationExternalIdentityLink",
        "IntegrationInvocation",
        "IntegrationMapping",
        "IntegrationProviderDefinition",
        "IntegrationSyncState",
        "IntegrationTransferItem",
        "IntegrationTransferRun",
        "IntegrationWebhookReceipt",
        "InterestedParty",
        "InternationalTransfer",
        "Kpi",
        "KvkkCompany",
        "LdapRoleMapping",
        "LegalReason",
        "LessonLearned",
        "MailTemplate",
        "MatrixConfiguration",
        "Meeting",
        "Notification",
        "NotificationDeliveryIntent",
        "NotificationDigestItem",
        "NotificationDispatch",
        "NotificationPolicy",
        "NotificationPolicyRevision",
        "NotificationPolicyVerification",
        "NotificationPreference",
        "NotificationTemplate",
        "Objective",
        "OperationalRun",
        "OperationalRunTask",
        "OperationalRunTaskEvidence",
        "OperationalRunUpdate",
        "OutboxEvent",
        "PartyInstance",
        "PartyTemplate",
        "PatchNote",
        "PersonalDataCategory",
        "PersonalDataInventory",
        "PrivacyNotice",
        "PrivacyPrinciple",
        "Problem",
        "ProblemCandidate",
        "Process",
        "ProcessingPurpose",
        "RecipientGroup",
        "RecoveryResources",
        "RegulatoryClause",
        "RegulatorySource",
        "ReportArchive",
        "ReportArtifact",
        "ReportBranding",
        "ReportBrandingRevision",
        "ReportConfidentialityClass",
        "RetentionPeriod",
        "Risk",
        "RiskAnalysis",
        "RiskConsequence",
        "RiskMitigationDefinition",
        "RiskRegister",
        "RiskReports",
        "Role",
        "RootCause",
        "ScenarioTimeline",
        "ScfAssessmentObjective",
        "ScfAuthoritativeSource",
        "ScfControl",
        "ScfDomain",
        "ScfEvidenceRequest",
        "ScfRisk",
        "ScfThreat",
        "ScopeDocument",
        "SecurityMeasure",
        "SeedTombstone",
        "ServiceCatalogItem",
        "StrategicInitiative",
        "SubjectPersonGroup",
        "SurveyDispatch",
        "SystemLog",
        "SystemSeed",
        "SystemSeedRun",
        "Team",
        "TeamAssignment",
        "TeamDutyProfile",
        "Tenant",
        "TenantBranding",
        "TenantBusinessHours",
        "TenantComplianceConfig",
        "TenantConnectionConfig",
        "TenantControlEvaluation",
        "TenantControlScopePreference",
        "TenantDirectoryConfig",
        "TenantFeatureFlag",
        "TenantHoliday",
        "TenantMfaSettings",
        "Threat",
        "Ticket",
        "TicketCategory",
        "TicketComment",
        "TicketConfig",
        "TicketNumberSequence",
        "TicketRecurrence",
        "TicketSLA",
        "TicketSubtaskComment",
        "TicketTemplate",
        "Training",
        "TransferType",
        "Unit",
        "User",
        "UserNavigationPreference",
        "UserPageLayout",
        "UserTraining",
        "Vendor",
        "VendorAssessment",
        "Vulnerability",
        "Weakness",
        "WebhookDelivery",
        "WebhookSubscription",
        "WorkflowInformedReceipt",
        "WorkflowInstance",
        "WorkflowScheduledTrigger",
        "WorkflowTask",
        "WorkflowTemplate"
    ],
    "aliases": {
        "AccessLog": "accessLog",
        "Action": "action",
        "ApplicationMethod": "applicationMethod",
        "ApplicationRequestInformation": "applicationRequestInformation",
        "ApplicationTracking": "applicationTracking",
        "Assessment": "assessment",
        "AssessmentQuestion": "assessmentQuestion",
        "Asset": "asset",
        "AssetCategory": "assetCategory",
        "AssetDisposal": "assetDisposal",
        "AssetGroup": "assetGroup",
        "AssetGroupCriticality": "assetGroupCriticalityEvaluation",
        "AssetGroupCriticalityEvaluation": "assetGroupCriticalityEvaluation",
        "AssetGroupCriticalitySurveyResponse": "assetGroupCriticalitySurveyResponse",
        "AssetGroupMeasureApplicability": "assetGroupMeasureApplicability",
        "AssetGroupMeasureEvaluation": "assetGroupMeasureEvaluation",
        "AssetLicense": "assetLicense",
        "AssetLifecycleEvent": "assetLifecycleEvent",
        "AssetNumberSequence": "assetNumberSequence",
        "AssignmentTemplate": "assignmentTemplate",
        "AuditAssignment": "auditAssignment",
        "AuditFinding": "auditFinding",
        "AuditPlan": "auditPlan",
        "BcmInitialResponseLibrary": "bcmInitialResponseLibrary",
        "BcmRpo": "bcmRpo",
        "BcmSettings": "bcmSettings",
        "Bcp": "bcp",
        "BcpLocation": "bcpLocation",
        "Bia": "bia",
        "BiaImpactConfiguration": "biaImpactConfiguration",
        "BiaRpoCalculation": "biaRpoCalculation",
        "BiaRpoRecommendation": "biaRpoRecommendation",
        "BigdesCompensatoryControl": "bigdesCompensatoryControl",
        "BigdesCurrentSituationEvaluationScope": "bigdesCurrentSituationEvaluationScope",
        "BigdesImplementationProcessEvaluation": "bigdesImplementationProcessEvaluation",
        "BigdesMeasure": "bigdesMeasure",
        "BigdesRoadMapWorkPackage": "bigdesRoadMapWorkPackage",
        "ChangeRequest": "changeRequest",
        "Classification": "classification",
        "CollectionMethod": "collectionMethod",
        "Communication": "communication",
        "CommunicationChannelPolicy": "communicationChannelPolicy",
        "CommunicationPlan": "communicationPlan",
        "CommunicationProvider": "communicationProvider",
        "Company": "company",
        "Competence": "competence",
        "ComplianceFramework": "complianceFramework",
        "ComplianceObligation": "complianceObligation",
        "ConsentRecord": "consentRecord",
        "Context": "context",
        "Control": "control",
        "CookieInventory": "cookieInventory",
        "CrisisEvent": "crisisEvent",
        "CrisisRecoveryActivity": "crisisRecoveryActivity",
        "CustomFieldDefinition": "customFieldDefinition",
        "CustomPermissionDefinition": "customPermissionDefinition",
        "CustomerImportIdentityLink": "customerImportIdentityLink",
        "CustomerImportMappingProfile": "customerImportMappingProfile",
        "CustomerImportMutation": "customerImportMutation",
        "CustomerImportPackage": "customerImportPackage",
        "CustomerImportPackageRun": "customerImportPackageRun",
        "CustomerImportRelationMutation": "customerImportRelationMutation",
        "CustomerImportRow": "customerImportRow",
        "CustomerImportRun": "customerImportRun",
        "CustomerImportSession": "customerImportSession",
        "DataBreach": "dataBreach",
        "DataDisposalMethod": "dataDisposalMethod",
        "DataProcessingAgreement": "dataProcessingAgreement",
        "DataSource": "dataSource",
        "DataSubjectRequest": "dataSubjectRequest",
        "DeadLetterEvent": "deadLetterEvent",
        "Delegation": "delegation",
        "DeliveryReceipt": "deliveryReceipt",
        "DetailedReportArchive": "detailedReportArchive",
        "DetailedReportJob": "detailedReportJob",
        "DetailedReportNarrative": "detailedReportNarrative",
        "DetailedReportProfile": "detailedReportProfile",
        "DetailedReportSnapshot": "detailedReportSnapshot",
        "DisposalRecord": "disposalRecord",
        "DisposalRun": "disposalRun",
        "Document": "document",
        "DocumentRevision": "documentRevision",
        "DocumentType": "documentType",
        "DpiaAssessment": "dpiaAssessment",
        "DpiaTemplate": "dpiaTemplate",
        "DutyDefinition": "dutyDefinition",
        "EntityFormLayout": "entityFormLayout",
        "EntityUpdateDraft": "entityUpdateDraft",
        "EvidenceBundle": "evidenceBundle",
        "Exercise": "exercise",
        "ExerciseEvaluation": "exerciseEvaluation",
        "ExerciseParticipant": "exerciseParticipant",
        "ExerciseRecoveryActivity": "exerciseRecoveryActivity",
        "ExplicitConsent": "explicitConsent",
        "ExplicitConsentMethod": "explicitConsentMethod",
        "ExplicitConsentReason": "explicitConsentReason",
        "ExportJob": "exportJob",
        "FormSubmission": "formSubmission",
        "FormTask": "formTask",
        "FormTemplate": "formTemplate",
        "Gap": "gap",
        "GeneratedReport": "generatedReport",
        "GovernanceReportDefinition": "governanceReportDefinition",
        "Incident": "incident",
        "IncidentComment": "incidentComment",
        "IncidentTemplate": "incidentTemplate",
        "IntegrationConnection": "integrationConnection",
        "IntegrationConnector": "integrationConnector",
        "IntegrationCredentialSet": "integrationCredentialSet",
        "IntegrationEndpoint": "integrationEndpoint",
        "IntegrationExternalIdentityLink": "integrationExternalIdentityLink",
        "IntegrationInvocation": "integrationInvocation",
        "IntegrationMapping": "integrationMapping",
        "IntegrationProviderDefinition": "integrationProviderDefinition",
        "IntegrationSyncState": "integrationSyncState",
        "IntegrationTransferItem": "integrationTransferItem",
        "IntegrationTransferRun": "integrationTransferRun",
        "IntegrationWebhookReceipt": "integrationWebhookReceipt",
        "InterestedParty": "interestedParty",
        "InternationalTransfer": "internationalTransfer",
        "Kpi": "kpi",
        "KvkkCompany": "kvkkCompany",
        "LdapRoleMapping": "ldapRoleMapping",
        "LegalReason": "legalReason",
        "LessonLearned": "lessonLearned",
        "MailTemplate": "mailTemplate",
        "MatrixConfiguration": "matrixConfiguration",
        "Meeting": "meeting",
        "Notification": "notification",
        "NotificationDeliveryIntent": "notificationDeliveryIntent",
        "NotificationDigestItem": "notificationDigestItem",
        "NotificationDispatch": "notificationDispatch",
        "NotificationPolicy": "notificationPolicy",
        "NotificationPolicyRevision": "notificationPolicyRevision",
        "NotificationPolicyVerification": "notificationPolicyVerification",
        "NotificationPreference": "notificationPreference",
        "NotificationTemplate": "notificationTemplate",
        "Objective": "objective",
        "OperationalRun": "operationalRun",
        "OperationalRunTask": "operationalRunTask",
        "OperationalRunTaskEvidence": "operationalRunTaskEvidence",
        "OperationalRunUpdate": "operationalRunUpdate",
        "OutboxEvent": "outboxEvent",
        "PartyInstance": "partyInstance",
        "PartyTemplate": "partyTemplate",
        "PatchNote": "patchNote",
        "PersonalDataCategory": "personalDataCategory",
        "PersonalDataInventory": "personalDataInventory",
        "PrivacyNotice": "privacyNotice",
        "PrivacyPrinciple": "privacyPrinciple",
        "Problem": "problem",
        "ProblemCandidate": "problemCandidate",
        "Process": "process",
        "ProcessingPurpose": "processingPurpose",
        "RecipientGroup": "recipientGroup",
        "RecoveryResources": "recoveryResources",
        "RegulatoryClause": "regulatoryClause",
        "RegulatorySource": "regulatorySource",
        "ReportArchive": "reportArchive",
        "ReportArtifact": "reportArtifact",
        "ReportBranding": "reportBranding",
        "ReportBrandingRevision": "reportBrandingRevision",
        "ReportConfidentialityClass": "reportConfidentialityClass",
        "RetentionPeriod": "retentionPeriod",
        "Risk": "risk",
        "RiskAnalysis": "riskAnalysis",
        "RiskConsequence": "riskConsequence",
        "RiskMitigationDefinition": "riskMitigationDefinition",
        "RiskRegister": "riskRegister",
        "RiskReports": "riskReports",
        "RiskTreatment": "action",
        "Role": "role",
        "RootCause": "rootCause",
        "ScenarioTimeline": "scenarioTimeline",
        "ScfAssessmentObjective": "scfAssessmentObjective",
        "ScfAuthoritativeSource": "scfAuthoritativeSource",
        "ScfControl": "scfControl",
        "ScfDomain": "scfDomain",
        "ScfEvidenceRequest": "scfEvidenceRequest",
        "ScfRisk": "scfRisk",
        "ScfThreat": "scfThreat",
        "ScopeDocument": "scopeDocument",
        "SecurityMeasure": "securityMeasure",
        "SeedTombstone": "seedTombstone",
        "ServiceCatalogItem": "serviceCatalogItem",
        "StrategicInitiative": "strategicInitiative",
        "SubjectPersonGroup": "subjectPersonGroup",
        "SurveyDispatch": "surveyDispatch",
        "SystemLog": "systemLog",
        "SystemSeed": "systemSeed",
        "SystemSeedRun": "systemSeedRun",
        "Team": "team",
        "TeamAssignment": "teamAssignment",
        "TeamDutyProfile": "teamDutyProfile",
        "Tenant": "tenant",
        "TenantBranding": "tenantBranding",
        "TenantBusinessHours": "tenantBusinessHours",
        "TenantComplianceConfig": "tenantComplianceConfig",
        "TenantConnectionConfig": "tenantConnectionConfig",
        "TenantControlEvaluation": "tenantControlEvaluation",
        "TenantControlScopePreference": "tenantControlScopePreference",
        "TenantDirectoryConfig": "tenantDirectoryConfig",
        "TenantFeatureFlag": "tenantFeatureFlag",
        "TenantHoliday": "tenantHoliday",
        "TenantMfaSettings": "tenantMfaSettings",
        "Threat": "threat",
        "Ticket": "ticket",
        "TicketCategory": "ticketCategory",
        "TicketComment": "ticketComment",
        "TicketConfig": "ticketConfig",
        "TicketNumberSequence": "ticketNumberSequence",
        "TicketRecurrence": "ticketRecurrence",
        "TicketSLA": "ticketSLA",
        "TicketSubtaskComment": "ticketSubtaskComment",
        "TicketTemplate": "ticketTemplate",
        "Training": "training",
        "TransferType": "transferType",
        "Unit": "unit",
        "User": "user",
        "UserNavigationPreference": "userNavigationPreference",
        "UserPageLayout": "userPageLayout",
        "UserTraining": "userTraining",
        "Vendor": "vendor",
        "VendorAssessment": "vendorAssessment",
        "Vulnerability": "vulnerability",
        "Weakness": "weakness",
        "WebhookDelivery": "webhookDelivery",
        "WebhookSubscription": "webhookSubscription",
        "WorkflowInformedReceipt": "workflowInformedReceipt",
        "WorkflowInstance": "workflowInstance",
        "WorkflowScheduledTrigger": "workflowScheduledTrigger",
        "WorkflowTask": "workflowTask",
        "WorkflowTemplate": "workflowTemplate",
        "accesslog": "accessLog",
        "action": "action",
        "applicationmethod": "applicationMethod",
        "applicationrequestinformation": "applicationRequestInformation",
        "applicationtracking": "applicationTracking",
        "assessment": "assessment",
        "assessmentquestion": "assessmentQuestion",
        "asset": "asset",
        "assetcategory": "assetCategory",
        "assetdisposal": "assetDisposal",
        "assetgroup": "assetGroup",
        "assetgroupcriticalityevaluation": "assetGroupCriticalityEvaluation",
        "assetgroupcriticalitysurveyresponse": "assetGroupCriticalitySurveyResponse",
        "assetgroupmeasureapplicability": "assetGroupMeasureApplicability",
        "assetgroupmeasureevaluation": "assetGroupMeasureEvaluation",
        "assetlicense": "assetLicense",
        "assetlifecycleevent": "assetLifecycleEvent",
        "assetnumbersequence": "assetNumberSequence",
        "assignmenttemplate": "assignmentTemplate",
        "auditassignment": "auditAssignment",
        "auditfinding": "auditFinding",
        "auditplan": "auditPlan",
        "bcminitialresponselibrary": "bcmInitialResponseLibrary",
        "bcmrpo": "bcmRpo",
        "bcmsettings": "bcmSettings",
        "bcp": "bcp",
        "bcplocation": "bcpLocation",
        "bia": "bia",
        "biaimpactconfiguration": "biaImpactConfiguration",
        "biarpocalculation": "biaRpoCalculation",
        "biarporecommendation": "biaRpoRecommendation",
        "bigdescompensatorycontrol": "bigdesCompensatoryControl",
        "bigdescurrentsituationevaluationscope": "bigdesCurrentSituationEvaluationScope",
        "bigdesimplementationprocessevaluation": "bigdesImplementationProcessEvaluation",
        "bigdesmeasure": "bigdesMeasure",
        "bigdesroadmapworkpackage": "bigdesRoadMapWorkPackage",
        "changerequest": "changeRequest",
        "classification": "classification",
        "collectionmethod": "collectionMethod",
        "communication": "communication",
        "communicationchannelpolicy": "communicationChannelPolicy",
        "communicationplan": "communicationPlan",
        "communicationprovider": "communicationProvider",
        "company": "company",
        "competence": "competence",
        "complianceframework": "complianceFramework",
        "complianceobligation": "complianceObligation",
        "consentrecord": "consentRecord",
        "context": "context",
        "control": "control",
        "cookieinventory": "cookieInventory",
        "crisisevent": "crisisEvent",
        "crisisrecoveryactivity": "crisisRecoveryActivity",
        "customerimportidentitylink": "customerImportIdentityLink",
        "customerimportmappingprofile": "customerImportMappingProfile",
        "customerimportmutation": "customerImportMutation",
        "customerimportpackage": "customerImportPackage",
        "customerimportpackagerun": "customerImportPackageRun",
        "customerimportrelationmutation": "customerImportRelationMutation",
        "customerimportrow": "customerImportRow",
        "customerimportrun": "customerImportRun",
        "customerimportsession": "customerImportSession",
        "customfielddefinition": "customFieldDefinition",
        "custompermissiondefinition": "customPermissionDefinition",
        "databreach": "dataBreach",
        "datadisposalmethod": "dataDisposalMethod",
        "dataprocessingagreement": "dataProcessingAgreement",
        "datasource": "dataSource",
        "datasubjectrequest": "dataSubjectRequest",
        "deadletterevent": "deadLetterEvent",
        "delegation": "delegation",
        "deliveryreceipt": "deliveryReceipt",
        "detailedreportarchive": "detailedReportArchive",
        "detailedreportjob": "detailedReportJob",
        "detailedreportnarrative": "detailedReportNarrative",
        "detailedreportprofile": "detailedReportProfile",
        "detailedreportsnapshot": "detailedReportSnapshot",
        "disposalrecord": "disposalRecord",
        "disposalrun": "disposalRun",
        "document": "document",
        "documentrevision": "documentRevision",
        "documenttype": "documentType",
        "dpiaassessment": "dpiaAssessment",
        "dpiatemplate": "dpiaTemplate",
        "dutydefinition": "dutyDefinition",
        "entityformlayout": "entityFormLayout",
        "entityupdatedraft": "entityUpdateDraft",
        "evidencebundle": "evidenceBundle",
        "exercise": "exercise",
        "exerciseevaluation": "exerciseEvaluation",
        "exerciseparticipant": "exerciseParticipant",
        "exerciserecoveryactivity": "exerciseRecoveryActivity",
        "explicitconsent": "explicitConsent",
        "explicitconsentmethod": "explicitConsentMethod",
        "explicitconsentreason": "explicitConsentReason",
        "exportjob": "exportJob",
        "formsubmission": "formSubmission",
        "formtask": "formTask",
        "formtemplate": "formTemplate",
        "gap": "gap",
        "generatedreport": "generatedReport",
        "governancereportdefinition": "governanceReportDefinition",
        "incident": "incident",
        "incidentcomment": "incidentComment",
        "incidenttemplate": "incidentTemplate",
        "integrationconnection": "integrationConnection",
        "integrationconnector": "integrationConnector",
        "integrationcredentialset": "integrationCredentialSet",
        "integrationendpoint": "integrationEndpoint",
        "integrationexternalidentitylink": "integrationExternalIdentityLink",
        "integrationinvocation": "integrationInvocation",
        "integrationmapping": "integrationMapping",
        "integrationproviderdefinition": "integrationProviderDefinition",
        "integrationsyncstate": "integrationSyncState",
        "integrationtransferitem": "integrationTransferItem",
        "integrationtransferrun": "integrationTransferRun",
        "integrationwebhookreceipt": "integrationWebhookReceipt",
        "interestedparty": "interestedParty",
        "internationaltransfer": "internationalTransfer",
        "kpi": "kpi",
        "kvkkcompany": "kvkkCompany",
        "ldaprolemapping": "ldapRoleMapping",
        "legalreason": "legalReason",
        "lessonlearned": "lessonLearned",
        "mailtemplate": "mailTemplate",
        "matrixconfiguration": "matrixConfiguration",
        "meeting": "meeting",
        "notification": "notification",
        "notificationdeliveryintent": "notificationDeliveryIntent",
        "notificationdigestitem": "notificationDigestItem",
        "notificationdispatch": "notificationDispatch",
        "notificationpolicy": "notificationPolicy",
        "notificationpolicyrevision": "notificationPolicyRevision",
        "notificationpolicyverification": "notificationPolicyVerification",
        "notificationpreference": "notificationPreference",
        "notificationtemplate": "notificationTemplate",
        "objective": "objective",
        "operationalrun": "operationalRun",
        "operationalruntask": "operationalRunTask",
        "operationalruntaskevidence": "operationalRunTaskEvidence",
        "operationalrunupdate": "operationalRunUpdate",
        "outboxevent": "outboxEvent",
        "partyinstance": "partyInstance",
        "partytemplate": "partyTemplate",
        "patchnote": "patchNote",
        "personaldatacategory": "personalDataCategory",
        "personaldatainventory": "personalDataInventory",
        "privacynotice": "privacyNotice",
        "privacyprinciple": "privacyPrinciple",
        "problem": "problem",
        "problemcandidate": "problemCandidate",
        "process": "process",
        "processingpurpose": "processingPurpose",
        "recipientgroup": "recipientGroup",
        "recoveryresources": "recoveryResources",
        "regulatoryclause": "regulatoryClause",
        "regulatorysource": "regulatorySource",
        "reportarchive": "reportArchive",
        "reportartifact": "reportArtifact",
        "reportbranding": "reportBranding",
        "reportbrandingrevision": "reportBrandingRevision",
        "reportconfidentialityclass": "reportConfidentialityClass",
        "retentionperiod": "retentionPeriod",
        "risk": "risk",
        "riskanalysis": "riskAnalysis",
        "riskconsequence": "riskConsequence",
        "riskmitigationdefinition": "riskMitigationDefinition",
        "riskregister": "riskRegister",
        "riskreports": "riskReports",
        "role": "role",
        "rootcause": "rootCause",
        "scenariotimeline": "scenarioTimeline",
        "scfassessmentobjective": "scfAssessmentObjective",
        "scfauthoritativesource": "scfAuthoritativeSource",
        "scfcontrol": "scfControl",
        "scfdomain": "scfDomain",
        "scfevidencerequest": "scfEvidenceRequest",
        "scfrisk": "scfRisk",
        "scfthreat": "scfThreat",
        "scopedocument": "scopeDocument",
        "securitymeasure": "securityMeasure",
        "seedtombstone": "seedTombstone",
        "servicecatalogitem": "serviceCatalogItem",
        "strategicinitiative": "strategicInitiative",
        "subjectpersongroup": "subjectPersonGroup",
        "surveydispatch": "surveyDispatch",
        "systemlog": "systemLog",
        "systemseed": "systemSeed",
        "systemseedrun": "systemSeedRun",
        "team": "team",
        "teamassignment": "teamAssignment",
        "teamdutyprofile": "teamDutyProfile",
        "tenant": "tenant",
        "tenantbranding": "tenantBranding",
        "tenantbusinesshours": "tenantBusinessHours",
        "tenantcomplianceconfig": "tenantComplianceConfig",
        "tenantconnectionconfig": "tenantConnectionConfig",
        "tenantcontrolevaluation": "tenantControlEvaluation",
        "tenantcontrolscopepreference": "tenantControlScopePreference",
        "tenantdirectoryconfig": "tenantDirectoryConfig",
        "tenantfeatureflag": "tenantFeatureFlag",
        "tenantholiday": "tenantHoliday",
        "tenantmfasettings": "tenantMfaSettings",
        "threat": "threat",
        "ticket": "ticket",
        "ticketcategory": "ticketCategory",
        "ticketcomment": "ticketComment",
        "ticketconfig": "ticketConfig",
        "ticketnumbersequence": "ticketNumberSequence",
        "ticketrecurrence": "ticketRecurrence",
        "ticketsla": "ticketSLA",
        "ticketsubtaskcomment": "ticketSubtaskComment",
        "tickettemplate": "ticketTemplate",
        "training": "training",
        "transfertype": "transferType",
        "unit": "unit",
        "user": "user",
        "usernavigationpreference": "userNavigationPreference",
        "userpagelayout": "userPageLayout",
        "usertraining": "userTraining",
        "vendor": "vendor",
        "vendorassessment": "vendorAssessment",
        "vulnerability": "vulnerability",
        "weakness": "weakness",
        "webhookdelivery": "webhookDelivery",
        "webhooksubscription": "webhookSubscription",
        "workflowinformedreceipt": "workflowInformedReceipt",
        "workflowinstance": "workflowInstance",
        "workflowscheduledtrigger": "workflowScheduledTrigger",
        "workflowtask": "workflowTask",
        "workflowtemplate": "workflowTemplate"
    },
    "catalog": {
        "accessLog": {
            "contentLength": {
                "kind": "number"
            },
            "durationMs": {
                "kind": "number"
            },
            "ip": {
                "kind": "text"
            },
            "method": {
                "kind": "text"
            },
            "path": {
                "kind": "text"
            },
            "requestId": {
                "kind": "text"
            },
            "sessionId": {
                "kind": "text"
            },
            "statusCode": {
                "kind": "number"
            },
            "userAgent": {
                "kind": "text"
            },
            "userId": {
                "kind": "ref",
                "refEntity": "user"
            }
        },
        "action": {
            "actionType": {
                "kind": "enum",
                "values": [
                    "risk_treatment",
                    "corrective",
                    "preventive",
                    "improvement"
                ]
            },
            "assignmentTemplate": {
                "kind": "ref",
                "refEntity": "assignmentTemplate"
            },
            "budget": {
                "kind": "number"
            },
            "budgetStatus": {
                "kind": "enum",
                "values": [
                    "not budgeted for",
                    "budget approved",
                    "no budget required"
                ]
            },
            "currency": {
                "kind": "enum",
                "values": [
                    "TRY",
                    "USD",
                    "EUR",
                    "GBP"
                ]
            },
            "deadline": {
                "kind": "date"
            },
            "description": {
                "kind": "text"
            },
            "effectivenessVerification": {
                "kind": "text"
            },
            "executionStatus": {
                "kind": "enum",
                "values": [
                    "not_started",
                    "opened",
                    "in_progress",
                    "resolved",
                    "verified",
                    "closed"
                ]
            },
            "executionTicket": {
                "kind": "ref",
                "refEntity": "ticket"
            },
            "improvementObjective": {
                "kind": "text"
            },
            "partyInstanceId": {
                "kind": "ref",
                "refEntity": "partyInstance"
            },
            "pdcaStatus": {
                "kind": "enum",
                "values": [
                    "plan",
                    "do",
                    "check",
                    "act",
                    "closed"
                ]
            },
            "plan": {
                "kind": "text"
            },
            "preventiveRationale": {
                "kind": "text"
            },
            "progress": {
                "kind": "number"
            },
            "requiresExecution": {
                "kind": "boolean"
            },
            "rootCause": {
                "kind": "text"
            },
            "rootCauseAnalysis": {
                "kind": "text"
            },
            "rootCauseMethod": {
                "kind": "text"
            },
            "rootCauseReasons": {
                "kind": "json"
            },
            "sourceId": {
                "kind": "text"
            },
            "sourceTitle": {
                "kind": "text"
            },
            "sourceType": {
                "kind": "text"
            },
            "startDate": {
                "kind": "date"
            },
            "status": {
                "kind": "enum",
                "values": [
                    "Pending",
                    "In Progress",
                    "Completed",
                    "Delayed"
                ]
            },
            "strategy": {
                "kind": "enum",
                "values": [
                    "Mitigation",
                    "Avoidance",
                    "Transfer",
                    "Acceptance"
                ]
            },
            "title": {
                "kind": "text"
            },
            "unit": {
                "kind": "ref",
                "refEntity": "unit"
            },
            "verifiedBy": {
                "kind": "ref",
                "refEntity": "user"
            },
            "verifiedDate": {
                "kind": "date"
            }
        },
        "applicationMethod": {
            "address": {
                "kind": "text"
            },
            "description": {
                "kind": "text"
            },
            "information": {
                "kind": "text"
            },
            "metadata": {
                "kind": "json"
            },
            "method": {
                "kind": "text"
            },
            "name": {
                "kind": "text"
            },
            "status": {
                "kind": "enum",
                "values": [
                    "active",
                    "inactive"
                ]
            }
        },
        "applicationRequestInformation": {
            "description": {
                "kind": "text"
            },
            "legalBasis": {
                "kind": "text"
            },
            "metadata": {
                "kind": "json"
            },
            "name": {
                "kind": "text"
            },
            "requestSubject": {
                "kind": "text"
            },
            "status": {
                "kind": "enum",
                "values": [
                    "active",
                    "inactive"
                ]
            }
        },
        "applicationTracking": {
            "applicationDate": {
                "kind": "date"
            },
            "applicationDocuments": {
                "kind": "json"
            },
            "applicationMethod": {
                "kind": "text"
            },
            "applicationRequest": {
                "kind": "text"
            },
            "capAddress": {
                "kind": "text"
            },
            "email": {
                "kind": "text"
            },
            "faxNo": {
                "kind": "text"
            },
            "identityNumber": {
                "kind": "text"
            },
            "legalRepresentativeIdentity": {
                "kind": "text"
            },
            "legalRepresentativeName": {
                "kind": "text"
            },
            "metadata": {
                "kind": "json"
            },
            "nameSurname": {
                "kind": "text"
            },
            "nationality": {
                "kind": "text"
            },
            "phoneNumber": {
                "kind": "text"
            },
            "relationshipExplanation": {
                "kind": "text"
            },
            "relationshipWithOrganisation": {
                "kind": "text"
            },
            "requestDescription": {
                "kind": "text"
            },
            "residentialAddress": {
                "kind": "text"
            },
            "status": {
                "kind": "enum",
                "values": [
                    "active",
                    "inactive"
                ]
            }
        },
        "assessment": {
            "criteria": {
                "kind": "json"
            },
            "description": {
                "kind": "text"
            },
            "endDate": {
                "kind": "text"
            },
            "executiveSummary": {
                "kind": "text"
            },
            "overallRating": {
                "kind": "text"
            },
            "overallScore": {
                "kind": "number"
            },
            "periodMonths": {
                "kind": "number"
            },
            "periodType": {
                "kind": "enum",
                "values": [
                    "Once",
                    "Periodic"
                ]
            },
            "purpose": {
                "kind": "text"
            },
            "sharedAuditorControlAnswers": {
                "kind": "json"
            },
            "sharedDocuments": {
                "kind": "json"
            },
            "startDate": {
                "kind": "text"
            },
            "status": {
                "kind": "enum",
                "values": [
                    "Planned",
                    "In Progress",
                    "Completed",
                    "Cancelled"
                ]
            },
            "teamLeader": {
                "kind": "ref",
                "refEntity": "user"
            },
            "teamMembers": {
                "kind": "json"
            },
            "title": {
                "kind": "text"
            },
            "units": {
                "kind": "json"
            },
            "workPlan": {
                "kind": "json"
            }
        },
        "assessmentQuestion": {
            "code": {
                "kind": "text"
            },
            "description": {
                "kind": "text"
            },
            "name": {
                "kind": "text"
            },
            "questions": {
                "kind": "json"
            },
            "status": {
                "kind": "enum",
                "values": [
                    "active",
                    "inactive"
                ]
            }
        },
        "asset": {
            "accessConstraints": {
                "kind": "text"
            },
            "accessLevel": {
                "kind": "text"
            },
            "accuracy": {
                "kind": "text"
            },
            "acquisitionDate": {
                "kind": "date"
            },
            "address": {
                "kind": "text"
            },
            "alternateSiteAvailable": {
                "kind": "boolean"
            },
            "alternativeVendor": {
                "kind": "text"
            },
            "amount": {
                "kind": "number"
            },
            "appDependencies": {
                "kind": "text"
            },
            "appVendor": {
                "kind": "text"
            },
            "assetCategory": {
                "kind": "ref",
                "refEntity": "assetCategory"
            },
            "assetGroup": {
                "kind": "ref",
                "refEntity": "assetGroup"
            },
            "assetId": {
                "kind": "text"
            },
            "assetName": {
                "kind": "text"
            },
            "authMethod": {
                "kind": "text"
            },
            "availabilityValue": {
                "kind": "number"
            },
            "backupFrequency": {
                "kind": "text"
            },
            "bcps": {
                "kind": "json"
            },
            "bias": {
                "kind": "json"
            },
            "brand": {
                "kind": "text"
            },
            "businessImpact": {
                "kind": "text"
            },
            "capacity": {
                "kind": "text"
            },
            "category": {
                "kind": "ref",
                "refEntity": "assetCategory"
            },
            "classificationLevel": {
                "kind": "text"
            },
            "company": {
                "kind": "text"
            },
            "confidentialityValue": {
                "kind": "number"
            },
            "connectivityDetails": {
                "kind": "text"
            },
            "contactPerson": {
                "kind": "text"
            },
            "containsPersonalData": {
                "kind": "boolean"
            },
            "contractDate": {
                "kind": "text"
            },
            "contractExpiryDate": {
                "kind": "text"
            },
            "country": {
                "kind": "text"
            },
            "crisisEvents": {
                "kind": "json"
            },
            "criticalDependencies": {
                "kind": "text"
            },
            "criticality": {
                "kind": "text"
            },
            "criticalityToOperation": {
                "kind": "text"
            },
            "currency": {
                "kind": "text"
            },
            "currentValue": {
                "kind": "number"
            },
            "custodian": {
                "kind": "ref",
                "refEntity": "user"
            },
            "dataClassification": {
                "kind": "text"
            },
            "definition": {
                "kind": "text"
            },
            "dependencies": {
                "kind": "text"
            },
            "dependentBeing": {
                "kind": "boolean"
            },
            "depreciation": {
                "kind": "number"
            },
            "detail": {
                "kind": "text"
            },
            "disposalCertificateId": {
                "kind": "text"
            },
            "disposalDate": {
                "kind": "date"
            },
            "disposalMethod": {
                "kind": "text"
            },
            "drStrategy": {
                "kind": "text"
            },
            "encryption": {
                "kind": "json"
            },
            "expectedLifespan": {
                "kind": "number"
            },
            "firmwareVersion": {
                "kind": "text"
            },
            "format": {
                "kind": "text"
            },
            "hostName": {
                "kind": "text"
            },
            "hostingEnvironment": {
                "kind": "text"
            },
            "image": {
                "kind": "text"
            },
            "impact": {
                "kind": "text"
            },
            "institutionApproval": {
                "kind": "boolean"
            },
            "integrityValue": {
                "kind": "number"
            },
            "ipAddress": {
                "kind": "text"
            },
            "lastDrTestDate": {
                "kind": "text"
            },
            "lastReviewedAt": {
                "kind": "date"
            },
            "licenseCount": {
                "kind": "number"
            },
            "licenseKey": {
                "kind": "text"
            },
            "licenseType": {
                "kind": "text"
            },
            "location": {
                "kind": "json"
            },
            "macAddress": {
                "kind": "text"
            },
            "maintenanceScope": {
                "kind": "text"
            },
            "maintenanceWindow": {
                "kind": "text"
            },
            "manualWorkarounds": {
                "kind": "text"
            },
            "model": {
                "kind": "text"
            },
            "modelType": {
                "kind": "text"
            },
            "mtpd": {
                "kind": "text"
            },
            "nextReviewAt": {
                "kind": "date"
            },
            "owner": {
                "kind": "ref",
                "refEntity": "user"
            },
            "partyInstanceId": {
                "kind": "ref",
                "refEntity": "partyInstance"
            },
            "peakPeriods": {
                "kind": "text"
            },
            "pendingOperation": {
                "kind": "json"
            },
            "personalDataDescription": {
                "kind": "text"
            },
            "personnelRole": {
                "kind": "text"
            },
            "physicalLocation": {
                "kind": "text"
            },
            "physicalSecurityControls": {
                "kind": "text"
            },
            "powerRequirement": {
                "kind": "text"
            },
            "processOwner": {
                "kind": "text"
            },
            "processes": {
                "kind": "json"
            },
            "purchaseDate": {
                "kind": "date"
            },
            "purchasePrice": {
                "kind": "number"
            },
            "raidLevel": {
                "kind": "text"
            },
            "redundanceLevel": {
                "kind": "text"
            },
            "relatedControls": {
                "kind": "json"
            },
            "relatedRiskLinks": {
                "kind": "json"
            },
            "relatedRisks": {
                "kind": "json"
            },
            "relatedThreats": {
                "kind": "json"
            },
            "relatedVulnerabilities": {
                "kind": "json"
            },
            "relationships": {
                "kind": "json"
            },
            "remoteWorkCapability": {
                "kind": "boolean"
            },
            "requiredResources": {
                "kind": "text"
            },
            "retentionPeriod": {
                "kind": "text"
            },
            "reviewFrequency": {
                "kind": "enum",
                "values": [
                    "none",
                    "monthly",
                    "quarterly",
                    "semi-annual",
                    "annual",
                    "biennial"
                ]
            },
            "rpo": {
                "kind": "text"
            },
            "rto": {
                "kind": "text"
            },
            "runtimeEnvironment": {
                "kind": "text"
            },
            "schedule": {
                "kind": "text"
            },
            "serialNo": {
                "kind": "text"
            },
            "shiftPattern": {
                "kind": "text"
            },
            "sla": {
                "kind": "text"
            },
            "slaRef": {
                "kind": "ref",
                "refEntity": "ticketSLA"
            },
            "storageCapacity": {
                "kind": "text"
            },
            "storageLocation": {
                "kind": "text"
            },
            "storageMedia": {
                "kind": "text"
            },
            "storageType": {
                "kind": "text"
            },
            "successorPerson": {
                "kind": "text"
            },
            "supportEndDate": {
                "kind": "date"
            },
            "supportStartDate": {
                "kind": "date"
            },
            "supportedVendor": {
                "kind": "text"
            },
            "trainingData": {
                "kind": "text"
            },
            "trigger": {
                "kind": "text"
            },
            "unit": {
                "kind": "ref",
                "refEntity": "unit"
            },
            "usingStatus": {
                "kind": "boolean"
            },
            "utilityFeeds": {
                "kind": "text"
            },
            "utilityRedundancy": {
                "kind": "text"
            },
            "vCpu": {
                "kind": "text"
            },
            "vRam": {
                "kind": "text"
            },
            "version": {
                "kind": "text"
            },
            "vitalRecord": {
                "kind": "boolean"
            },
            "workflowApprovalStatus": {
                "kind": "enum",
                "values": [
                    "none",
                    "pending_create",
                    "approved",
                    "rejected"
                ]
            },
            "workflowTemplateId": {
                "kind": "ref",
                "refEntity": "workflowTemplate"
            }
        },
        "assetCategory": {
            "assetGroupId": {
                "kind": "ref",
                "refEntity": "assetGroup"
            },
            "availabilityValue": {
                "kind": "number"
            },
            "categoryOwners": {
                "kind": "json"
            },
            "code": {
                "kind": "text"
            },
            "color": {
                "kind": "text"
            },
            "confidentialityValue": {
                "kind": "number"
            },
            "description": {
                "kind": "text"
            },
            "icon": {
                "kind": "text"
            },
            "integrityValue": {
                "kind": "number"
            },
            "name": {
                "kind": "text"
            },
            "parentCategory": {
                "kind": "ref",
                "refEntity": "assetCategory"
            },
            "status": {
                "kind": "enum",
                "values": [
                    "active",
                    "inactive"
                ]
            }
        },
        "assetDisposal": {
            "certificateDocumentId": {
                "kind": "ref",
                "refEntity": "document"
            },
            "certificateId": {
                "kind": "text"
            },
            "completedAt": {
                "kind": "date"
            },
            "destructionMethod": {
                "kind": "text"
            },
            "kind": {
                "kind": "enum",
                "values": [
                    "decommission",
                    "destruction",
                    "transfer",
                    "recycle"
                ]
            },
            "linkedAssets": {
                "kind": "json"
            },
            "notes": {
                "kind": "text"
            },
            "plannedDate": {
                "kind": "date"
            },
            "responsibleUser": {
                "kind": "ref",
                "refEntity": "user"
            },
            "status": {
                "kind": "enum",
                "values": [
                    "planned",
                    "inProgress",
                    "completed",
                    "certified"
                ]
            },
            "title": {
                "kind": "text"
            }
        },
        "assetGroup": {
            "assetType": {
                "kind": "enum",
                "values": [
                    "hardware",
                    "software",
                    "service",
                    "data",
                    "personnel",
                    "facility"
                ]
            },
            "category": {
                "kind": "text"
            },
            "categoryIndex": {
                "kind": "text"
            },
            "code": {
                "kind": "text"
            },
            "criticalityLevel": {
                "kind": "enum",
                "values": [
                    "low",
                    "medium",
                    "high",
                    "critical"
                ]
            },
            "defaultClassification": {
                "kind": "enum",
                "values": [
                    "TASNİF DIŞI",
                    "HİZMETE ÖZEL",
                    "ÖZEL",
                    "KISITLI",
                    "GİZLİ",
                    "ÇOK GİZLİ",
                    "UNCLASSIFIED",
                    "INTERNAL USE",
                    "SENSITIVE",
                    "RESTRICTED",
                    "CONFIDENTIAL",
                    "TOP SECRET"
                ]
            },
            "description": {
                "kind": "text"
            },
            "name": {
                "kind": "text"
            },
            "status": {
                "kind": "enum",
                "values": [
                    "active",
                    "inactive"
                ]
            }
        },
        "assetGroupCriticalityEvaluation": {
            "approval": {
                "kind": "json"
            },
            "assetGroup": {
                "kind": "ref",
                "refEntity": "assetGroup"
            },
            "currentSurvey": {
                "kind": "json"
            },
            "expertUserIds": {
                "kind": "json"
            },
            "restartReason": {
                "kind": "text"
            },
            "status": {
                "kind": "enum",
                "values": [
                    "undefined",
                    "passive",
                    "active",
                    "completed"
                ]
            },
            "surveyRepeatCount": {
                "kind": "number"
            }
        },
        "assetGroupCriticalitySurveyResponse": {
            "answerExplanations": {
                "kind": "json"
            },
            "answers": {
                "kind": "json"
            },
            "assetGroup": {
                "kind": "ref",
                "refEntity": "assetGroup"
            },
            "completedAt": {
                "kind": "date"
            },
            "criticalityDegree": {
                "kind": "number"
            },
            "evaluation": {
                "kind": "ref",
                "refEntity": "assetGroupCriticalityEvaluation"
            },
            "questionScores": {
                "kind": "json"
            },
            "surveyRoundNumber": {
                "kind": "number"
            },
            "totalScore": {
                "kind": "number"
            },
            "user": {
                "kind": "ref",
                "refEntity": "user"
            }
        },
        "assetGroupMeasureApplicability": {
            "applicability": {
                "kind": "json"
            },
            "assetGroup": {
                "kind": "ref",
                "refEntity": "assetGroup"
            },
            "criticalityDegree": {
                "kind": "number"
            },
            "evaluation": {
                "kind": "ref",
                "refEntity": "assetGroupCriticalityEvaluation"
            }
        },
        "assetGroupMeasureEvaluation": {
            "compensatoryControlIds": {
                "kind": "json"
            },
            "currentSituationAnalysis": {
                "kind": "json"
            },
            "currentSituationEvaluation": {
                "kind": "json"
            },
            "measure": {
                "kind": "ref",
                "refEntity": "bigdesMeasure"
            },
            "measureApplicability": {
                "kind": "ref",
                "refEntity": "assetGroupMeasureApplicability"
            },
            "roadMapWorkPackageIds": {
                "kind": "json"
            }
        },
        "assetLicense": {
            "autoRenew": {
                "kind": "boolean"
            },
            "billingCycle": {
                "kind": "text"
            },
            "cost": {
                "kind": "number"
            },
            "currency": {
                "kind": "text"
            },
            "endDate": {
                "kind": "date"
            },
            "licenseKey": {
                "kind": "text"
            },
            "licenseType": {
                "kind": "text"
            },
            "linkedAssets": {
                "kind": "json"
            },
            "linkedDocuments": {
                "kind": "json"
            },
            "name": {
                "kind": "text"
            },
            "notes": {
                "kind": "text"
            },
            "ownerUnit": {
                "kind": "ref",
                "refEntity": "unit"
            },
            "poReference": {
                "kind": "text"
            },
            "renewalType": {
                "kind": "enum",
                "values": [
                    "none",
                    "annual",
                    "monthly",
                    "multi_year",
                    "perpetual",
                    "other"
                ]
            },
            "seatCount": {
                "kind": "number"
            },
            "skuOrPartNo": {
                "kind": "text"
            },
            "startDate": {
                "kind": "date"
            },
            "status": {
                "kind": "enum",
                "values": [
                    "active",
                    "inactive",
                    "archived"
                ]
            },
            "vendor": {
                "kind": "text"
            }
        },
        "assetLifecycleEvent": {
            "assetIds": {
                "kind": "json"
            },
            "errorMessage": {
                "kind": "text"
            },
            "eventType": {
                "kind": "enum",
                "values": [
                    "license_expiry_reminder",
                    "disposal_planned_reminder",
                    "license_linked",
                    "license_unlinked",
                    "disposal_linked",
                    "disposal_unlinked",
                    "disposal_status_change",
                    "support_end_reminder",
                    "vendor_contract_expiry_reminder",
                    "vendor_assessment_review_reminder"
                ]
            },
            "idempotencyKey": {
                "kind": "text"
            },
            "metadata": {
                "kind": "json"
            },
            "processedAt": {
                "kind": "date"
            },
            "scheduledFor": {
                "kind": "date"
            },
            "sourceId": {
                "kind": "ref"
            },
            "sourceType": {
                "kind": "enum",
                "values": [
                    "license",
                    "disposal",
                    "asset",
                    "vendor",
                    "vendor-assessment",
                    "system"
                ]
            },
            "status": {
                "kind": "enum",
                "values": [
                    "scheduled",
                    "pending",
                    "processed",
                    "cancelled",
                    "failed"
                ]
            }
        },
        "assetNumberSequence": {
            "seq": {
                "kind": "number"
            }
        },
        "assignmentTemplate": {
            "audienceMembers": {
                "kind": "json"
            },
            "code": {
                "kind": "text"
            },
            "contextKey": {
                "kind": "text"
            },
            "description": {
                "kind": "text"
            },
            "isActive": {
                "kind": "boolean"
            },
            "name": {
                "kind": "text"
            },
            "steps": {
                "kind": "json"
            },
            "usageProfile": {
                "kind": "enum",
                "values": [
                    "approval-chain",
                    "audience",
                    "hybrid"
                ]
            }
        },
        "auditAssignment": {
            "assessment": {
                "kind": "ref",
                "refEntity": "assessment"
            },
            "auditor": {
                "kind": "ref",
                "refEntity": "user"
            },
            "controlIds": {
                "kind": "json"
            },
            "questionDocumentIds": {
                "kind": "json"
            },
            "role": {
                "kind": "enum",
                "values": [
                    "lead",
                    "member",
                    "observer"
                ]
            },
            "status": {
                "kind": "enum",
                "values": [
                    "assigned",
                    "accepted",
                    "in-progress",
                    "completed"
                ]
            },
            "submissions": {
                "kind": "json"
            }
        },
        "auditFinding": {
            "actualClosureDate": {
                "kind": "date"
            },
            "assessment": {
                "kind": "ref",
                "refEntity": "assessment"
            },
            "attachments": {
                "kind": "json"
            },
            "clause": {
                "kind": "text"
            },
            "control": {
                "kind": "ref",
                "refEntity": "scfControl"
            },
            "correctiveAction": {
                "kind": "ref",
                "refEntity": "action"
            },
            "description": {
                "kind": "text"
            },
            "evidence": {
                "kind": "text"
            },
            "partyInstanceId": {
                "kind": "ref",
                "refEntity": "partyInstance"
            },
            "referenceNumber": {
                "kind": "text"
            },
            "responsiblePerson": {
                "kind": "ref",
                "refEntity": "user"
            },
            "responsibleUnit": {
                "kind": "ref",
                "refEntity": "unit"
            },
            "rootCause": {
                "kind": "text"
            },
            "status": {
                "kind": "enum",
                "values": [
                    "open",
                    "action-planned",
                    "in-progress",
                    "pending-verification",
                    "closed"
                ]
            },
            "targetClosureDate": {
                "kind": "date"
            },
            "title": {
                "kind": "text"
            },
            "type": {
                "kind": "enum",
                "values": [
                    "nonconformity_major",
                    "nonconformity_minor",
                    "observation",
                    "opportunity"
                ]
            },
            "verificationNotes": {
                "kind": "text"
            },
            "verifiedAt": {
                "kind": "date"
            },
            "verifiedBy": {
                "kind": "ref",
                "refEntity": "user"
            }
        },
        "auditPlan": {
            "approvedAt": {
                "kind": "date"
            },
            "approvedBy": {
                "kind": "ref",
                "refEntity": "user"
            },
            "audits": {
                "kind": "json"
            },
            "description": {
                "kind": "text"
            },
            "status": {
                "kind": "enum",
                "values": [
                    "draft",
                    "approved",
                    "active",
                    "completed"
                ]
            },
            "title": {
                "kind": "text"
            },
            "year": {
                "kind": "number"
            }
        },
        "bcmInitialResponseLibrary": {
            "action": {
                "kind": "text"
            },
            "description": {
                "kind": "text"
            },
            "details": {
                "kind": "text"
            },
            "include": {
                "kind": "boolean"
            },
            "metadata": {
                "kind": "json"
            },
            "name": {
                "kind": "text"
            },
            "responsible": {
                "kind": "text"
            },
            "status": {
                "kind": "enum",
                "values": [
                    "active",
                    "inactive"
                ]
            },
            "step": {
                "kind": "text"
            },
            "timeframe": {
                "kind": "text"
            }
        },
        "bcmRpo": {
            "description": {
                "kind": "text"
            },
            "metadata": {
                "kind": "json"
            },
            "name": {
                "kind": "text"
            },
            "status": {
                "kind": "enum",
                "values": [
                    "active",
                    "inactive"
                ]
            }
        },
        "bcmSettings": {
            "code": {
                "kind": "text"
            },
            "config": {
                "kind": "json"
            },
            "description": {
                "kind": "text"
            },
            "name": {
                "kind": "text"
            },
            "status": {
                "kind": "enum",
                "values": [
                    "active",
                    "inactive"
                ]
            }
        },
        "bcp": {
            "activatedCrisisEvents": {
                "kind": "json"
            },
            "activationCriteria": {
                "kind": "text"
            },
            "activationProcedure": {
                "kind": "text"
            },
            "alternateLocation": {
                "kind": "json"
            },
            "assets": {
                "kind": "json"
            },
            "bias": {
                "kind": "json"
            },
            "code": {
                "kind": "text"
            },
            "communicationPlans": {
                "kind": "json"
            },
            "communications": {
                "kind": "json"
            },
            "daysForNextReview": {
                "kind": "number"
            },
            "deactivationProcedure": {
                "kind": "text"
            },
            "description": {
                "kind": "text"
            },
            "documents": {
                "kind": "json"
            },
            "exercises": {
                "kind": "json"
            },
            "initialResponse": {
                "kind": "json"
            },
            "initialResponseComments": {
                "kind": "json"
            },
            "introItems": {
                "kind": "json"
            },
            "isPeriodic": {
                "kind": "boolean"
            },
            "lastExerciseAt": {
                "kind": "date"
            },
            "lastExerciseId": {
                "kind": "ref",
                "refEntity": "exercise"
            },
            "lastExerciseScore": {
                "kind": "number"
            },
            "lastExerciseSummary": {
                "kind": "text"
            },
            "location": {
                "kind": "json"
            },
            "locations": {
                "kind": "json"
            },
            "name": {
                "kind": "text"
            },
            "nextReview": {
                "kind": "date"
            },
            "partyInstanceId": {
                "kind": "ref",
                "refEntity": "partyInstance"
            },
            "phases": {
                "kind": "json"
            },
            "process": {
                "kind": "ref",
                "refEntity": "process"
            },
            "processes": {
                "kind": "json"
            },
            "requiredResources": {
                "kind": "json"
            },
            "reviewPeriod": {
                "kind": "number"
            },
            "reviewUnit": {
                "kind": "enum",
                "values": [
                    "Days",
                    "Weeks",
                    "Months",
                    "Years"
                ]
            },
            "state": {
                "kind": "enum",
                "values": [
                    "Draft",
                    "Under Review",
                    "Pending Approval",
                    "Approved",
                    "Rejected"
                ]
            },
            "status": {
                "kind": "enum",
                "values": [
                    "active",
                    "inactive",
                    "archived"
                ]
            },
            "teams": {
                "kind": "json"
            },
            "unit": {
                "kind": "text"
            },
            "unitId": {
                "kind": "ref",
                "refEntity": "unit"
            },
            "vendors": {
                "kind": "json"
            }
        },
        "bcpLocation": {
            "asset": {
                "kind": "ref",
                "refEntity": "asset"
            },
            "category": {
                "kind": "enum",
                "values": [
                    "BAU",
                    "Recovery"
                ]
            },
            "remarks": {
                "kind": "text"
            }
        },
        "bia": {
            "assets": {
                "kind": "json"
            },
            "biaId": {
                "kind": "text"
            },
            "category": {
                "kind": "text"
            },
            "continuityRecoveryNotes": {
                "kind": "text"
            },
            "crisisEvents": {
                "kind": "json"
            },
            "criticality": {
                "kind": "text"
            },
            "currency": {
                "kind": "enum",
                "values": [
                    "TRY",
                    "USD",
                    "EUR",
                    "GBP"
                ]
            },
            "description": {
                "kind": "text"
            },
            "documents": {
                "kind": "json"
            },
            "downtimeCost": {
                "kind": "text"
            },
            "employees": {
                "kind": "json"
            },
            "impactAssessment": {
                "kind": "json"
            },
            "impactStatusAverage": {
                "kind": "number"
            },
            "lastReviewDate": {
                "kind": "text"
            },
            "location": {
                "kind": "json"
            },
            "minimumServiceLevel": {
                "kind": "text"
            },
            "mtpd": {
                "kind": "text"
            },
            "name": {
                "kind": "text"
            },
            "nextReview": {
                "kind": "text"
            },
            "partyInstanceId": {
                "kind": "ref",
                "refEntity": "partyInstance"
            },
            "process": {
                "kind": "ref",
                "refEntity": "process"
            },
            "processes": {
                "kind": "json"
            },
            "recoveryResources": {
                "kind": "json"
            },
            "relatedBcps": {
                "kind": "json"
            },
            "relatedRisks": {
                "kind": "json"
            },
            "rpo": {
                "kind": "text"
            },
            "rpoCalculations": {
                "kind": "json"
            },
            "rpoRecommendations": {
                "kind": "json"
            },
            "rto": {
                "kind": "text"
            },
            "state": {
                "kind": "enum",
                "values": [
                    "Draft",
                    "Under Review",
                    "Pending Approval",
                    "Approved"
                ]
            },
            "status": {
                "kind": "enum",
                "values": [
                    "very_low",
                    "low",
                    "medium",
                    "high",
                    "critical"
                ]
            },
            "unit": {
                "kind": "ref",
                "refEntity": "unit"
            },
            "vendors": {
                "kind": "json"
            }
        },
        "biaImpactConfiguration": {
            "calculationModel": {
                "kind": "enum",
                "values": [
                    "SIMPLE_AVERAGE",
                    "WEIGHTED_AVERAGE",
                    "SINGLE_THRESHOLD"
                ]
            },
            "categories": {
                "kind": "json"
            },
            "isCustomized": {
                "kind": "boolean"
            },
            "mtpdThreshold": {
                "kind": "number"
            },
            "rpoThreshold": {
                "kind": "number"
            },
            "rtoThreshold": {
                "kind": "number"
            },
            "timeHorizons": {
                "kind": "json"
            }
        },
        "biaRpoCalculation": {
            "application": {
                "kind": "text"
            },
            "avgTransHr": {
                "kind": "text"
            },
            "backupFreq": {
                "kind": "text"
            },
            "maxAllowableLoss": {
                "kind": "text"
            },
            "restoreTime": {
                "kind": "text"
            },
            "rpo": {
                "kind": "text"
            },
            "transLoss": {
                "kind": "text"
            },
            "transLossCount": {
                "kind": "text"
            },
            "transaction": {
                "kind": "text"
            },
            "type": {
                "kind": "text"
            }
        },
        "biaRpoRecommendation": {
            "application": {
                "kind": "text"
            },
            "backupFreq": {
                "kind": "text"
            },
            "recommendedRpo": {
                "kind": "text"
            },
            "remarks": {
                "kind": "text"
            },
            "restoreTime": {
                "kind": "text"
            }
        },
        "bigdesCompensatoryControl": {
            "controlNo": {
                "kind": "text"
            },
            "definition": {
                "kind": "text"
            },
            "implementationRisks": {
                "kind": "text"
            },
            "name": {
                "kind": "text"
            },
            "nature": {
                "kind": "enum",
                "values": [
                    "temporary",
                    "permanent"
                ]
            },
            "nonImplementationReasons": {
                "kind": "text"
            },
            "plannedImplementationInterval": {
                "kind": "text"
            },
            "relatedMeasureArticleNo": {
                "kind": "text"
            },
            "relatedMeasureRequirements": {
                "kind": "text"
            },
            "verificationMethod": {
                "kind": "text"
            }
        },
        "bigdesCurrentSituationEvaluationScope": {
            "applicabilityIds": {
                "kind": "json"
            }
        },
        "bigdesImplementationProcessEvaluation": {
            "auditMethods": {
                "kind": "json"
            },
            "effectivenessStatus": {
                "kind": "enum",
                "values": [
                    "effective",
                    "not_effective",
                    "partially_effective"
                ]
            },
            "questionNo": {
                "kind": "number"
            },
            "workFormNo": {
                "kind": "text"
            }
        },
        "bigdesMeasure": {
            "audit_methods": {
                "kind": "json"
            },
            "audit_questions": {
                "kind": "json"
            },
            "catalog_source": {
                "kind": "text"
            },
            "description": {
                "kind": "text"
            },
            "is_editable": {
                "kind": "boolean"
            },
            "measure_code": {
                "kind": "text"
            },
            "parent_code": {
                "kind": "text"
            },
            "section_code": {
                "kind": "text"
            },
            "tier": {
                "kind": "number"
            },
            "title": {
                "kind": "text"
            }
        },
        "bigdesRoadMapWorkPackage": {
            "activities": {
                "kind": "text"
            },
            "goals": {
                "kind": "json"
            },
            "name": {
                "kind": "text"
            },
            "packageNo": {
                "kind": "text"
            },
            "periodMonths": {
                "kind": "number"
            },
            "targetDurationMonths": {
                "kind": "number"
            }
        },
        "changeRequest": {
            "approvalHistory": {
                "kind": "json"
            },
            "approvalSequentialQueue": {
                "kind": "json"
            },
            "approvalStatus": {
                "kind": "enum",
                "values": [
                    "not_started",
                    "pending",
                    "in_progress",
                    "approved",
                    "rejected",
                    "returned",
                    "cancelled"
                ]
            },
            "assignmentTemplate": {
                "kind": "ref",
                "refEntity": "assignmentTemplate"
            },
            "changeType": {
                "kind": "enum",
                "values": [
                    "standard",
                    "normal",
                    "emergency"
                ]
            },
            "currentApprovalStep": {
                "kind": "number"
            },
            "currentApprovers": {
                "kind": "json"
            },
            "description": {
                "kind": "text"
            },
            "implementationResult": {
                "kind": "text"
            },
            "informedUsers": {
                "kind": "json"
            },
            "partyInstanceId": {
                "kind": "ref",
                "refEntity": "partyInstance"
            },
            "plannedWindowEnd": {
                "kind": "date"
            },
            "plannedWindowStart": {
                "kind": "date"
            },
            "postImplementationReview": {
                "kind": "text"
            },
            "postImplementationReviewAt": {
                "kind": "date"
            },
            "postImplementationReviewBy": {
                "kind": "ref",
                "refEntity": "user"
            },
            "requestedBy": {
                "kind": "ref",
                "refEntity": "user"
            },
            "requestedByUnit": {
                "kind": "ref",
                "refEntity": "unit"
            },
            "riskSummary": {
                "kind": "text"
            },
            "serviceCatalogItem": {
                "kind": "ref",
                "refEntity": "serviceCatalogItem"
            },
            "status": {
                "kind": "enum",
                "values": [
                    "draft",
                    "in_approval",
                    "approved",
                    "implemented",
                    "rejected",
                    "cancelled"
                ]
            },
            "title": {
                "kind": "text"
            },
            "workflowInstanceId": {
                "kind": "ref",
                "refEntity": "workflowInstance"
            }
        },
        "classification": {
            "code": {
                "kind": "text"
            },
            "color": {
                "kind": "text"
            },
            "description": {
                "kind": "text"
            },
            "icon": {
                "kind": "text"
            },
            "level": {
                "kind": "number"
            },
            "name": {
                "kind": "text"
            },
            "restrictions": {
                "kind": "json"
            },
            "status": {
                "kind": "enum",
                "values": [
                    "active",
                    "inactive"
                ]
            }
        },
        "collectionMethod": {
            "description": {
                "kind": "text"
            },
            "metadata": {
                "kind": "json"
            },
            "name": {
                "kind": "text"
            },
            "orderIndex": {
                "kind": "number"
            },
            "parentId": {
                "kind": "ref",
                "refEntity": "collectionMethod"
            },
            "processingCategory": {
                "kind": "enum",
                "values": [
                    "fully_automatic",
                    "partially_automatic",
                    "non_automatic"
                ]
            },
            "status": {
                "kind": "enum",
                "values": [
                    "active",
                    "inactive"
                ]
            },
            "thirdPartySource": {
                "kind": "text"
            }
        },
        "communication": {
            "bcps": {
                "kind": "json"
            },
            "category": {
                "kind": "text"
            },
            "contactSubject": {
                "kind": "text"
            },
            "crisisEvents": {
                "kind": "json"
            },
            "email": {
                "kind": "text"
            },
            "inWhichCase": {
                "kind": "text"
            },
            "landline": {
                "kind": "text"
            },
            "mobile": {
                "kind": "text"
            },
            "name": {
                "kind": "text"
            },
            "position": {
                "kind": "text"
            },
            "remarks": {
                "kind": "text"
            },
            "responsible": {
                "kind": "text"
            },
            "status": {
                "kind": "enum",
                "values": [
                    "active",
                    "inactive"
                ]
            },
            "unit": {
                "kind": "ref",
                "refEntity": "unit"
            },
            "whichMethod": {
                "kind": "text"
            },
            "who": {
                "kind": "text"
            },
            "withWhom": {
                "kind": "text"
            }
        },
        "communicationChannelPolicy": {
            "channel": {
                "kind": "enum",
                "values": [
                    "in-app",
                    "email",
                    "sms",
                    "push"
                ]
            },
            "isEnabled": {
                "kind": "boolean"
            }
        },
        "communicationPlan": {
            "audience": {
                "kind": "text"
            },
            "bcps": {
                "kind": "json"
            },
            "channels": {
                "kind": "text"
            },
            "crisisEvents": {
                "kind": "json"
            },
            "frequency": {
                "kind": "text"
            },
            "goal": {
                "kind": "text"
            },
            "messaging": {
                "kind": "text"
            },
            "partyInstanceId": {
                "kind": "ref",
                "refEntity": "partyInstance"
            },
            "status": {
                "kind": "enum",
                "values": [
                    "active",
                    "inactive"
                ]
            }
        },
        "communicationProvider": {
            "channel": {
                "kind": "enum",
                "values": [
                    "sms",
                    "email"
                ]
            },
            "config": {
                "kind": "json"
            },
            "credentials": {
                "kind": "json"
            },
            "from": {
                "kind": "text"
            },
            "isActive": {
                "kind": "boolean"
            },
            "isDefault": {
                "kind": "boolean"
            },
            "lastTestError": {
                "kind": "text"
            },
            "lastTestStatus": {
                "kind": "enum",
                "values": [
                    "success",
                    "failed",
                    "untested"
                ]
            },
            "lastTestedAt": {
                "kind": "date"
            },
            "name": {
                "kind": "text"
            },
            "priority": {
                "kind": "number"
            },
            "providerType": {
                "kind": "enum",
                "values": [
                    "netgsm",
                    "iletimerkezi",
                    "mutlucell",
                    "vatansms",
                    "verimor",
                    "turkcell",
                    "generic-http",
                    "smtp",
                    "resend",
                    "sendgrid",
                    "ses",
                    "office365-oauth2"
                ]
            },
            "status": {
                "kind": "enum",
                "values": [
                    "active",
                    "inactive"
                ]
            }
        },
        "company": {
            "code": {
                "kind": "text"
            },
            "description": {
                "kind": "text"
            },
            "employeeCount": {
                "kind": "number"
            },
            "logo": {
                "kind": "text"
            },
            "name": {
                "kind": "text"
            },
            "parent": {
                "kind": "ref",
                "refEntity": "company"
            },
            "sector": {
                "kind": "text"
            },
            "status": {
                "kind": "enum",
                "values": [
                    "active",
                    "inactive"
                ]
            },
            "taxNumber": {
                "kind": "text"
            }
        },
        "competence": {
            "code": {
                "kind": "text"
            },
            "description": {
                "kind": "text"
            },
            "level": {
                "kind": "text"
            },
            "name": {
                "kind": "text"
            },
            "numberOfPersonnel": {
                "kind": "number"
            },
            "personnelQualifications": {
                "kind": "json"
            },
            "qualifiedPersonnel": {
                "kind": "json"
            },
            "status": {
                "kind": "enum",
                "values": [
                    "active",
                    "inactive"
                ]
            }
        },
        "complianceFramework": {
            "code": {
                "kind": "text"
            },
            "description": {
                "kind": "text"
            },
            "name": {
                "kind": "text"
            },
            "regulatorySources": {
                "kind": "json"
            },
            "status": {
                "kind": "enum",
                "values": [
                    "active",
                    "inactive",
                    "draft"
                ]
            },
            "versionLabel": {
                "kind": "text"
            }
        },
        "complianceObligation": {
            "clause": {
                "kind": "ref",
                "refEntity": "regulatoryClause"
            },
            "description": {
                "kind": "text"
            },
            "duePattern": {
                "kind": "enum",
                "values": [
                    "annual_review",
                    "continuous",
                    "one_time",
                    "ad_hoc"
                ]
            },
            "evidenceExpectation": {
                "kind": "text"
            },
            "linkedPolicyDocument": {
                "kind": "ref",
                "refEntity": "document"
            },
            "obligationCode": {
                "kind": "text"
            },
            "ownerUnit": {
                "kind": "ref",
                "refEntity": "unit"
            },
            "priority": {
                "kind": "enum",
                "values": [
                    "mandatory",
                    "recommended"
                ]
            },
            "responsibleUser": {
                "kind": "ref",
                "refEntity": "user"
            },
            "reviewFrequency": {
                "kind": "text"
            },
            "source": {
                "kind": "ref",
                "refEntity": "regulatorySource"
            },
            "status": {
                "kind": "enum",
                "values": [
                    "draft",
                    "active",
                    "retired"
                ]
            },
            "title": {
                "kind": "text"
            }
        },
        "consentRecord": {
            "consent": {
                "kind": "ref",
                "refEntity": "explicitConsent"
            },
            "consentVersion": {
                "kind": "text"
            },
            "dataSubjectEmail": {
                "kind": "text"
            },
            "dataSubjectEmailHmac": {
                "kind": "text"
            },
            "dataSubjectId": {
                "kind": "text"
            },
            "dataSubjectIdHmac": {
                "kind": "text"
            },
            "dataSubjectIdLast4": {
                "kind": "text"
            },
            "dataSubjectName": {
                "kind": "text"
            },
            "dataSubjectNameHmac": {
                "kind": "text"
            },
            "dataSubjectType": {
                "kind": "text"
            },
            "evidenceUrl": {
                "kind": "text"
            },
            "expiresAt": {
                "kind": "date"
            },
            "given": {
                "kind": "boolean"
            },
            "givenAt": {
                "kind": "date"
            },
            "inventoryItemId": {
                "kind": "ref",
                "refEntity": "personalDataInventory"
            },
            "ipAddress": {
                "kind": "text"
            },
            "privacyNoticeId": {
                "kind": "ref",
                "refEntity": "privacyNotice"
            },
            "privacyNoticeVersion": {
                "kind": "text"
            },
            "processingPurposeId": {
                "kind": "ref",
                "refEntity": "processingPurpose"
            },
            "source": {
                "kind": "enum",
                "values": [
                    "web",
                    "mobile",
                    "paper",
                    "verbal",
                    "api"
                ]
            },
            "status": {
                "kind": "enum",
                "values": [
                    "valid",
                    "withdrawn",
                    "expired"
                ]
            },
            "userAgent": {
                "kind": "text"
            },
            "withdrawnAt": {
                "kind": "date"
            }
        },
        "context": {
            "code": {
                "kind": "text"
            },
            "description": {
                "kind": "text"
            },
            "intendedOutcomes": {
                "kind": "text"
            },
            "name": {
                "kind": "text"
            },
            "organizationalPurpose": {
                "kind": "text"
            },
            "status": {
                "kind": "enum",
                "values": [
                    "active",
                    "inactive"
                ]
            },
            "subItems": {
                "kind": "json"
            },
            "type": {
                "kind": "enum",
                "values": [
                    "internal",
                    "external",
                    "interested-party",
                    "scope"
                ]
            }
        },
        "control": {
            "categories": {
                "kind": "json"
            },
            "control": {
                "kind": "text"
            },
            "controlCode": {
                "kind": "text"
            },
            "controlType": {
                "kind": "text"
            },
            "controlWeight": {
                "kind": "number"
            },
            "description": {
                "kind": "text"
            },
            "domain": {
                "kind": "text"
            },
            "effectiveness": {
                "kind": "text"
            },
            "implementationNotes": {
                "kind": "text"
            },
            "lastReviewDate": {
                "kind": "date"
            },
            "nextReviewDate": {
                "kind": "date"
            },
            "owner": {
                "kind": "ref",
                "refEntity": "user"
            },
            "partyInstanceId": {
                "kind": "ref",
                "refEntity": "partyInstance"
            },
            "references": {
                "kind": "json"
            },
            "relatedAssets": {
                "kind": "json"
            },
            "relatedObligations": {
                "kind": "json"
            },
            "relatedProcesses": {
                "kind": "json"
            },
            "relatedRisks": {
                "kind": "json"
            },
            "reviewFrequency": {
                "kind": "enum",
                "values": [
                    "none",
                    "monthly",
                    "quarterly",
                    "semi-annual",
                    "annual",
                    "biennial"
                ]
            },
            "scope": {
                "kind": "text"
            },
            "status": {
                "kind": "text"
            }
        },
        "cookieInventory": {
            "category": {
                "kind": "enum",
                "values": [
                    "zorunlu",
                    "islevsel",
                    "analitik",
                    "pazarlama"
                ]
            },
            "consentRequired": {
                "kind": "boolean"
            },
            "domain": {
                "kind": "text"
            },
            "duration": {
                "kind": "text"
            },
            "linkedConsentId": {
                "kind": "ref",
                "refEntity": "consentRecord"
            },
            "linkedPrivacyNoticeId": {
                "kind": "ref",
                "refEntity": "privacyNotice"
            },
            "name": {
                "kind": "text"
            },
            "party": {
                "kind": "enum",
                "values": [
                    "first_party",
                    "third_party"
                ]
            },
            "provider": {
                "kind": "text"
            },
            "purpose": {
                "kind": "text"
            },
            "status": {
                "kind": "enum",
                "values": [
                    "active",
                    "inactive"
                ]
            }
        },
        "crisisEvent": {
            "activatedBcps": {
                "kind": "json"
            },
            "actualCost": {
                "kind": "number"
            },
            "affectedAssets": {
                "kind": "json"
            },
            "affectedProcesses": {
                "kind": "json"
            },
            "affectedUnits": {
                "kind": "json"
            },
            "affectedVendors": {
                "kind": "json"
            },
            "code": {
                "kind": "text"
            },
            "comments": {
                "kind": "json"
            },
            "communicationPlans": {
                "kind": "json"
            },
            "communications": {
                "kind": "json"
            },
            "declaredAt": {
                "kind": "date"
            },
            "description": {
                "kind": "text"
            },
            "detectedAt": {
                "kind": "date"
            },
            "estimatedCost": {
                "kind": "number"
            },
            "impactDescription": {
                "kind": "text"
            },
            "impactedLocations": {
                "kind": "text"
            },
            "improvementActions": {
                "kind": "json"
            },
            "incidentCommander": {
                "kind": "ref",
                "refEntity": "user"
            },
            "lessonsLearned": {
                "kind": "json"
            },
            "occurredAt": {
                "kind": "date"
            },
            "partyInstanceId": {
                "kind": "ref",
                "refEntity": "partyInstance"
            },
            "recoveryActivities": {
                "kind": "json"
            },
            "recoveryResources": {
                "kind": "json"
            },
            "relatedBias": {
                "kind": "json"
            },
            "resolvedAt": {
                "kind": "date"
            },
            "rootCause": {
                "kind": "text"
            },
            "severity": {
                "kind": "enum",
                "values": [
                    "critical",
                    "major",
                    "moderate",
                    "minor"
                ]
            },
            "status": {
                "kind": "enum",
                "values": [
                    "detected",
                    "declared",
                    "responding",
                    "recovering",
                    "resolved",
                    "closed"
                ]
            },
            "teams": {
                "kind": "json"
            },
            "title": {
                "kind": "text"
            },
            "type": {
                "kind": "enum",
                "values": [
                    "natural-disaster",
                    "cyber-attack",
                    "infrastructure-failure",
                    "pandemic",
                    "civil-unrest",
                    "supply-chain",
                    "recovery",
                    "improvement",
                    "other"
                ]
            }
        },
        "crisisRecoveryActivity": {
            "dependencies": {
                "kind": "text"
            },
            "description": {
                "kind": "text"
            },
            "endDate": {
                "kind": "date"
            },
            "externalSupport": {
                "kind": "boolean"
            },
            "name": {
                "kind": "text"
            },
            "owner": {
                "kind": "ref",
                "refEntity": "user"
            },
            "progress": {
                "kind": "number"
            },
            "startDate": {
                "kind": "date"
            },
            "step": {
                "kind": "number"
            },
            "team": {
                "kind": "ref",
                "refEntity": "team"
            },
            "timeframe": {
                "kind": "text"
            },
            "vendor": {
                "kind": "ref",
                "refEntity": "vendor"
            }
        },
        "customFieldDefinition": {
            "defaultValue": {
                "kind": "json"
            },
            "description": {
                "kind": "json"
            },
            "entityType": {
                "kind": "text"
            },
            "fieldKey": {
                "kind": "text"
            },
            "fieldType": {
                "kind": "enum",
                "values": [
                    "text",
                    "textarea",
                    "number",
                    "boolean",
                    "date",
                    "datetime",
                    "select",
                    "multiselect",
                    "user",
                    "unit",
                    "role",
                    "json"
                ]
            },
            "isActive": {
                "kind": "boolean"
            },
            "isRequired": {
                "kind": "boolean"
            },
            "isSearchable": {
                "kind": "boolean"
            },
            "isUnique": {
                "kind": "boolean"
            },
            "label": {
                "kind": "json"
            },
            "options": {
                "kind": "json"
            },
            "readOnlyExpression": {
                "kind": "text"
            },
            "requiredExpression": {
                "kind": "text"
            },
            "validations": {
                "kind": "json"
            },
            "version": {
                "kind": "number"
            },
            "visibilityExpression": {
                "kind": "text"
            }
        },
        "customPermissionDefinition": {
            "actions": {
                "kind": "json"
            },
            "isActive": {
                "kind": "boolean"
            },
            "label": {
                "kind": "json"
            },
            "moduleKey": {
                "kind": "text"
            },
            "pageKey": {
                "kind": "text"
            }
        },
        "customerImportIdentityLink": {
            "createdByRunId": {
                "kind": "ref",
                "refEntity": "customerImportRun"
            },
            "definitionKey": {
                "kind": "text"
            },
            "definitionVersion": {
                "kind": "number"
            },
            "expiresAt": {
                "kind": "date"
            },
            "externalIdHash": {
                "kind": "text"
            },
            "firstSeenAt": {
                "kind": "date"
            },
            "lastSeenAt": {
                "kind": "date"
            },
            "sourceNamespace": {
                "kind": "text"
            },
            "targetEntityId": {
                "kind": "ref"
            },
            "targetEntityType": {
                "kind": "text"
            }
        },
        "customerImportMappingProfile": {
            "customFieldDigest": {
                "kind": "text"
            },
            "definitionDigest": {
                "kind": "text"
            },
            "definitionVersion": {
                "kind": "number"
            },
            "digest": {
                "kind": "text"
            },
            "expiresAt": {
                "kind": "date"
            },
            "headerFingerprint": {
                "kind": "text"
            },
            "key": {
                "kind": "text"
            },
            "mappings": {
                "kind": "json"
            },
            "name": {
                "kind": "json"
            },
            "operationPolicy": {
                "kind": "json"
            },
            "publishedAt": {
                "kind": "date"
            },
            "publishedBy": {
                "kind": "ref",
                "refEntity": "user"
            },
            "sourceNamespace": {
                "kind": "text"
            },
            "status": {
                "kind": "enum",
                "values": [
                    "draft",
                    "published",
                    "retired"
                ]
            },
            "targetEntityType": {
                "kind": "text"
            },
            "targetKey": {
                "kind": "text"
            },
            "version": {
                "kind": "number"
            }
        },
        "customerImportMutation": {
            "afterFingerprint": {
                "kind": "text"
            },
            "afterVersion": {
                "kind": "number"
            },
            "beforeSnapshotEncrypted": {
                "kind": "text"
            },
            "compensatedAt": {
                "kind": "date"
            },
            "compensationRunId": {
                "kind": "ref",
                "refEntity": "customerImportRun"
            },
            "expiresAt": {
                "kind": "date"
            },
            "identityLinkId": {
                "kind": "ref"
            },
            "operation": {
                "kind": "enum",
                "values": [
                    "create",
                    "update"
                ]
            },
            "operationKey": {
                "kind": "text"
            },
            "outboxEventIds": {
                "kind": "json"
            },
            "partyInstanceId": {
                "kind": "ref",
                "refEntity": "partyInstance"
            },
            "rowId": {
                "kind": "ref",
                "refEntity": "customerImportRow"
            },
            "runId": {
                "kind": "ref",
                "refEntity": "customerImportRun"
            },
            "targetEntityId": {
                "kind": "ref"
            },
            "targetEntityType": {
                "kind": "text"
            }
        },
        "customerImportPackage": {
            "acceptedRules": {
                "kind": "json"
            },
            "active": {
                "kind": "boolean"
            },
            "actorSnapshot": {
                "kind": "json"
            },
            "answers": {
                "kind": "json"
            },
            "decisionBlockers": {
                "kind": "json"
            },
            "decisionDigest": {
                "kind": "text"
            },
            "decisionStatus": {
                "kind": "json"
            },
            "errorSummary": {
                "kind": "json"
            },
            "evidenceDigest": {
                "kind": "text"
            },
            "expiresAt": {
                "kind": "date"
            },
            "latestRunId": {
                "kind": "ref",
                "refEntity": "customerImportPackageRun"
            },
            "plan": {
                "kind": "json"
            },
            "planDigest": {
                "kind": "text"
            },
            "questionSetVersion": {
                "kind": "number"
            },
            "questions": {
                "kind": "json"
            },
            "revision": {
                "kind": "number"
            },
            "sessionBindings": {
                "kind": "json"
            },
            "state": {
                "kind": "enum",
                "values": [
                    "draft",
                    "analyzed",
                    "queued",
                    "running",
                    "succeeded",
                    "partial",
                    "failed",
                    "cancelled",
                    "compensating",
                    "compensated",
                    "needs-reconciliation"
                ]
            },
            "suggestions": {
                "kind": "json"
            }
        },
        "customerImportPackageRun": {
            "actorId": {
                "kind": "ref",
                "refEntity": "user"
            },
            "approverId": {
                "kind": "ref",
                "refEntity": "user"
            },
            "completedSessions": {
                "kind": "json"
            },
            "counters": {
                "kind": "json"
            },
            "errorSummary": {
                "kind": "json"
            },
            "expiresAt": {
                "kind": "date"
            },
            "fencingToken": {
                "kind": "number"
            },
            "finishedAt": {
                "kind": "date"
            },
            "heartbeatAt": {
                "kind": "date"
            },
            "idempotencyKey": {
                "kind": "text"
            },
            "leaseExpiresAt": {
                "kind": "date"
            },
            "leaseOwner": {
                "kind": "text"
            },
            "manifestDigest": {
                "kind": "text"
            },
            "manifestNonce": {
                "kind": "text"
            },
            "manifestPayload": {
                "kind": "json"
            },
            "manifestSignature": {
                "kind": "text"
            },
            "packageId": {
                "kind": "ref",
                "refEntity": "customerImportPackage"
            },
            "packageRevision": {
                "kind": "number"
            },
            "parentRunId": {
                "kind": "ref",
                "refEntity": "customerImportPackageRun"
            },
            "planDigest": {
                "kind": "text"
            },
            "queueJobId": {
                "kind": "text"
            },
            "reconciliation": {
                "kind": "json"
            },
            "startedAt": {
                "kind": "date"
            },
            "state": {
                "kind": "enum",
                "values": [
                    "queued",
                    "running",
                    "succeeded",
                    "partial",
                    "failed",
                    "cancelled",
                    "needs-reconciliation",
                    "compensating",
                    "compensated"
                ]
            },
            "trigger": {
                "kind": "enum",
                "values": [
                    "manual",
                    "compensation",
                    "reconcile"
                ]
            }
        },
        "customerImportRelationMutation": {
            "compensatedAt": {
                "kind": "date"
            },
            "expiresAt": {
                "kind": "date"
            },
            "inverseEntityIds": {
                "kind": "json"
            },
            "inverseEntityType": {
                "kind": "text"
            },
            "inverseField": {
                "kind": "text"
            },
            "operation": {
                "kind": "enum",
                "values": [
                    "link"
                ]
            },
            "ownerEntityId": {
                "kind": "ref"
            },
            "ownerEntityType": {
                "kind": "text"
            },
            "ownerField": {
                "kind": "text"
            },
            "rowId": {
                "kind": "ref",
                "refEntity": "customerImportRow"
            },
            "runId": {
                "kind": "ref"
            },
            "strategy": {
                "kind": "enum",
                "values": [
                    "asset-vulnerability"
                ]
            }
        },
        "customerImportRow": {
            "candidateSnapshot": {
                "kind": "json"
            },
            "canonicalPayloadEncrypted": {
                "kind": "text"
            },
            "displaySnapshot": {
                "kind": "json"
            },
            "executionPayloadEncrypted": {
                "kind": "text"
            },
            "expiresAt": {
                "kind": "date"
            },
            "hidden": {
                "kind": "boolean"
            },
            "identity": {
                "kind": "json"
            },
            "lastRunId": {
                "kind": "ref",
                "refEntity": "customerImportRun"
            },
            "outcome": {
                "kind": "enum",
                "values": [
                    "pending",
                    "create",
                    "update",
                    "unchanged",
                    "skip",
                    "conflict",
                    "invalid",
                    "failed"
                ]
            },
            "planDigest": {
                "kind": "text"
            },
            "plannedOutcome": {
                "kind": "enum",
                "values": [
                    "create",
                    "update",
                    "unchanged",
                    "skip",
                    "conflict",
                    "invalid",
                    "failed"
                ]
            },
            "previewFingerprint": {
                "kind": "text"
            },
            "previewVersion": {
                "kind": "number"
            },
            "provenance": {
                "kind": "json"
            },
            "referenceResults": {
                "kind": "json"
            },
            "resultError": {
                "kind": "json"
            },
            "rowNumber": {
                "kind": "number"
            },
            "sessionId": {
                "kind": "ref",
                "refEntity": "customerImportSession"
            },
            "sheetKey": {
                "kind": "text"
            },
            "sheetName": {
                "kind": "text"
            },
            "sourceHash": {
                "kind": "text"
            },
            "sourceIdentity": {
                "kind": "text"
            },
            "targetEntityId": {
                "kind": "ref"
            },
            "targetEntityType": {
                "kind": "text"
            },
            "validationErrors": {
                "kind": "json"
            }
        },
        "customerImportRun": {
            "actorId": {
                "kind": "ref",
                "refEntity": "user"
            },
            "approverId": {
                "kind": "ref",
                "refEntity": "user"
            },
            "counters": {
                "kind": "json"
            },
            "customFieldDigest": {
                "kind": "text"
            },
            "definitionDigest": {
                "kind": "text"
            },
            "definitionKey": {
                "kind": "text"
            },
            "definitionVersion": {
                "kind": "number"
            },
            "errorSummary": {
                "kind": "json"
            },
            "expiresAt": {
                "kind": "date"
            },
            "fencingToken": {
                "kind": "number"
            },
            "finishedAt": {
                "kind": "date"
            },
            "heartbeatAt": {
                "kind": "date"
            },
            "idempotencyKey": {
                "kind": "text"
            },
            "leaseExpiresAt": {
                "kind": "date"
            },
            "leaseOwner": {
                "kind": "text"
            },
            "manifestDigest": {
                "kind": "text"
            },
            "manifestNonce": {
                "kind": "text"
            },
            "manifestPayload": {
                "kind": "json"
            },
            "manifestSignature": {
                "kind": "text"
            },
            "operationPolicy": {
                "kind": "json"
            },
            "parentRunId": {
                "kind": "ref",
                "refEntity": "customerImportRun"
            },
            "queueJobId": {
                "kind": "text"
            },
            "reconciliation": {
                "kind": "json"
            },
            "retrySummary": {
                "kind": "json"
            },
            "sessionId": {
                "kind": "ref",
                "refEntity": "customerImportSession"
            },
            "startedAt": {
                "kind": "date"
            },
            "state": {
                "kind": "enum",
                "values": [
                    "queued",
                    "running",
                    "succeeded",
                    "partial",
                    "failed",
                    "cancelled",
                    "needs-reconciliation",
                    "compensating",
                    "compensated"
                ]
            },
            "trigger": {
                "kind": "enum",
                "values": [
                    "manual",
                    "retry",
                    "compensation",
                    "reconcile"
                ]
            }
        },
        "customerImportSession": {
            "actorSnapshot": {
                "kind": "json"
            },
            "analysisQueueJobId": {
                "kind": "text"
            },
            "analysisRevision": {
                "kind": "number"
            },
            "correlationId": {
                "kind": "text"
            },
            "counters": {
                "kind": "json"
            },
            "customFieldDigest": {
                "kind": "text"
            },
            "customFieldSnapshot": {
                "kind": "json"
            },
            "definitionDigest": {
                "kind": "text"
            },
            "definitionSnapshot": {
                "kind": "json"
            },
            "definitionVersion": {
                "kind": "number"
            },
            "errorSummary": {
                "kind": "json"
            },
            "expiresAt": {
                "kind": "date"
            },
            "latestAnalysisAt": {
                "kind": "date"
            },
            "latestRunId": {
                "kind": "ref",
                "refEntity": "customerImportRun"
            },
            "operationPolicy": {
                "kind": "json"
            },
            "packageHistoryId": {
                "kind": "ref",
                "refEntity": "customerImportPackage"
            },
            "packageId": {
                "kind": "ref",
                "refEntity": "customerImportPackage"
            },
            "packageRevision": {
                "kind": "number"
            },
            "queueJobIds": {
                "kind": "json"
            },
            "state": {
                "kind": "enum",
                "values": [
                    "uploaded",
                    "analyzing",
                    "analyzed",
                    "queued",
                    "running",
                    "succeeded",
                    "partial",
                    "failed",
                    "cancelled",
                    "compensating",
                    "compensated",
                    "needs-reconciliation"
                ]
            },
            "targetEntityType": {
                "kind": "text"
            },
            "targetKey": {
                "kind": "text"
            }
        },
        "dataBreach": {
            "affectedDataCategories": {
                "kind": "json"
            },
            "affectedDataSubjectCount": {
                "kind": "number"
            },
            "affectedDataSubjectTypes": {
                "kind": "json"
            },
            "affectedRecordCount": {
                "kind": "number"
            },
            "assignee": {
                "kind": "ref",
                "refEntity": "user"
            },
            "authorityDeadline": {
                "kind": "date"
            },
            "authorityNotificationDate": {
                "kind": "date"
            },
            "authorityNotificationRef": {
                "kind": "text"
            },
            "availabilityImpact": {
                "kind": "boolean"
            },
            "becameAwareAt": {
                "kind": "date"
            },
            "breachCause": {
                "kind": "text"
            },
            "breachType": {
                "kind": "enum",
                "values": [
                    "unauthorized_access",
                    "theft",
                    "loss",
                    "disclosure",
                    "alteration",
                    "destruction"
                ]
            },
            "confidentialityImpact": {
                "kind": "boolean"
            },
            "containmentMeasures": {
                "kind": "text"
            },
            "dataSubjectDeadline": {
                "kind": "date"
            },
            "dataSubjectNotificationDate": {
                "kind": "date"
            },
            "dataSubjectNotificationMethod": {
                "kind": "text"
            },
            "description": {
                "kind": "text"
            },
            "detectedAt": {
                "kind": "date"
            },
            "detectedBy": {
                "kind": "ref",
                "refEntity": "user"
            },
            "incidentId": {
                "kind": "ref",
                "refEntity": "incident"
            },
            "integrityImpact": {
                "kind": "boolean"
            },
            "lateNotificationJustification": {
                "kind": "text"
            },
            "notifiedToAuthority": {
                "kind": "boolean"
            },
            "notifiedToDataSubjects": {
                "kind": "boolean"
            },
            "occurredAt": {
                "kind": "date"
            },
            "partyInstanceId": {
                "kind": "ref",
                "refEntity": "partyInstance"
            },
            "possibleConsequences": {
                "kind": "text"
            },
            "preventiveMeasures": {
                "kind": "text"
            },
            "processorName": {
                "kind": "text"
            },
            "processorOriginated": {
                "kind": "boolean"
            },
            "referenceNumber": {
                "kind": "text"
            },
            "remediationMeasures": {
                "kind": "text"
            },
            "severity": {
                "kind": "enum",
                "values": [
                    "critical",
                    "high",
                    "medium",
                    "low"
                ]
            },
            "status": {
                "kind": "enum",
                "values": [
                    "detected",
                    "investigating",
                    "contained",
                    "notified",
                    "closed"
                ]
            },
            "title": {
                "kind": "text"
            }
        },
        "dataDisposalMethod": {
            "code": {
                "kind": "text"
            },
            "description": {
                "kind": "text"
            },
            "name": {
                "kind": "text"
            },
            "procedure": {
                "kind": "text"
            },
            "status": {
                "kind": "enum",
                "values": [
                    "active",
                    "inactive"
                ]
            },
            "type": {
                "kind": "enum",
                "values": [
                    "silme",
                    "yok_etme",
                    "anonimlestirme",
                    "anonimlestime"
                ]
            }
        },
        "dataProcessingAgreement": {
            "agreementType": {
                "kind": "enum",
                "values": [
                    "dpa",
                    "scc",
                    "undertaking",
                    "bcr",
                    "other"
                ]
            },
            "art28Checklist": {
                "kind": "json"
            },
            "art28Score": {
                "kind": "number"
            },
            "autoRenew": {
                "kind": "boolean"
            },
            "code": {
                "kind": "text"
            },
            "description": {
                "kind": "text"
            },
            "documentId": {
                "kind": "ref",
                "refEntity": "document"
            },
            "linkedInventoryItems": {
                "kind": "json"
            },
            "linkedProcessingActivities": {
                "kind": "json"
            },
            "partyInstanceId": {
                "kind": "ref",
                "refEntity": "partyInstance"
            },
            "role": {
                "kind": "enum",
                "values": [
                    "processor",
                    "joint_controller",
                    "sub_processor"
                ]
            },
            "status": {
                "kind": "enum",
                "values": [
                    "draft",
                    "active",
                    "expired",
                    "terminated"
                ]
            },
            "subProcessors": {
                "kind": "json"
            },
            "title": {
                "kind": "text"
            },
            "transferMechanismId": {
                "kind": "ref",
                "refEntity": "internationalTransfer"
            },
            "validFrom": {
                "kind": "date"
            },
            "validUntil": {
                "kind": "date"
            },
            "vendorId": {
                "kind": "ref",
                "refEntity": "vendor"
            }
        },
        "dataSource": {
            "code": {
                "kind": "text"
            },
            "description": {
                "kind": "text"
            },
            "examples": {
                "kind": "json"
            },
            "name": {
                "kind": "text"
            },
            "status": {
                "kind": "enum",
                "values": [
                    "active",
                    "inactive"
                ]
            },
            "type": {
                "kind": "enum",
                "values": [
                    "ic",
                    "dis"
                ]
            }
        },
        "dataSubjectRequest": {
            "applicantAddress": {
                "kind": "text"
            },
            "applicantEmail": {
                "kind": "text"
            },
            "applicantIdentity": {
                "kind": "text"
            },
            "applicantName": {
                "kind": "text"
            },
            "applicantPhone": {
                "kind": "text"
            },
            "assignee": {
                "kind": "ref",
                "refEntity": "user"
            },
            "attachments": {
                "kind": "json"
            },
            "channel": {
                "kind": "enum",
                "values": [
                    "yazili",
                    "kep",
                    "eposta",
                    "noter",
                    "public_portal",
                    "diger"
                ]
            },
            "deadline": {
                "kind": "date"
            },
            "description": {
                "kind": "text"
            },
            "disposalRecordId": {
                "kind": "ref",
                "refEntity": "disposalRecord"
            },
            "jurisdiction": {
                "kind": "enum",
                "values": [
                    "kvkk",
                    "gdpr"
                ]
            },
            "notes": {
                "kind": "json"
            },
            "partyInstanceId": {
                "kind": "ref",
                "refEntity": "partyInstance"
            },
            "receivedAt": {
                "kind": "date"
            },
            "referenceNumber": {
                "kind": "text"
            },
            "requestType": {
                "kind": "enum",
                "values": [
                    "bilgi_talep",
                    "duzeltme",
                    "silme",
                    "sinirlandirma",
                    "itiraz",
                    "tasima",
                    "profilleme_itiraz",
                    "diger"
                ]
            },
            "respondedAt": {
                "kind": "date"
            },
            "responseAttachments": {
                "kind": "json"
            },
            "responseText": {
                "kind": "text"
            },
            "responseType": {
                "kind": "enum",
                "values": [
                    "kabul",
                    "kismi_kabul",
                    "ret",
                    "bilgi_talep"
                ]
            },
            "sourceApplicationId": {
                "kind": "ref",
                "refEntity": "applicationTracking"
            },
            "status": {
                "kind": "enum",
                "values": [
                    "yeni",
                    "kimlik_dogrulama",
                    "inceleniyor",
                    "beklemede",
                    "tamamlandi",
                    "reddedildi"
                ]
            },
            "subject": {
                "kind": "text"
            },
            "unit": {
                "kind": "ref",
                "refEntity": "unit"
            }
        },
        "deadLetterEvent": {
            "abandonedAt": {
                "kind": "date"
            },
            "attempts": {
                "kind": "number"
            },
            "eventName": {
                "kind": "text"
            },
            "lastError": {
                "kind": "text"
            },
            "payload": {
                "kind": "json"
            },
            "reason": {
                "kind": "text"
            },
            "redactedAt": {
                "kind": "date"
            },
            "redactionVersion": {
                "kind": "number"
            },
            "retriedAt": {
                "kind": "date"
            },
            "status": {
                "kind": "enum",
                "values": [
                    "pending",
                    "retried",
                    "abandoned"
                ]
            }
        },
        "delegation": {
            "declinedAt": {
                "kind": "date"
            },
            "declinedBy": {
                "kind": "ref",
                "refEntity": "user"
            },
            "delegateeId": {
                "kind": "ref",
                "refEntity": "user"
            },
            "delegatorId": {
                "kind": "ref",
                "refEntity": "user"
            },
            "endDate": {
                "kind": "date"
            },
            "isActive": {
                "kind": "boolean"
            },
            "reason": {
                "kind": "text"
            },
            "revokedAt": {
                "kind": "date"
            },
            "revokedBy": {
                "kind": "ref",
                "refEntity": "user"
            },
            "scope": {
                "kind": "json"
            },
            "startDate": {
                "kind": "date"
            }
        },
        "deliveryReceipt": {
            "attemptNumber": {
                "kind": "number"
            },
            "attemptState": {
                "kind": "enum",
                "values": [
                    "queued",
                    "processing",
                    "sent",
                    "delivered",
                    "read",
                    "suppressed",
                    "scheduled",
                    "failed",
                    "unknown",
                    "cancelled"
                ]
            },
            "channel": {
                "kind": "enum",
                "values": [
                    "email",
                    "sms",
                    "push",
                    "in-app",
                    "socket",
                    "whatsapp",
                    "teams",
                    "discord",
                    "slack",
                    "webhook"
                ]
            },
            "claimToken": {
                "kind": "text"
            },
            "contentChecksum": {
                "kind": "text"
            },
            "correlationId": {
                "kind": "text"
            },
            "deliveredAt": {
                "kind": "date"
            },
            "deliveryIntentId": {
                "kind": "ref",
                "refEntity": "notificationDeliveryIntent"
            },
            "dispatchId": {
                "kind": "ref",
                "refEntity": "notificationDispatch"
            },
            "error": {
                "kind": "text"
            },
            "eventId": {
                "kind": "text"
            },
            "metadata": {
                "kind": "json"
            },
            "nextAttemptAt": {
                "kind": "date"
            },
            "policyRevisionId": {
                "kind": "ref",
                "refEntity": "notificationPolicyRevision"
            },
            "providerIdempotencyKey": {
                "kind": "text"
            },
            "providerMessageId": {
                "kind": "text"
            },
            "readAt": {
                "kind": "date"
            },
            "reasonCode": {
                "kind": "text"
            },
            "redactedAt": {
                "kind": "date"
            },
            "redactionVersion": {
                "kind": "number"
            },
            "retryable": {
                "kind": "boolean"
            },
            "sentAt": {
                "kind": "date"
            },
            "status": {
                "kind": "enum",
                "values": [
                    "queued",
                    "sent",
                    "delivered",
                    "read",
                    "failed",
                    "skipped"
                ]
            },
            "tenantId": {
                "kind": "ref",
                "refEntity": "tenant"
            },
            "userId": {
                "kind": "ref",
                "refEntity": "user"
            }
        },
        "detailedReportArchive": {
            "approvedAt": {
                "kind": "date"
            },
            "approvedBy": {
                "kind": "ref",
                "refEntity": "user"
            },
            "artifactVersions": {
                "kind": "json"
            },
            "baselineSnapshot": {
                "kind": "ref",
                "refEntity": "detailedReportSnapshot"
            },
            "cancelledAt": {
                "kind": "date"
            },
            "cancelledBy": {
                "kind": "ref",
                "refEntity": "user"
            },
            "checksum": {
                "kind": "text"
            },
            "contentType": {
                "kind": "enum",
                "values": [
                    "application/pdf",
                    "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                ]
            },
            "dataSnapshotTime": {
                "kind": "date"
            },
            "deliveries": {
                "kind": "json"
            },
            "document": {
                "kind": "ref",
                "refEntity": "document"
            },
            "documentRevision": {
                "kind": "ref",
                "refEntity": "documentRevision"
            },
            "fileSize": {
                "kind": "number"
            },
            "format": {
                "kind": "enum",
                "values": [
                    "pdf",
                    "docx"
                ]
            },
            "generatedAt": {
                "kind": "date"
            },
            "generatedBy": {
                "kind": "ref",
                "refEntity": "user"
            },
            "idempotencyKey": {
                "kind": "text"
            },
            "job": {
                "kind": "ref",
                "refEntity": "detailedReportJob"
            },
            "lifecycleComment": {
                "kind": "text"
            },
            "profile": {
                "kind": "ref",
                "refEntity": "detailedReportProfile"
            },
            "profileVersion": {
                "kind": "number"
            },
            "publication": {
                "kind": "json"
            },
            "renderPayload": {
                "kind": "json"
            },
            "replacementPublication": {
                "kind": "json"
            },
            "reportId": {
                "kind": "text"
            },
            "reportKey": {
                "kind": "enum",
                "values": [
                    "vendor-detailed-portfolio",
                    "vendor-record-dossier",
                    "incident-detailed-portfolio",
                    "incident-record-dossier",
                    "risk-detailed-portfolio",
                    "asset-detailed-portfolio",
                    "risk-record-dossier",
                    "asset-record-dossier",
                    "meeting-record-dossier"
                ]
            },
            "retentionUntil": {
                "kind": "date"
            },
            "revision": {
                "kind": "number"
            },
            "scope": {
                "kind": "json"
            },
            "snapshot": {
                "kind": "ref",
                "refEntity": "detailedReportSnapshot"
            },
            "status": {
                "kind": "enum",
                "values": [
                    "draft",
                    "review",
                    "approved",
                    "cancelled"
                ]
            },
            "storageResourceId": {
                "kind": "text"
            },
            "tombstoneReason": {
                "kind": "text"
            },
            "tombstonedAt": {
                "kind": "date"
            },
            "tombstonedBy": {
                "kind": "ref",
                "refEntity": "user"
            }
        },
        "detailedReportJob": {
            "adapterKey": {
                "kind": "text"
            },
            "adapterVersion": {
                "kind": "number"
            },
            "appearanceStrategy": {
                "kind": "enum",
                "values": [
                    "tenant-global-at-execution-v1"
                ]
            },
            "attachmentPolicy": {
                "kind": "enum",
                "values": [
                    "links-only",
                    "allow"
                ]
            },
            "baselineStrategy": {
                "kind": "enum",
                "values": [
                    "last-successful",
                    "previous-month",
                    "previous-quarter"
                ]
            },
            "canonicalizerVersion": {
                "kind": "number"
            },
            "claimToken": {
                "kind": "text"
            },
            "claimedAt": {
                "kind": "date"
            },
            "definitionVersion": {
                "kind": "number"
            },
            "enabled": {
                "kind": "boolean"
            },
            "format": {
                "kind": "enum",
                "values": [
                    "pdf",
                    "docx"
                ]
            },
            "jobRevisionVersion": {
                "kind": "number"
            },
            "lastRunAt": {
                "kind": "date"
            },
            "name": {
                "kind": "text"
            },
            "nextRunAt": {
                "kind": "date"
            },
            "notificationChannels": {
                "kind": "json"
            },
            "profile": {
                "kind": "ref",
                "refEntity": "detailedReportProfile"
            },
            "profileRevision": {
                "kind": "json"
            },
            "profileVersion": {
                "kind": "number"
            },
            "recipientTargets": {
                "kind": "json"
            },
            "recipients": {
                "kind": "json"
            },
            "recordId": {
                "kind": "ref"
            },
            "recordIds": {
                "kind": "json"
            },
            "rendererContractVersion": {
                "kind": "number"
            },
            "rendererKey": {
                "kind": "text"
            },
            "reportKey": {
                "kind": "enum",
                "values": [
                    "vendor-detailed-portfolio",
                    "vendor-record-dossier",
                    "incident-detailed-portfolio",
                    "incident-record-dossier",
                    "risk-detailed-portfolio",
                    "asset-detailed-portfolio",
                    "risk-record-dossier",
                    "asset-record-dossier",
                    "meeting-record-dossier"
                ]
            },
            "runHistory": {
                "kind": "json"
            },
            "schedule": {
                "kind": "json"
            },
            "selectorRevision": {
                "kind": "json"
            },
            "version": {
                "kind": "number"
            }
        },
        "detailedReportNarrative": {
            "acceptedAt": {
                "kind": "date"
            },
            "acceptedBy": {
                "kind": "ref",
                "refEntity": "user"
            },
            "baselineSnapshot": {
                "kind": "ref",
                "refEntity": "detailedReportSnapshot"
            },
            "estimatedCostUsd": {
                "kind": "number"
            },
            "inputHash": {
                "kind": "text"
            },
            "length": {
                "kind": "enum",
                "values": [
                    "short",
                    "medium",
                    "long"
                ]
            },
            "locale": {
                "kind": "enum",
                "values": [
                    "tr",
                    "en"
                ]
            },
            "model": {
                "kind": "text"
            },
            "promptVersion": {
                "kind": "text"
            },
            "providerRequestId": {
                "kind": "text"
            },
            "redactedFields": {
                "kind": "json"
            },
            "sentences": {
                "kind": "json"
            },
            "snapshot": {
                "kind": "ref",
                "refEntity": "detailedReportSnapshot"
            },
            "status": {
                "kind": "enum",
                "values": [
                    "draft",
                    "accepted",
                    "rejected"
                ]
            },
            "tone": {
                "kind": "enum",
                "values": [
                    "executive",
                    "neutral",
                    "concise"
                ]
            },
            "version": {
                "kind": "number"
            }
        },
        "detailedReportProfile": {
            "branding": {
                "kind": "json"
            },
            "definitionVersionAtSave": {
                "kind": "number"
            },
            "isDefault": {
                "kind": "boolean"
            },
            "locale": {
                "kind": "enum",
                "values": [
                    "tr",
                    "en"
                ]
            },
            "name": {
                "kind": "text"
            },
            "options": {
                "kind": "json"
            },
            "owner": {
                "kind": "ref",
                "refEntity": "user"
            },
            "profileVersion": {
                "kind": "number"
            },
            "reportKey": {
                "kind": "text"
            },
            "schemaVersion": {
                "kind": "number"
            },
            "sections": {
                "kind": "json"
            },
            "selectorDefaults": {
                "kind": "json"
            },
            "status": {
                "kind": "enum",
                "values": [
                    "draft",
                    "active",
                    "inactive"
                ]
            }
        },
        "detailedReportSnapshot": {
            "adapterKey": {
                "kind": "text"
            },
            "adapterVersion": {
                "kind": "number"
            },
            "archivePolicy": {
                "kind": "enum",
                "values": [
                    "standard",
                    "legal-hold"
                ]
            },
            "canonicalData": {
                "kind": "json"
            },
            "canonicalizerVersion": {
                "kind": "number"
            },
            "comparatorVersion": {
                "kind": "number"
            },
            "confidentiality": {
                "kind": "json"
            },
            "definitionVersion": {
                "kind": "number"
            },
            "generatedAt": {
                "kind": "date"
            },
            "generatedBy": {
                "kind": "ref",
                "refEntity": "user"
            },
            "hash": {
                "kind": "text"
            },
            "normalizedPayload": {
                "kind": "json"
            },
            "profile": {
                "kind": "ref",
                "refEntity": "detailedReportProfile"
            },
            "profileVersion": {
                "kind": "number"
            },
            "reportKey": {
                "kind": "enum",
                "values": [
                    "vendor-detailed-portfolio",
                    "vendor-record-dossier",
                    "incident-detailed-portfolio",
                    "incident-record-dossier",
                    "risk-detailed-portfolio",
                    "asset-detailed-portfolio",
                    "risk-record-dossier",
                    "asset-record-dossier",
                    "meeting-record-dossier"
                ]
            },
            "retentionUntil": {
                "kind": "date"
            },
            "schemaVersion": {
                "kind": "number"
            },
            "scope": {
                "kind": "json"
            },
            "subject": {
                "kind": "json"
            }
        },
        "disposalRecord": {
            "approvedBy": {
                "kind": "ref",
                "refEntity": "user"
            },
            "basis": {
                "kind": "enum",
                "values": [
                    "sure_doldu",
                    "dsr_silme",
                    "amac_ortadan_kalkti",
                    "hukuki_dayanak_kalkti",
                    "diger"
                ]
            },
            "dataCategoryId": {
                "kind": "ref",
                "refEntity": "personalDataCategory"
            },
            "dataDescription": {
                "kind": "text"
            },
            "disposedAt": {
                "kind": "date"
            },
            "evidence": {
                "kind": "text"
            },
            "inventoryItemId": {
                "kind": "ref",
                "refEntity": "personalDataInventory"
            },
            "methodId": {
                "kind": "ref",
                "refEntity": "dataDisposalMethod"
            },
            "methodNote": {
                "kind": "text"
            },
            "performedBy": {
                "kind": "ref",
                "refEntity": "user"
            },
            "processingActivityId": {
                "kind": "ref",
                "refEntity": "personalDataInventory"
            },
            "runId": {
                "kind": "ref",
                "refEntity": "disposalRun"
            },
            "sourceDsrId": {
                "kind": "ref",
                "refEntity": "dataSubjectRequest"
            },
            "status": {
                "kind": "enum",
                "values": [
                    "planned",
                    "completed",
                    "cancelled"
                ]
            }
        },
        "disposalRun": {
            "code": {
                "kind": "text"
            },
            "completedAt": {
                "kind": "date"
            },
            "description": {
                "kind": "text"
            },
            "partyInstanceId": {
                "kind": "ref",
                "refEntity": "partyInstance"
            },
            "periodEnd": {
                "kind": "date"
            },
            "periodStart": {
                "kind": "date"
            },
            "scheduledDate": {
                "kind": "date"
            },
            "status": {
                "kind": "enum",
                "values": [
                    "planned",
                    "in_progress",
                    "completed",
                    "cancelled"
                ]
            },
            "title": {
                "kind": "text"
            }
        },
        "document": {
            "approvalHistory": {
                "kind": "json"
            },
            "approvalMode": {
                "kind": "enum",
                "values": [
                    "parallel",
                    "sequential"
                ]
            },
            "approvalStatus": {
                "kind": "enum",
                "values": [
                    "draft",
                    "pending-approval",
                    "approved",
                    "rejected",
                    "expired"
                ]
            },
            "assignmentTemplate": {
                "kind": "ref",
                "refEntity": "assignmentTemplate"
            },
            "bcps": {
                "kind": "json"
            },
            "bias": {
                "kind": "json"
            },
            "classification": {
                "kind": "ref",
                "refEntity": "classification"
            },
            "code": {
                "kind": "text"
            },
            "controlledArtifactOperationId": {
                "kind": "text"
            },
            "currentApprovalStep": {
                "kind": "number"
            },
            "currentRevision": {
                "kind": "ref",
                "refEntity": "documentRevision"
            },
            "description": {
                "kind": "text"
            },
            "documentType": {
                "kind": "ref",
                "refEntity": "documentType"
            },
            "dynamicReportSource": {
                "kind": "boolean"
            },
            "effectiveDate": {
                "kind": "date"
            },
            "expiryDate": {
                "kind": "date"
            },
            "fileName": {
                "kind": "text"
            },
            "fileSize": {
                "kind": "number"
            },
            "fileUrl": {
                "kind": "text"
            },
            "lastReviewDate": {
                "kind": "date"
            },
            "mimeType": {
                "kind": "text"
            },
            "nextReviewDate": {
                "kind": "date"
            },
            "partyInstanceId": {
                "kind": "ref",
                "refEntity": "partyInstance"
            },
            "publicShare": {
                "kind": "json"
            },
            "publishedAt": {
                "kind": "date"
            },
            "relatedControls": {
                "kind": "json"
            },
            "relatedObligations": {
                "kind": "json"
            },
            "relatedProcesses": {
                "kind": "json"
            },
            "relatedVendors": {
                "kind": "json"
            },
            "reportBinding": {
                "kind": "json"
            },
            "reviewFrequency": {
                "kind": "enum",
                "values": [
                    "none",
                    "monthly",
                    "quarterly",
                    "semi-annual",
                    "annual",
                    "biennial"
                ]
            },
            "status": {
                "kind": "enum",
                "values": [
                    "active",
                    "archived",
                    "obsolete"
                ]
            },
            "tags": {
                "kind": "json"
            },
            "title": {
                "kind": "text"
            },
            "unit": {
                "kind": "ref",
                "refEntity": "unit"
            },
            "version": {
                "kind": "text"
            },
            "workflowInstanceId": {
                "kind": "ref",
                "refEntity": "workflowInstance"
            }
        },
        "documentRevision": {
            "approvedAt": {
                "kind": "date"
            },
            "approvedBy": {
                "kind": "ref",
                "refEntity": "user"
            },
            "changeDescription": {
                "kind": "text"
            },
            "controlledArtifactOperationId": {
                "kind": "text"
            },
            "document": {
                "kind": "ref",
                "refEntity": "document"
            },
            "fileName": {
                "kind": "text"
            },
            "fileSize": {
                "kind": "number"
            },
            "fileType": {
                "kind": "enum",
                "values": [
                    "docx",
                    "xlsx",
                    "pdf",
                    "other"
                ]
            },
            "fileUrl": {
                "kind": "text"
            },
            "isActive": {
                "kind": "boolean"
            },
            "isDynamic": {
                "kind": "boolean"
            },
            "mimeType": {
                "kind": "text"
            },
            "notes": {
                "kind": "text"
            },
            "pdfUrl": {
                "kind": "text"
            },
            "rejectedAt": {
                "kind": "date"
            },
            "rejectedBy": {
                "kind": "ref",
                "refEntity": "user"
            },
            "rejectionReason": {
                "kind": "text"
            },
            "reportTemplate": {
                "kind": "text"
            },
            "status": {
                "kind": "enum",
                "values": [
                    "draft",
                    "pending-approval",
                    "approved",
                    "rejected",
                    "archived"
                ]
            },
            "uploadedBy": {
                "kind": "ref",
                "refEntity": "user"
            },
            "version": {
                "kind": "number"
            },
            "versionLabel": {
                "kind": "text"
            },
            "workflowInstanceId": {
                "kind": "ref",
                "refEntity": "workflowInstance"
            }
        },
        "documentType": {
            "complianceCategory": {
                "kind": "text"
            },
            "defaultAssignmentTemplate": {
                "kind": "ref",
                "refEntity": "assignmentTemplate"
            },
            "defaultClassification": {
                "kind": "ref",
                "refEntity": "classification"
            },
            "defaultReviewFrequency": {
                "kind": "enum",
                "values": [
                    "monthly",
                    "quarterly",
                    "semi-annual",
                    "annual",
                    "biennial"
                ]
            },
            "documentCategory": {
                "kind": "text"
            },
            "documentTypeAbbreviation": {
                "kind": "text"
            },
            "status": {
                "kind": "enum",
                "values": [
                    "active",
                    "inactive"
                ]
            },
            "templateUrl": {
                "kind": "text"
            }
        },
        "dpiaAssessment": {
            "approvalDecision": {
                "kind": "enum",
                "values": [
                    "accept",
                    "reject",
                    "conditional"
                ]
            },
            "assessmentType": {
                "kind": "enum",
                "values": [
                    "dpia",
                    "lia",
                    "tia"
                ]
            },
            "code": {
                "kind": "text"
            },
            "completedAt": {
                "kind": "date"
            },
            "completedBy": {
                "kind": "ref",
                "refEntity": "user"
            },
            "description": {
                "kind": "text"
            },
            "dpiaRequired": {
                "kind": "boolean"
            },
            "dpoOpinion": {
                "kind": "text"
            },
            "internationalTransferId": {
                "kind": "ref",
                "refEntity": "internationalTransfer"
            },
            "inventoryItemId": {
                "kind": "ref",
                "refEntity": "personalDataInventory"
            },
            "language": {
                "kind": "enum",
                "values": [
                    "tr",
                    "en"
                ]
            },
            "linkedRiskIds": {
                "kind": "json"
            },
            "necessityAssessment": {
                "kind": "text"
            },
            "outcome": {
                "kind": "enum",
                "values": [
                    "approved",
                    "approved_with_measures",
                    "prior_consultation_required",
                    "rejected"
                ]
            },
            "partyInstanceId": {
                "kind": "ref",
                "refEntity": "partyInstance"
            },
            "processingActivityId": {
                "kind": "ref",
                "refEntity": "personalDataInventory"
            },
            "proportionalityAssessment": {
                "kind": "text"
            },
            "residualRiskLevel": {
                "kind": "enum",
                "values": [
                    "low",
                    "medium",
                    "high"
                ]
            },
            "risks": {
                "kind": "json"
            },
            "screening": {
                "kind": "json"
            },
            "screeningScore": {
                "kind": "number"
            },
            "status": {
                "kind": "enum",
                "values": [
                    "draft",
                    "in_review",
                    "approved",
                    "rejected",
                    "archived"
                ]
            },
            "submittedAt": {
                "kind": "date"
            },
            "templateId": {
                "kind": "ref",
                "refEntity": "privacyDpiaTemplate"
            },
            "title": {
                "kind": "text"
            }
        },
        "dpiaTemplate": {
            "code": {
                "kind": "text"
            },
            "name": {
                "kind": "text"
            },
            "status": {
                "kind": "enum",
                "values": [
                    "active",
                    "inactive",
                    "draft"
                ]
            },
            "templateBody": {
                "kind": "text"
            },
            "triggerSummary": {
                "kind": "text"
            }
        },
        "dutyDefinition": {
            "code": {
                "kind": "text"
            },
            "description": {
                "kind": "text"
            },
            "executionTasks": {
                "kind": "json"
            },
            "members": {
                "kind": "json"
            },
            "name": {
                "kind": "text"
            },
            "situationKey": {
                "kind": "enum",
                "values": [
                    "crisis",
                    "exercise",
                    "other"
                ]
            }
        },
        "entityFormLayout": {
            "entityType": {
                "kind": "text"
            },
            "isActive": {
                "kind": "boolean"
            },
            "mode": {
                "kind": "enum",
                "values": [
                    "create",
                    "update",
                    "detail"
                ]
            },
            "sections": {
                "kind": "json"
            }
        },
        "entityUpdateDraft": {
            "entityId": {
                "kind": "ref"
            },
            "entityType": {
                "kind": "text"
            },
            "linkPayload": {
                "kind": "json"
            },
            "operation": {
                "kind": "enum",
                "values": [
                    "update"
                ]
            },
            "pageKey": {
                "kind": "text"
            },
            "partyPayload": {
                "kind": "json"
            },
            "payload": {
                "kind": "json"
            },
            "previousData": {
                "kind": "json"
            },
            "resourceName": {
                "kind": "text"
            },
            "status": {
                "kind": "enum",
                "values": [
                    "draft",
                    "submitted",
                    "applied",
                    "rejected",
                    "cancelled"
                ]
            },
            "submittedAt": {
                "kind": "date"
            },
            "submittedBy": {
                "kind": "ref",
                "refEntity": "user"
            },
            "workflowInstanceId": {
                "kind": "ref",
                "refEntity": "workflowInstance"
            }
        },
        "evidenceBundle": {
            "canonicalPayloadSize": {
                "kind": "number"
            },
            "description": {
                "kind": "text"
            },
            "entityId": {
                "kind": "ref"
            },
            "entityType": {
                "kind": "text"
            },
            "exportArtifacts": {
                "kind": "json"
            },
            "frameworks": {
                "kind": "json"
            },
            "logIds": {
                "kind": "json"
            },
            "schemaVersion": {
                "kind": "number"
            },
            "sealedAt": {
                "kind": "date"
            },
            "signature": {
                "kind": "json"
            },
            "signatureVersion": {
                "kind": "number"
            },
            "status": {
                "kind": "enum",
                "values": [
                    "draft",
                    "sealed"
                ]
            },
            "title": {
                "kind": "text"
            }
        },
        "exercise": {
            "actualDate": {
                "kind": "date"
            },
            "bcp": {
                "kind": "ref",
                "refEntity": "bcp"
            },
            "code": {
                "kind": "text"
            },
            "description": {
                "kind": "text"
            },
            "documents": {
                "kind": "json"
            },
            "duration": {
                "kind": "text"
            },
            "exerciseEvaluations": {
                "kind": "json"
            },
            "exerciseParticipants": {
                "kind": "json"
            },
            "exerciseRecoveryActivities": {
                "kind": "json"
            },
            "facilitator": {
                "kind": "ref",
                "refEntity": "user"
            },
            "improvementActions": {
                "kind": "json"
            },
            "issuesIdentified": {
                "kind": "json"
            },
            "lessonsLearned": {
                "kind": "json"
            },
            "location": {
                "kind": "text"
            },
            "name": {
                "kind": "text"
            },
            "objectives": {
                "kind": "text"
            },
            "objectivesMet": {
                "kind": "json"
            },
            "otherRemarks": {
                "kind": "json"
            },
            "participants": {
                "kind": "json"
            },
            "participatingVendors": {
                "kind": "json"
            },
            "partyInstanceId": {
                "kind": "ref",
                "refEntity": "partyInstance"
            },
            "plannedDate": {
                "kind": "date"
            },
            "relatedAssessments": {
                "kind": "json"
            },
            "relatedBcps": {
                "kind": "json"
            },
            "results": {
                "kind": "text"
            },
            "scenario": {
                "kind": "text"
            },
            "scenarioDevelopment": {
                "kind": "json"
            },
            "scenarioTimelines": {
                "kind": "json"
            },
            "score": {
                "kind": "number"
            },
            "status": {
                "kind": "enum",
                "values": [
                    "planned",
                    "in-progress",
                    "completed",
                    "cancelled"
                ]
            },
            "teams": {
                "kind": "json"
            },
            "type": {
                "kind": "enum",
                "values": [
                    "tabletop",
                    "walkthrough",
                    "simulation",
                    "full-scale",
                    "parallel",
                    "improvement"
                ]
            }
        },
        "exerciseEvaluation": {
            "category": {
                "kind": "text"
            },
            "details": {
                "kind": "text"
            }
        },
        "exerciseParticipant": {
            "contact": {
                "kind": "text"
            },
            "name": {
                "kind": "text"
            },
            "responsibilities": {
                "kind": "text"
            },
            "role": {
                "kind": "text"
            },
            "unit": {
                "kind": "ref",
                "refEntity": "unit"
            }
        },
        "exerciseRecoveryActivity": {
            "dependencies": {
                "kind": "text"
            },
            "description": {
                "kind": "text"
            },
            "endDate": {
                "kind": "date"
            },
            "externalSupport": {
                "kind": "boolean"
            },
            "name": {
                "kind": "text"
            },
            "owner": {
                "kind": "ref",
                "refEntity": "user"
            },
            "progress": {
                "kind": "number"
            },
            "startDate": {
                "kind": "date"
            },
            "step": {
                "kind": "number"
            },
            "team": {
                "kind": "ref",
                "refEntity": "team"
            },
            "timeframe": {
                "kind": "text"
            },
            "vendor": {
                "kind": "ref",
                "refEntity": "vendor"
            }
        },
        "explicitConsent": {
            "capAddress": {
                "kind": "text"
            },
            "consentSignedAt": {
                "kind": "date"
            },
            "consentTextUrl": {
                "kind": "text"
            },
            "disclosureSignedAt": {
                "kind": "date"
            },
            "disclosureTextUrl": {
                "kind": "text"
            },
            "email": {
                "kind": "text"
            },
            "emailHmac": {
                "kind": "text"
            },
            "explicitConsentMethod": {
                "kind": "text"
            },
            "faxNo": {
                "kind": "text"
            },
            "historyOfExplicitConsent": {
                "kind": "text"
            },
            "inventoryItemId": {
                "kind": "ref",
                "refEntity": "personalDataInventory"
            },
            "legalRepresentativeName": {
                "kind": "text"
            },
            "legalRepresentativeTc": {
                "kind": "text"
            },
            "nameSurname": {
                "kind": "text"
            },
            "nameSurnameHmac": {
                "kind": "text"
            },
            "outputDocumentUrl": {
                "kind": "text"
            },
            "personalData": {
                "kind": "text"
            },
            "privacyNoticeId": {
                "kind": "ref",
                "refEntity": "privacyNotice"
            },
            "processingPurposeId": {
                "kind": "ref",
                "refEntity": "processingPurpose"
            },
            "referenceNumber": {
                "kind": "text"
            },
            "residentialAddress": {
                "kind": "text"
            },
            "status": {
                "kind": "enum",
                "values": [
                    "active",
                    "inactive"
                ]
            },
            "tcIdentityHmac": {
                "kind": "text"
            },
            "tcIdentityNo": {
                "kind": "text"
            },
            "tcLast4": {
                "kind": "text"
            },
            "telephoneHmac": {
                "kind": "text"
            },
            "telephoneLast4": {
                "kind": "text"
            },
            "telephoneNo": {
                "kind": "text"
            }
        },
        "explicitConsentMethod": {
            "description": {
                "kind": "text"
            },
            "metadata": {
                "kind": "json"
            },
            "name": {
                "kind": "text"
            },
            "status": {
                "kind": "enum",
                "values": [
                    "active",
                    "inactive"
                ]
            }
        },
        "explicitConsentReason": {
            "description": {
                "kind": "text"
            },
            "metadata": {
                "kind": "json"
            },
            "name": {
                "kind": "text"
            },
            "status": {
                "kind": "enum",
                "values": [
                    "active",
                    "inactive"
                ]
            }
        },
        "exportJob": {
            "actorId": {
                "kind": "ref",
                "refEntity": "user"
            },
            "adapterVersion": {
                "kind": "number"
            },
            "artifactCandidateCleanupAt": {
                "kind": "date"
            },
            "artifactCandidates": {
                "kind": "json"
            },
            "artifactDeletedAt": {
                "kind": "date"
            },
            "fencingToken": {
                "kind": "number"
            },
            "finishedAt": {
                "kind": "date"
            },
            "format": {
                "kind": "enum",
                "values": [
                    "json",
                    "csv"
                ]
            },
            "heartbeatAt": {
                "kind": "date"
            },
            "idempotencyKey": {
                "kind": "text"
            },
            "metadataExpiresAt": {
                "kind": "date"
            },
            "queueJobId": {
                "kind": "text"
            },
            "requestDigest": {
                "kind": "text"
            },
            "schemaVersion": {
                "kind": "number"
            },
            "startedAt": {
                "kind": "date"
            },
            "state": {
                "kind": "enum",
                "values": [
                    "queued",
                    "running",
                    "succeeded",
                    "failed",
                    "cancelled"
                ]
            },
            "type": {
                "kind": "enum",
                "values": [
                    "asset",
                    "risk",
                    "document",
                    "ticket",
                    "incident",
                    "control",
                    "vendor",
                    "changerequest"
                ]
            }
        },
        "formSubmission": {
            "approvalHistory": {
                "kind": "json"
            },
            "approvalStatus": {
                "kind": "enum",
                "values": [
                    "pending",
                    "approved",
                    "rejected",
                    "not-required"
                ]
            },
            "data": {
                "kind": "json"
            },
            "entityId": {
                "kind": "ref"
            },
            "entityLabel": {
                "kind": "text"
            },
            "entityType": {
                "kind": "text"
            },
            "files": {
                "kind": "json"
            },
            "form": {
                "kind": "ref",
                "refEntity": "formTemplate"
            },
            "formTaskId": {
                "kind": "ref",
                "refEntity": "formTask"
            },
            "maxScore": {
                "kind": "number"
            },
            "questionScores": {
                "kind": "json"
            },
            "source": {
                "kind": "enum",
                "values": [
                    "workflow",
                    "vendor",
                    "direct",
                    "manual",
                    "scheduled",
                    "periodic",
                    "training"
                ]
            },
            "status": {
                "kind": "enum",
                "values": [
                    "draft",
                    "submitted",
                    "processing",
                    "completed",
                    "cancelled"
                ]
            },
            "submittedAt": {
                "kind": "date"
            },
            "submittedBy": {
                "kind": "ref",
                "refEntity": "user"
            },
            "submitterEmail": {
                "kind": "text"
            },
            "submitterName": {
                "kind": "text"
            },
            "surveyDispatchId": {
                "kind": "ref",
                "refEntity": "surveyDispatch"
            },
            "totalScore": {
                "kind": "number"
            },
            "vendorAssessment": {
                "kind": "ref",
                "refEntity": "vendorAssessment"
            },
            "workflowInstanceId": {
                "kind": "ref",
                "refEntity": "workflowInstance"
            },
            "workflowTask": {
                "kind": "ref",
                "refEntity": "workflowTask"
            }
        },
        "formTask": {
            "assignedAt": {
                "kind": "date"
            },
            "assignedBy": {
                "kind": "ref",
                "refEntity": "user"
            },
            "assignedTo": {
                "kind": "ref",
                "refEntity": "user"
            },
            "completedAt": {
                "kind": "date"
            },
            "completionNotes": {
                "kind": "text"
            },
            "description": {
                "kind": "text"
            },
            "dispatchSource": {
                "kind": "enum",
                "values": [
                    "manual",
                    "scheduled",
                    "periodic",
                    "training"
                ]
            },
            "document": {
                "kind": "ref",
                "refEntity": "document"
            },
            "dueDate": {
                "kind": "date"
            },
            "formSubmission": {
                "kind": "ref",
                "refEntity": "formSubmission"
            },
            "formTemplate": {
                "kind": "ref",
                "refEntity": "formTemplate"
            },
            "lastSurveyReminderAt": {
                "kind": "date"
            },
            "priority": {
                "kind": "enum",
                "values": [
                    "low",
                    "medium",
                    "high",
                    "critical"
                ]
            },
            "status": {
                "kind": "enum",
                "values": [
                    "waiting-assignment",
                    "assigned",
                    "in-progress",
                    "completed",
                    "cancelled"
                ]
            },
            "statusHistory": {
                "kind": "json"
            },
            "surveyDispatchId": {
                "kind": "ref",
                "refEntity": "surveyDispatch"
            },
            "title": {
                "kind": "text"
            },
            "trainingId": {
                "kind": "ref",
                "refEntity": "training"
            },
            "userTrainingId": {
                "kind": "ref",
                "refEntity": "userTraining"
            },
            "workflowInstanceId": {
                "kind": "ref",
                "refEntity": "workflowInstance"
            },
            "workflowNodeId": {
                "kind": "text"
            },
            "workflowTaskId": {
                "kind": "ref",
                "refEntity": "workflowTask"
            }
        },
        "formTemplate": {
            "assignmentTemplate": {
                "kind": "ref",
                "refEntity": "assignmentTemplate"
            },
            "category": {
                "kind": "text"
            },
            "code": {
                "kind": "text"
            },
            "confirmationMessage": {
                "kind": "text"
            },
            "description": {
                "kind": "text"
            },
            "fields": {
                "kind": "json"
            },
            "name": {
                "kind": "text"
            },
            "notifyOnSubmit": {
                "kind": "json"
            },
            "requiresApproval": {
                "kind": "boolean"
            },
            "sections": {
                "kind": "json"
            },
            "status": {
                "kind": "enum",
                "values": [
                    "draft",
                    "published",
                    "archived"
                ]
            },
            "submitButtonText": {
                "kind": "text"
            },
            "surveyDefinition": {
                "kind": "json"
            },
            "surveySchemaVersion": {
                "kind": "number"
            },
            "templateKind": {
                "kind": "enum",
                "values": [
                    "form",
                    "survey"
                ]
            }
        },
        "gap": {
            "actualClosureDate": {
                "kind": "date"
            },
            "assignee": {
                "kind": "ref",
                "refEntity": "user"
            },
            "closureEvidence": {
                "kind": "json"
            },
            "control": {
                "kind": "ref",
                "refEntity": "control"
            },
            "currentState": {
                "kind": "text"
            },
            "description": {
                "kind": "text"
            },
            "desiredState": {
                "kind": "text"
            },
            "estimatedCost": {
                "kind": "number"
            },
            "estimatedEffort": {
                "kind": "text"
            },
            "gapDescription": {
                "kind": "text"
            },
            "identifiedDate": {
                "kind": "date"
            },
            "impact": {
                "kind": "text"
            },
            "name": {
                "kind": "text"
            },
            "remediationPlan": {
                "kind": "text"
            },
            "severity": {
                "kind": "enum",
                "values": [
                    "critical",
                    "high",
                    "medium",
                    "low"
                ]
            },
            "soaApplicability": {
                "kind": "enum",
                "values": [
                    "applicable",
                    "not-applicable",
                    "partial"
                ]
            },
            "soaImplementationStatus": {
                "kind": "enum",
                "values": [
                    "not-implemented",
                    "partially-implemented",
                    "implemented",
                    "not-applicable"
                ]
            },
            "soaJustification": {
                "kind": "text"
            },
            "status": {
                "kind": "enum",
                "values": [
                    "open",
                    "in-progress",
                    "pending-verification",
                    "closed",
                    "accepted"
                ]
            },
            "targetClosureDate": {
                "kind": "date"
            }
        },
        "generatedReport": {
            "checksum": {
                "kind": "text"
            },
            "fileName": {
                "kind": "text"
            },
            "fileSize": {
                "kind": "number"
            },
            "format": {
                "kind": "enum",
                "values": [
                    "pdf",
                    "docx",
                    "xlsx"
                ]
            },
            "generatedAt": {
                "kind": "date"
            },
            "generatedBy": {
                "kind": "ref",
                "refEntity": "user"
            },
            "locale": {
                "kind": "enum",
                "values": [
                    "tr",
                    "en"
                ]
            },
            "reportKey": {
                "kind": "text"
            },
            "status": {
                "kind": "enum",
                "values": [
                    "generating",
                    "completed",
                    "failed"
                ]
            },
            "storageKey": {
                "kind": "text"
            }
        },
        "governanceReportDefinition": {
            "audience": {
                "kind": "text"
            },
            "code": {
                "kind": "text"
            },
            "description": {
                "kind": "text"
            },
            "metricKeys": {
                "kind": "json"
            },
            "name": {
                "kind": "text"
            },
            "scheduleCron": {
                "kind": "text"
            },
            "status": {
                "kind": "enum",
                "values": [
                    "active",
                    "inactive",
                    "draft"
                ]
            }
        },
        "incident": {
            "acceptedAt": {
                "kind": "date"
            },
            "acceptedBy": {
                "kind": "ref",
                "refEntity": "user"
            },
            "affectedAssets": {
                "kind": "json"
            },
            "affectedUsers": {
                "kind": "number"
            },
            "assignedAt": {
                "kind": "date"
            },
            "assignedBy": {
                "kind": "ref",
                "refEntity": "user"
            },
            "assignedTo": {
                "kind": "ref",
                "refEntity": "user"
            },
            "assignedToPool": {
                "kind": "json"
            },
            "assignedUserIds": {
                "kind": "json"
            },
            "assignmentHistory": {
                "kind": "json"
            },
            "attachments": {
                "kind": "json"
            },
            "category": {
                "kind": "text"
            },
            "claimedAt": {
                "kind": "date"
            },
            "claimedBy": {
                "kind": "ref",
                "refEntity": "user"
            },
            "code": {
                "kind": "text"
            },
            "comments": {
                "kind": "json"
            },
            "containmentActions": {
                "kind": "text"
            },
            "dataBreachInvolved": {
                "kind": "boolean"
            },
            "description": {
                "kind": "text"
            },
            "detectedAt": {
                "kind": "date"
            },
            "escalationLevel": {
                "kind": "number"
            },
            "firstResponseAt": {
                "kind": "date"
            },
            "firstResponseDueAt": {
                "kind": "date"
            },
            "immediateActions": {
                "kind": "text"
            },
            "impact": {
                "kind": "enum",
                "values": [
                    "critical",
                    "high",
                    "medium",
                    "low"
                ]
            },
            "impactDescription": {
                "kind": "text"
            },
            "linkedActions": {
                "kind": "json"
            },
            "linkedChangeRequests": {
                "kind": "json"
            },
            "linkedProblem": {
                "kind": "ref",
                "refEntity": "problem"
            },
            "linkedProblems": {
                "kind": "json"
            },
            "occurredAt": {
                "kind": "date"
            },
            "partyInstanceId": {
                "kind": "ref",
                "refEntity": "partyInstance"
            },
            "regulatoryReporting": {
                "kind": "boolean"
            },
            "rejectedAt": {
                "kind": "date"
            },
            "rejectedBy": {
                "kind": "ref",
                "refEntity": "user"
            },
            "rejectionReason": {
                "kind": "text"
            },
            "relatedControls": {
                "kind": "json"
            },
            "relatedRisks": {
                "kind": "json"
            },
            "reportedAt": {
                "kind": "date"
            },
            "reportedBy": {
                "kind": "ref",
                "refEntity": "user"
            },
            "requestedBy": {
                "kind": "ref",
                "refEntity": "user"
            },
            "requestedByEmail": {
                "kind": "text"
            },
            "requestedByName": {
                "kind": "text"
            },
            "requestedByUnit": {
                "kind": "ref",
                "refEntity": "unit"
            },
            "resolutionDueAt": {
                "kind": "date"
            },
            "resolvedAt": {
                "kind": "date"
            },
            "rootCause": {
                "kind": "text"
            },
            "rootCauseCategory": {
                "kind": "text"
            },
            "severity": {
                "kind": "enum",
                "values": [
                    "critical",
                    "high",
                    "medium",
                    "low"
                ]
            },
            "sla": {
                "kind": "ref",
                "refEntity": "ticketSLA"
            },
            "slaBreached": {
                "kind": "boolean"
            },
            "slaBreachedAt": {
                "kind": "date"
            },
            "status": {
                "kind": "enum",
                "values": [
                    "draft",
                    "submitted",
                    "in_approval",
                    "approved",
                    "rejected",
                    "returned",
                    "assigned",
                    "in_progress",
                    "on_hold",
                    "resolved",
                    "closed",
                    "cancelled"
                ]
            },
            "statusHistory": {
                "kind": "json"
            },
            "submittedAt": {
                "kind": "date"
            },
            "template": {
                "kind": "ref",
                "refEntity": "incidentTemplate"
            },
            "title": {
                "kind": "text"
            },
            "type": {
                "kind": "enum",
                "values": [
                    "security",
                    "safety",
                    "operational",
                    "compliance",
                    "other"
                ]
            },
            "unit": {
                "kind": "ref",
                "refEntity": "unit"
            },
            "urgency": {
                "kind": "enum",
                "values": [
                    "critical",
                    "high",
                    "medium",
                    "low"
                ]
            },
            "visibilityApproverUserIds": {
                "kind": "json"
            },
            "visibilityInformedUserIds": {
                "kind": "json"
            },
            "workflowInstanceId": {
                "kind": "ref",
                "refEntity": "workflowInstance"
            },
            "workflowTemplateId": {
                "kind": "ref",
                "refEntity": "workflowTemplate"
            }
        },
        "incidentComment": {
            "attachments": {
                "kind": "json"
            },
            "author": {
                "kind": "ref",
                "refEntity": "user"
            },
            "content": {
                "kind": "text"
            },
            "editHistory": {
                "kind": "json"
            },
            "editedAt": {
                "kind": "date"
            },
            "incident": {
                "kind": "ref",
                "refEntity": "incident"
            },
            "isEdited": {
                "kind": "boolean"
            },
            "mentions": {
                "kind": "json"
            },
            "type": {
                "kind": "enum",
                "values": [
                    "comment",
                    "internal_note",
                    "system"
                ]
            }
        },
        "incidentTemplate": {
            "archivedAt": {
                "kind": "date"
            },
            "category": {
                "kind": "text"
            },
            "code": {
                "kind": "text"
            },
            "defaultAssigneePool": {
                "kind": "json"
            },
            "defaultSla": {
                "kind": "ref",
                "refEntity": "ticketSLA"
            },
            "defaultWorkflowTemplate": {
                "kind": "ref",
                "refEntity": "workflowTemplate"
            },
            "description": {
                "kind": "text"
            },
            "impact": {
                "kind": "enum",
                "values": [
                    "critical",
                    "high",
                    "medium",
                    "low"
                ]
            },
            "name": {
                "kind": "text"
            },
            "publishedAt": {
                "kind": "date"
            },
            "severity": {
                "kind": "enum",
                "values": [
                    "critical",
                    "high",
                    "medium",
                    "low"
                ]
            },
            "status": {
                "kind": "enum",
                "values": [
                    "draft",
                    "published",
                    "archived"
                ]
            },
            "type": {
                "kind": "enum",
                "values": [
                    "security",
                    "safety",
                    "operational",
                    "compliance",
                    "other"
                ]
            },
            "urgency": {
                "kind": "enum",
                "values": [
                    "critical",
                    "high",
                    "medium",
                    "low"
                ]
            }
        },
        "integrationConnection": {
            "config": {
                "kind": "json"
            },
            "description": {
                "kind": "text"
            },
            "health": {
                "kind": "enum",
                "values": [
                    "unknown",
                    "healthy",
                    "degraded",
                    "down"
                ]
            },
            "isBuiltinProvider": {
                "kind": "boolean"
            },
            "lastInvokedAt": {
                "kind": "date"
            },
            "lastTestError": {
                "kind": "text"
            },
            "lastTestStatus": {
                "kind": "enum",
                "values": [
                    "success",
                    "failed",
                    "untested"
                ]
            },
            "lastTestedAt": {
                "kind": "date"
            },
            "name": {
                "kind": "text"
            },
            "partyInstanceId": {
                "kind": "ref",
                "refEntity": "partyInstance"
            },
            "previousProviderVersion": {
                "kind": "number"
            },
            "providerKey": {
                "kind": "text"
            },
            "providerManifestDigest": {
                "kind": "text"
            },
            "providerVersion": {
                "kind": "number"
            },
            "status": {
                "kind": "enum",
                "values": [
                    "draft",
                    "active",
                    "inactive",
                    "error"
                ]
            },
            "webhookIngressId": {
                "kind": "text"
            },
            "webhookSecretHash": {
                "kind": "text"
            }
        },
        "integrationConnector": {
            "config": {
                "kind": "json"
            },
            "connectorType": {
                "kind": "enum",
                "values": [
                    "webhook",
                    "siem",
                    "iam",
                    "ticketing",
                    "cloud",
                    "other"
                ]
            },
            "description": {
                "kind": "text"
            },
            "enabled": {
                "kind": "boolean"
            },
            "lastError": {
                "kind": "text"
            },
            "lastSyncAt": {
                "kind": "date"
            },
            "name": {
                "kind": "text"
            }
        },
        "integrationCredentialSet": {
            "connectionId": {
                "kind": "ref",
                "refEntity": "integrationConnection"
            },
            "keyVersion": {
                "kind": "number"
            },
            "rotatedAt": {
                "kind": "date"
            },
            "values": {
                "kind": "json"
            }
        },
        "integrationEndpoint": {
            "builtin": {
                "kind": "boolean"
            },
            "category": {
                "kind": "text"
            },
            "connectionId": {
                "kind": "ref",
                "refEntity": "integrationConnection"
            },
            "description": {
                "kind": "json"
            },
            "headers": {
                "kind": "json"
            },
            "isActive": {
                "kind": "boolean"
            },
            "key": {
                "kind": "text"
            },
            "label": {
                "kind": "json"
            },
            "method": {
                "kind": "enum",
                "values": [
                    "GET",
                    "POST",
                    "PUT",
                    "PATCH",
                    "DELETE",
                    "HEAD"
                ]
            },
            "path": {
                "kind": "text"
            },
            "responseMapping": {
                "kind": "json"
            }
        },
        "integrationExternalIdentityLink": {
            "connectionId": {
                "kind": "ref",
                "refEntity": "integrationConnection"
            },
            "etag": {
                "kind": "text"
            },
            "externalId": {
                "kind": "text"
            },
            "externalIdHash": {
                "kind": "text"
            },
            "firstSeenAt": {
                "kind": "date"
            },
            "lastSeenAt": {
                "kind": "date"
            },
            "lastSyncedAt": {
                "kind": "date"
            },
            "localFingerprint": {
                "kind": "text"
            },
            "mappingKey": {
                "kind": "text"
            },
            "mappingVersion": {
                "kind": "number"
            },
            "remoteDeleteStatus": {
                "kind": "enum",
                "values": [
                    "active",
                    "deleted",
                    "unknown"
                ]
            },
            "remoteDeletedAt": {
                "kind": "date"
            },
            "remoteFingerprint": {
                "kind": "text"
            },
            "remoteVersion": {
                "kind": "text"
            },
            "resourceKey": {
                "kind": "text"
            },
            "targetEntityId": {
                "kind": "ref"
            },
            "targetEntityType": {
                "kind": "enum",
                "values": [
                    "Asset",
                    "Vulnerability"
                ]
            }
        },
        "integrationInvocation": {
            "actorUserId": {
                "kind": "ref",
                "refEntity": "user"
            },
            "connectionId": {
                "kind": "ref",
                "refEntity": "integrationConnection"
            },
            "correlationId": {
                "kind": "text"
            },
            "durationMs": {
                "kind": "number"
            },
            "endpointKey": {
                "kind": "text"
            },
            "endpointSource": {
                "kind": "enum",
                "values": [
                    "builtin",
                    "custom"
                ]
            },
            "errorSummary": {
                "kind": "text"
            },
            "expiresAt": {
                "kind": "date"
            },
            "httpStatus": {
                "kind": "number"
            },
            "method": {
                "kind": "text"
            },
            "path": {
                "kind": "text"
            },
            "status": {
                "kind": "enum",
                "values": [
                    "success",
                    "failed",
                    "timeout",
                    "blocked"
                ]
            }
        },
        "integrationMapping": {
            "conflictPolicy": {
                "kind": "json"
            },
            "connectionId": {
                "kind": "ref",
                "refEntity": "integrationConnection"
            },
            "deletePolicy": {
                "kind": "json"
            },
            "description": {
                "kind": "json"
            },
            "externalIdSourcePath": {
                "kind": "text"
            },
            "externalIdTransformExpression": {
                "kind": "text"
            },
            "fieldMappings": {
                "kind": "json"
            },
            "key": {
                "kind": "text"
            },
            "matchRules": {
                "kind": "json"
            },
            "name": {
                "kind": "json"
            },
            "partyInstanceId": {
                "kind": "ref",
                "refEntity": "partyInstance"
            },
            "partyRoleMappings": {
                "kind": "json"
            },
            "pipelineSteps": {
                "kind": "json"
            },
            "previousVersionId": {
                "kind": "ref",
                "refEntity": "integrationMapping"
            },
            "providerManifestDigest": {
                "kind": "text"
            },
            "providerVersion": {
                "kind": "number"
            },
            "publishedAt": {
                "kind": "date"
            },
            "referenceMappings": {
                "kind": "json"
            },
            "referencePolicy": {
                "kind": "json"
            },
            "resourceContext": {
                "kind": "json"
            },
            "resourceKey": {
                "kind": "text"
            },
            "retiredAt": {
                "kind": "date"
            },
            "rowSource": {
                "kind": "json"
            },
            "schemaFingerprint": {
                "kind": "text"
            },
            "status": {
                "kind": "enum",
                "values": [
                    "draft",
                    "published",
                    "retired"
                ]
            },
            "targetEntityType": {
                "kind": "enum",
                "values": [
                    "Asset",
                    "Vulnerability"
                ]
            },
            "version": {
                "kind": "number"
            }
        },
        "integrationProviderDefinition": {
            "actions": {
                "kind": "json"
            },
            "authScheme": {
                "kind": "enum",
                "values": [
                    "api-keys-header",
                    "bearer",
                    "basic",
                    "api-key-header",
                    "custom"
                ]
            },
            "capabilities": {
                "kind": "json"
            },
            "configFields": {
                "kind": "json"
            },
            "credentialFields": {
                "kind": "json"
            },
            "description": {
                "kind": "json"
            },
            "isActive": {
                "kind": "boolean"
            },
            "isCurrent": {
                "kind": "boolean"
            },
            "key": {
                "kind": "text"
            },
            "label": {
                "kind": "json"
            },
            "manifestDigest": {
                "kind": "text"
            },
            "publishedAt": {
                "kind": "date"
            },
            "resources": {
                "kind": "json"
            },
            "status": {
                "kind": "enum",
                "values": [
                    "draft",
                    "published",
                    "retired"
                ]
            },
            "version": {
                "kind": "number"
            }
        },
        "integrationSyncState": {
            "backoffMs": {
                "kind": "number"
            },
            "checkpoint": {
                "kind": "json"
            },
            "connectionId": {
                "kind": "ref",
                "refEntity": "integrationConnection"
            },
            "cron": {
                "kind": "text"
            },
            "cursor": {
                "kind": "json"
            },
            "failureCount": {
                "kind": "number"
            },
            "firstRunAt": {
                "kind": "date"
            },
            "highWatermark": {
                "kind": "json"
            },
            "intervalUnit": {
                "kind": "enum",
                "values": [
                    "minute",
                    "hour",
                    "day",
                    "week"
                ]
            },
            "intervalValue": {
                "kind": "number"
            },
            "isPaused": {
                "kind": "boolean"
            },
            "lastHeartbeatAt": {
                "kind": "date"
            },
            "lastRunAt": {
                "kind": "date"
            },
            "lastSuccessAt": {
                "kind": "date"
            },
            "leaseExpiresAt": {
                "kind": "date"
            },
            "leaseOwner": {
                "kind": "text"
            },
            "leaseToken": {
                "kind": "text"
            },
            "mappingId": {
                "kind": "ref",
                "refEntity": "integrationMapping"
            },
            "mappingKey": {
                "kind": "text"
            },
            "mappingVersion": {
                "kind": "number"
            },
            "nextRunAt": {
                "kind": "date"
            },
            "pauseReason": {
                "kind": "text"
            },
            "periodType": {
                "kind": "enum",
                "values": [
                    "once",
                    "periodic"
                ]
            },
            "retryAt": {
                "kind": "date"
            },
            "scheduleClaimExpiresAt": {
                "kind": "date"
            },
            "scheduleClaimToken": {
                "kind": "text"
            },
            "timezone": {
                "kind": "text"
            }
        },
        "integrationTransferItem": {
            "candidateSnapshot": {
                "kind": "json"
            },
            "conflictFields": {
                "kind": "json"
            },
            "conflictResolution": {
                "kind": "json"
            },
            "connectionId": {
                "kind": "ref",
                "refEntity": "integrationConnection"
            },
            "errorMessage": {
                "kind": "text"
            },
            "expiresAt": {
                "kind": "date"
            },
            "externalId": {
                "kind": "text"
            },
            "externalIdHash": {
                "kind": "text"
            },
            "identityLinkId": {
                "kind": "ref",
                "refEntity": "integrationExternalIdentityLink"
            },
            "mappingId": {
                "kind": "ref",
                "refEntity": "integrationMapping"
            },
            "outcome": {
                "kind": "enum",
                "values": [
                    "create",
                    "update",
                    "unchanged",
                    "skip",
                    "conflict",
                    "invalid",
                    "failed"
                ]
            },
            "resolvedAt": {
                "kind": "date"
            },
            "resolvedBy": {
                "kind": "ref",
                "refEntity": "user"
            },
            "rowIndex": {
                "kind": "number"
            },
            "runId": {
                "kind": "ref",
                "refEntity": "integrationTransferRun"
            },
            "sourceSnapshot": {
                "kind": "json"
            },
            "targetEntityId": {
                "kind": "ref"
            },
            "targetEntityType": {
                "kind": "enum",
                "values": [
                    "Asset",
                    "Vulnerability"
                ]
            },
            "validationErrors": {
                "kind": "json"
            }
        },
        "integrationTransferRun": {
            "checkpointAfter": {
                "kind": "json"
            },
            "checkpointBefore": {
                "kind": "json"
            },
            "connectionId": {
                "kind": "ref",
                "refEntity": "integrationConnection"
            },
            "correlationId": {
                "kind": "text"
            },
            "counters": {
                "kind": "json"
            },
            "errorSummary": {
                "kind": "json"
            },
            "expiresAt": {
                "kind": "date"
            },
            "finishedAt": {
                "kind": "date"
            },
            "idempotencyKey": {
                "kind": "text"
            },
            "kind": {
                "kind": "enum",
                "values": [
                    "sample",
                    "preview",
                    "import",
                    "sync",
                    "webhook",
                    "reconcile"
                ]
            },
            "mappingId": {
                "kind": "ref",
                "refEntity": "integrationMapping"
            },
            "mappingKey": {
                "kind": "text"
            },
            "mappingVersion": {
                "kind": "number"
            },
            "previewTokenHash": {
                "kind": "text"
            },
            "providerKey": {
                "kind": "text"
            },
            "providerVersion": {
                "kind": "number"
            },
            "retrySummary": {
                "kind": "json"
            },
            "schemaFingerprint": {
                "kind": "text"
            },
            "startedAt": {
                "kind": "date"
            },
            "status": {
                "kind": "enum",
                "values": [
                    "queued",
                    "running",
                    "succeeded",
                    "failed",
                    "cancelled",
                    "partial"
                ]
            },
            "trigger": {
                "kind": "enum",
                "values": [
                    "manual",
                    "schedule",
                    "webhook",
                    "replay",
                    "system"
                ]
            }
        },
        "integrationWebhookReceipt": {
            "connectionId": {
                "kind": "ref",
                "refEntity": "integrationConnection"
            },
            "dedupeKey": {
                "kind": "text"
            },
            "errorMessage": {
                "kind": "text"
            },
            "expiresAt": {
                "kind": "date"
            },
            "headersSample": {
                "kind": "json"
            },
            "payloadSample": {
                "kind": "json"
            },
            "processedAt": {
                "kind": "date"
            },
            "processingStatus": {
                "kind": "enum",
                "values": [
                    "received",
                    "queued",
                    "processed",
                    "failed",
                    "duplicate"
                ]
            },
            "providerEventId": {
                "kind": "text"
            },
            "receivedAt": {
                "kind": "date"
            },
            "runId": {
                "kind": "ref",
                "refEntity": "integrationTransferRun"
            },
            "signatureStatus": {
                "kind": "enum",
                "values": [
                    "valid",
                    "invalid",
                    "missing"
                ]
            },
            "webhookIngressId": {
                "kind": "text"
            }
        },
        "interestedParty": {
            "category": {
                "kind": "text"
            },
            "code": {
                "kind": "text"
            },
            "communicationFrequency": {
                "kind": "text"
            },
            "communicationMethod": {
                "kind": "text"
            },
            "contactEmail": {
                "kind": "text"
            },
            "contactPerson": {
                "kind": "text"
            },
            "evidenceDocumentId": {
                "kind": "ref",
                "refEntity": "document"
            },
            "expectations": {
                "kind": "text"
            },
            "name": {
                "kind": "text"
            },
            "obligations": {
                "kind": "text"
            },
            "status": {
                "kind": "enum",
                "values": [
                    "active",
                    "inactive"
                ]
            },
            "type": {
                "kind": "enum",
                "values": [
                    "internal",
                    "external"
                ]
            }
        },
        "internationalTransfer": {
            "boardNotificationDate": {
                "kind": "date"
            },
            "boardNotificationNumber": {
                "kind": "text"
            },
            "code": {
                "kind": "text"
            },
            "description": {
                "kind": "text"
            },
            "mechanism": {
                "kind": "enum",
                "values": [
                    "ssc",
                    "board_notification",
                    "bcr",
                    "explicit_consent",
                    "adequacy_decision",
                    "undertaking",
                    "public_agreement",
                    "incidental"
                ]
            },
            "name": {
                "kind": "text"
            },
            "purpose": {
                "kind": "text"
            },
            "recipientCountry": {
                "kind": "text"
            },
            "recipientName": {
                "kind": "text"
            },
            "safeguards": {
                "kind": "json"
            },
            "sscNotificationDeadline": {
                "kind": "date"
            },
            "sscNotificationSentAt": {
                "kind": "date"
            },
            "sscSignedAt": {
                "kind": "date"
            },
            "sscText": {
                "kind": "text"
            },
            "status": {
                "kind": "enum",
                "values": [
                    "active",
                    "inactive"
                ]
            }
        },
        "kpi": {
            "category": {
                "kind": "text"
            },
            "currentValue": {
                "kind": "number"
            },
            "dataSource": {
                "kind": "text"
            },
            "description": {
                "kind": "text"
            },
            "formula": {
                "kind": "text"
            },
            "frequency": {
                "kind": "enum",
                "values": [
                    "daily",
                    "weekly",
                    "monthly",
                    "quarterly",
                    "annually"
                ]
            },
            "name": {
                "kind": "text"
            },
            "owner": {
                "kind": "ref",
                "refEntity": "user"
            },
            "responsible": {
                "kind": "text"
            },
            "status": {
                "kind": "enum",
                "values": [
                    "active",
                    "inactive"
                ]
            },
            "targetValue": {
                "kind": "number"
            },
            "unit": {
                "kind": "text"
            },
            "values": {
                "kind": "json"
            }
        },
        "kvkkCompany": {
            "description": {
                "kind": "text"
            },
            "documentApprover": {
                "kind": "json"
            },
            "domesticDataController": {
                "kind": "json"
            },
            "foreignDataController": {
                "kind": "json"
            },
            "foreignDataControllerRepresentative": {
                "kind": "json"
            },
            "kvkkTeam": {
                "kind": "json"
            },
            "name": {
                "kind": "text"
            },
            "publicInstitution": {
                "kind": "json"
            },
            "status": {
                "kind": "enum",
                "values": [
                    "active",
                    "inactive"
                ]
            },
            "verbis": {
                "kind": "json"
            }
        },
        "ldapRoleMapping": {
            "matchType": {
                "kind": "enum",
                "values": [
                    "exact",
                    "contains"
                ]
            },
            "pattern": {
                "kind": "text"
            },
            "roleIds": {
                "kind": "json"
            },
            "sourceAttribute": {
                "kind": "enum",
                "values": [
                    "memberOf",
                    "title"
                ]
            }
        },
        "legalReason": {
            "article": {
                "kind": "text"
            },
            "code": {
                "kind": "text"
            },
            "description": {
                "kind": "text"
            },
            "forSensitiveData": {
                "kind": "boolean"
            },
            "jurisdiction": {
                "kind": "enum",
                "values": [
                    "kvkk",
                    "gdpr"
                ]
            },
            "lawArticle": {
                "kind": "text"
            },
            "metadata": {
                "kind": "json"
            },
            "name": {
                "kind": "text"
            },
            "scope": {
                "kind": "enum",
                "values": [
                    "m5",
                    "m6",
                    "art6",
                    "art9",
                    "other"
                ]
            },
            "status": {
                "kind": "enum",
                "values": [
                    "active",
                    "inactive"
                ]
            }
        },
        "lessonLearned": {
            "actionId": {
                "kind": "ref",
                "refEntity": "action"
            },
            "category": {
                "kind": "enum",
                "values": [
                    "communication",
                    "technology",
                    "people",
                    "logistics",
                    "process",
                    "vendor",
                    "external",
                    "safety",
                    "infrastructure"
                ]
            },
            "details": {
                "kind": "text"
            },
            "exerciseId": {
                "kind": "ref",
                "refEntity": "exercise"
            }
        },
        "mailTemplate": {
            "body": {
                "kind": "text"
            },
            "category": {
                "kind": "text"
            },
            "code": {
                "kind": "text"
            },
            "isSystem": {
                "kind": "boolean"
            },
            "name": {
                "kind": "text"
            },
            "status": {
                "kind": "enum",
                "values": [
                    "active",
                    "inactive"
                ]
            },
            "subject": {
                "kind": "text"
            },
            "variables": {
                "kind": "json"
            }
        },
        "matrixConfiguration": {
            "ciaMatrix": {
                "kind": "json"
            },
            "demoSeedTag": {
                "kind": "text"
            },
            "narrativeTag": {
                "kind": "text"
            },
            "riskMatrix": {
                "kind": "json"
            }
        },
        "meeting": {
            "additionalAgenda": {
                "kind": "text"
            },
            "additionalParticipants": {
                "kind": "text"
            },
            "agenda": {
                "kind": "text"
            },
            "attendees": {
                "kind": "json"
            },
            "code": {
                "kind": "text"
            },
            "date": {
                "kind": "text"
            },
            "decisions": {
                "kind": "text"
            },
            "description": {
                "kind": "text"
            },
            "duration": {
                "kind": "text"
            },
            "endTime": {
                "kind": "text"
            },
            "isManagementReview": {
                "kind": "boolean"
            },
            "location": {
                "kind": "text"
            },
            "meetingLink": {
                "kind": "text"
            },
            "minutes": {
                "kind": "text"
            },
            "organizer": {
                "kind": "ref",
                "refEntity": "user"
            },
            "participants": {
                "kind": "text"
            },
            "previousReviewActions": {
                "kind": "json"
            },
            "reviewInputs": {
                "kind": "json"
            },
            "reviewScope": {
                "kind": "json"
            },
            "scheduledDate": {
                "kind": "date"
            },
            "startTime": {
                "kind": "text"
            },
            "status": {
                "kind": "enum",
                "values": [
                    "scheduled",
                    "in-progress",
                    "completed",
                    "cancelled"
                ]
            },
            "title": {
                "kind": "text"
            },
            "topicsDiscussed": {
                "kind": "text"
            },
            "type": {
                "kind": "enum",
                "values": [
                    "management-review",
                    "audit",
                    "risk-review",
                    "incident-review",
                    "training",
                    "other"
                ]
            }
        },
        "notification": {
            "actionUrl": {
                "kind": "text"
            },
            "body": {
                "kind": "text"
            },
            "contentChecksum": {
                "kind": "text"
            },
            "correlationId": {
                "kind": "text"
            },
            "data": {
                "kind": "json"
            },
            "deliveryIntentId": {
                "kind": "ref",
                "refEntity": "notificationDeliveryIntent"
            },
            "dispatchId": {
                "kind": "ref",
                "refEntity": "notificationDispatch"
            },
            "eventId": {
                "kind": "text"
            },
            "expiresAt": {
                "kind": "date"
            },
            "imageUrl": {
                "kind": "text"
            },
            "policyCode": {
                "kind": "text"
            },
            "policyRevisionId": {
                "kind": "ref",
                "refEntity": "notificationPolicyRevision"
            },
            "read": {
                "kind": "boolean"
            },
            "readAt": {
                "kind": "date"
            },
            "tags": {
                "kind": "json"
            },
            "tenantId": {
                "kind": "ref",
                "refEntity": "tenant"
            },
            "title": {
                "kind": "text"
            },
            "type": {
                "kind": "text"
            },
            "userId": {
                "kind": "ref",
                "refEntity": "user"
            }
        },
        "notificationDeliveryIntent": {
            "attemptNumber": {
                "kind": "number"
            },
            "channel": {
                "kind": "enum",
                "values": [
                    "email",
                    "sms",
                    "push",
                    "in-app",
                    "socket"
                ]
            },
            "claimOwner": {
                "kind": "text"
            },
            "claimToken": {
                "kind": "text"
            },
            "dispatchId": {
                "kind": "ref",
                "refEntity": "notificationDispatch"
            },
            "eventId": {
                "kind": "text"
            },
            "externalRecipientId": {
                "kind": "text"
            },
            "externalRecipientKind": {
                "kind": "text"
            },
            "lastError": {
                "kind": "text"
            },
            "lastHeartbeatAt": {
                "kind": "date"
            },
            "latestReceiptId": {
                "kind": "ref",
                "refEntity": "deliveryReceipt"
            },
            "leaseExpiresAt": {
                "kind": "date"
            },
            "nextAttemptAt": {
                "kind": "date"
            },
            "policyRevisionId": {
                "kind": "ref",
                "refEntity": "notificationPolicyRevision"
            },
            "providerCallStartedAt": {
                "kind": "date"
            },
            "providerIdempotencyKey": {
                "kind": "text"
            },
            "providerReferenceId": {
                "kind": "text"
            },
            "reasonCode": {
                "kind": "text"
            },
            "recipientType": {
                "kind": "enum",
                "values": [
                    "user",
                    "external"
                ]
            },
            "redactedAt": {
                "kind": "date"
            },
            "redactionVersion": {
                "kind": "number"
            },
            "scheduleReason": {
                "kind": "text"
            },
            "state": {
                "kind": "enum",
                "values": [
                    "pending",
                    "processing",
                    "scheduled",
                    "sent",
                    "suppressed",
                    "failed",
                    "unknown",
                    "cancelled"
                ]
            },
            "tenantId": {
                "kind": "ref",
                "refEntity": "tenant"
            },
            "terminalAt": {
                "kind": "date"
            },
            "userId": {
                "kind": "ref",
                "refEntity": "user"
            }
        },
        "notificationDigestItem": {
            "bucketKey": {
                "kind": "text"
            },
            "channel": {
                "kind": "enum",
                "values": [
                    "email",
                    "sms",
                    "push",
                    "in-app"
                ]
            },
            "digestCorrelationId": {
                "kind": "text"
            },
            "dispatchId": {
                "kind": "ref",
                "refEntity": "notificationDispatch"
            },
            "error": {
                "kind": "text"
            },
            "eventId": {
                "kind": "text"
            },
            "eventName": {
                "kind": "text"
            },
            "flushAfter": {
                "kind": "date"
            },
            "flushedAt": {
                "kind": "date"
            },
            "frequency": {
                "kind": "enum",
                "values": [
                    "hourly",
                    "daily",
                    "weekly"
                ]
            },
            "intentId": {
                "kind": "ref",
                "refEntity": "notificationDeliveryIntent"
            },
            "status": {
                "kind": "enum",
                "values": [
                    "pending",
                    "flushed",
                    "failed"
                ]
            },
            "summary": {
                "kind": "text"
            },
            "title": {
                "kind": "text"
            },
            "userId": {
                "kind": "ref",
                "refEntity": "user"
            }
        },
        "notificationDispatch": {
            "audienceTrace": {
                "kind": "json"
            },
            "causationId": {
                "kind": "text"
            },
            "channels": {
                "kind": "json"
            },
            "codeSendPayload": {
                "kind": "json"
            },
            "completedAt": {
                "kind": "date"
            },
            "conditionTrace": {
                "kind": "json"
            },
            "contentChecksum": {
                "kind": "text"
            },
            "contextAdapterVersion": {
                "kind": "number"
            },
            "contextChecksum": {
                "kind": "text"
            },
            "correlationId": {
                "kind": "text"
            },
            "deliveryClass": {
                "kind": "enum",
                "values": [
                    "required",
                    "actionable",
                    "informational"
                ]
            },
            "enqueuedAt": {
                "kind": "date"
            },
            "errorCode": {
                "kind": "text"
            },
            "errorDetails": {
                "kind": "json"
            },
            "eventId": {
                "kind": "text"
            },
            "eventName": {
                "kind": "text"
            },
            "externalRecipientRefs": {
                "kind": "json"
            },
            "kind": {
                "kind": "enum",
                "values": [
                    "event",
                    "test",
                    "preview",
                    "live-pilot"
                ]
            },
            "mode": {
                "kind": "enum",
                "values": [
                    "shadow",
                    "active"
                ]
            },
            "policy": {
                "kind": "ref",
                "refEntity": "notificationPolicy"
            },
            "policyCode": {
                "kind": "text"
            },
            "policyRevision": {
                "kind": "ref",
                "refEntity": "notificationPolicyRevision"
            },
            "priority": {
                "kind": "enum",
                "values": [
                    "low",
                    "normal",
                    "high",
                    "urgent"
                ]
            },
            "priorityRank": {
                "kind": "number"
            },
            "processingStartedAt": {
                "kind": "date"
            },
            "queueJobId": {
                "kind": "text"
            },
            "reasonCode": {
                "kind": "enum",
                "values": [
                    "TENANT_POLICY_OFF",
                    "NO_POLICY"
                ]
            },
            "recipientIds": {
                "kind": "json"
            },
            "redactedAt": {
                "kind": "date"
            },
            "redactionVersion": {
                "kind": "number"
            },
            "revisionChecksum": {
                "kind": "text"
            },
            "revisionSnapshot": {
                "kind": "json"
            },
            "safeContext": {
                "kind": "json"
            },
            "source": {
                "kind": "enum",
                "values": [
                    "policy",
                    "code"
                ]
            },
            "status": {
                "kind": "enum",
                "values": [
                    "no_match",
                    "blocked",
                    "suppressed",
                    "queued",
                    "processing",
                    "partial",
                    "delivered",
                    "failed"
                ]
            },
            "tenantSuppressionPolicy": {
                "kind": "ref",
                "refEntity": "notificationPolicy"
            },
            "testRequestFingerprint": {
                "kind": "text"
            }
        },
        "notificationPolicy": {
            "activeRevision": {
                "kind": "ref",
                "refEntity": "notificationPolicyRevision"
            },
            "allowTenantSuppression": {
                "kind": "boolean"
            },
            "baseSystemPolicyCode": {
                "kind": "text"
            },
            "code": {
                "kind": "text"
            },
            "customization": {
                "kind": "enum",
                "values": [
                    "locked",
                    "limited",
                    "full"
                ]
            },
            "description": {
                "kind": "json"
            },
            "isEnabled": {
                "kind": "boolean"
            },
            "latestRevisionNumber": {
                "kind": "number"
            },
            "name": {
                "kind": "json"
            },
            "origin": {
                "kind": "enum",
                "values": [
                    "system",
                    "tenant"
                ]
            },
            "tenantMode": {
                "kind": "enum",
                "values": [
                    "inherit",
                    "custom",
                    "off"
                ]
            }
        },
        "notificationPolicyRevision": {
            "audience": {
                "kind": "json"
            },
            "baseSystemChecksum": {
                "kind": "text"
            },
            "baseSystemRevision": {
                "kind": "ref",
                "refEntity": "notificationPolicyRevision"
            },
            "channels": {
                "kind": "json"
            },
            "checksum": {
                "kind": "text"
            },
            "condition": {
                "kind": "json"
            },
            "contentSnapshot": {
                "kind": "json"
            },
            "contentSource": {
                "kind": "json"
            },
            "deliveryClass": {
                "kind": "enum",
                "values": [
                    "required",
                    "actionable",
                    "informational"
                ]
            },
            "eventDefinitionVersion": {
                "kind": "number"
            },
            "eventName": {
                "kind": "text"
            },
            "policy": {
                "kind": "ref",
                "refEntity": "notificationPolicy"
            },
            "priority": {
                "kind": "enum",
                "values": [
                    "low",
                    "normal",
                    "high",
                    "urgent"
                ]
            },
            "publicationComment": {
                "kind": "text"
            },
            "publishedAt": {
                "kind": "date"
            },
            "publishedBy": {
                "kind": "ref",
                "refEntity": "user"
            },
            "recipientCap": {
                "kind": "number"
            },
            "restoredFromRevision": {
                "kind": "ref",
                "refEntity": "notificationPolicyRevision"
            },
            "revisionNumber": {
                "kind": "number"
            },
            "state": {
                "kind": "enum",
                "values": [
                    "draft",
                    "published"
                ]
            },
            "validationSummary": {
                "kind": "json"
            }
        },
        "notificationPolicyVerification": {
            "actor": {
                "kind": "ref",
                "refEntity": "user"
            },
            "contentChecksum": {
                "kind": "text"
            },
            "contextChecksum": {
                "kind": "text"
            },
            "draftRevision": {
                "kind": "ref",
                "refEntity": "notificationPolicyRevision"
            },
            "eventDefinitionChecksum": {
                "kind": "text"
            },
            "eventDefinitionVersion": {
                "kind": "number"
            },
            "eventName": {
                "kind": "text"
            },
            "expiresAt": {
                "kind": "date"
            },
            "outcome": {
                "kind": "enum",
                "values": [
                    "matched",
                    "no_match",
                    "blocked"
                ]
            },
            "policy": {
                "kind": "ref",
                "refEntity": "notificationPolicy"
            },
            "previewChecksum": {
                "kind": "text"
            },
            "revisionChecksum": {
                "kind": "text"
            },
            "rolloutMode": {
                "kind": "enum",
                "values": [
                    "off",
                    "active"
                ]
            },
            "sourceReference": {
                "kind": "text"
            },
            "sourceType": {
                "kind": "enum",
                "values": [
                    "synthetic",
                    "record",
                    "dispatch"
                ]
            }
        },
        "notificationPreference": {
            "channels": {
                "kind": "json"
            },
            "digestFrequency": {
                "kind": "enum",
                "values": [
                    "immediately",
                    "hourly",
                    "daily",
                    "weekly"
                ]
            },
            "doNotDisturb": {
                "kind": "boolean"
            },
            "tenantId": {
                "kind": "ref",
                "refEntity": "tenant"
            },
            "userId": {
                "kind": "ref",
                "refEntity": "user"
            }
        },
        "notificationTemplate": {
            "category": {
                "kind": "text"
            },
            "code": {
                "kind": "text"
            },
            "defaultLocale": {
                "kind": "enum",
                "values": [
                    "tr",
                    "en"
                ]
            },
            "isSystem": {
                "kind": "boolean"
            },
            "name": {
                "kind": "json"
            },
            "status": {
                "kind": "enum",
                "values": [
                    "active",
                    "inactive"
                ]
            },
            "variables": {
                "kind": "json"
            },
            "variants": {
                "kind": "json"
            }
        },
        "objective": {
            "code": {
                "kind": "text"
            },
            "description": {
                "kind": "text"
            },
            "endDate": {
                "kind": "date"
            },
            "objectiveName": {
                "kind": "text"
            },
            "relatedInitiatives": {
                "kind": "json"
            },
            "relatedKpis": {
                "kind": "json"
            },
            "relatedRisks": {
                "kind": "json"
            },
            "relatedTreatments": {
                "kind": "json"
            },
            "startDate": {
                "kind": "date"
            },
            "status": {
                "kind": "text"
            },
            "unitId": {
                "kind": "ref",
                "refEntity": "unit"
            }
        },
        "operationalRun": {
            "cancelledAt": {
                "kind": "date"
            },
            "code": {
                "kind": "text"
            },
            "completedAt": {
                "kind": "date"
            },
            "completionSummary": {
                "kind": "text"
            },
            "controllerUserIds": {
                "kind": "json"
            },
            "evidenceBytes": {
                "kind": "number"
            },
            "evidenceFileCount": {
                "kind": "number"
            },
            "memberSnapshots": {
                "kind": "json"
            },
            "notifyUserIds": {
                "kind": "json"
            },
            "participantUserIds": {
                "kind": "json"
            },
            "partyInstanceId": {
                "kind": "ref",
                "refEntity": "partyInstance"
            },
            "pausedAt": {
                "kind": "date"
            },
            "resumedAt": {
                "kind": "date"
            },
            "source": {
                "kind": "ref"
            },
            "sourceCode": {
                "kind": "text"
            },
            "sourceTitle": {
                "kind": "text"
            },
            "sourceType": {
                "kind": "enum",
                "values": [
                    "CrisisEvent",
                    "Exercise"
                ]
            },
            "startedAt": {
                "kind": "date"
            },
            "startedBy": {
                "kind": "ref",
                "refEntity": "user"
            },
            "status": {
                "kind": "enum",
                "values": [
                    "active",
                    "paused",
                    "completed",
                    "cancelled"
                ]
            },
            "terminalReason": {
                "kind": "text"
            }
        },
        "operationalRunTask": {
            "assignedDutyDefinitionId": {
                "kind": "ref",
                "refEntity": "dutyDefinition"
            },
            "assignedTeamId": {
                "kind": "ref",
                "refEntity": "team"
            },
            "assignedUserId": {
                "kind": "ref",
                "refEntity": "user"
            },
            "assignedUserIds": {
                "kind": "json"
            },
            "cancelledAt": {
                "kind": "date"
            },
            "completedAt": {
                "kind": "date"
            },
            "completedBy": {
                "kind": "ref",
                "refEntity": "user"
            },
            "completionCriteria": {
                "kind": "json"
            },
            "completionNote": {
                "kind": "text"
            },
            "deadlineWarningNotifiedAt": {
                "kind": "date"
            },
            "dependenciesOverridden": {
                "kind": "boolean"
            },
            "dependencyOverriddenAt": {
                "kind": "date"
            },
            "dependencyOverriddenBy": {
                "kind": "ref",
                "refEntity": "user"
            },
            "dependencyOverrideReason": {
                "kind": "text"
            },
            "dependencyTaskKeys": {
                "kind": "json"
            },
            "description": {
                "kind": "json"
            },
            "dueAt": {
                "kind": "date"
            },
            "evidenceBytes": {
                "kind": "number"
            },
            "evidenceFileCount": {
                "kind": "number"
            },
            "executionMode": {
                "kind": "enum",
                "values": [
                    "sequential",
                    "parallel"
                ]
            },
            "expectedDuration": {
                "kind": "json"
            },
            "originalResponsibleMemberKey": {
                "kind": "text"
            },
            "originalResponsibleSnapshotMemberId": {
                "kind": "text"
            },
            "overdueNotifiedAt": {
                "kind": "date"
            },
            "readyAt": {
                "kind": "date"
            },
            "reassignedAt": {
                "kind": "date"
            },
            "reassignedBy": {
                "kind": "ref",
                "refEntity": "user"
            },
            "reassignmentReason": {
                "kind": "text"
            },
            "responsibleMemberKey": {
                "kind": "text"
            },
            "responsibleSnapshotMemberId": {
                "kind": "text"
            },
            "run": {
                "kind": "ref",
                "refEntity": "operationalRun"
            },
            "sequence": {
                "kind": "number"
            },
            "sourceAssignmentId": {
                "kind": "ref",
                "refEntity": "teamAssignment"
            },
            "sourceTaskKey": {
                "kind": "text"
            },
            "startedAt": {
                "kind": "date"
            },
            "status": {
                "kind": "enum",
                "values": [
                    "blocked",
                    "ready",
                    "in_progress",
                    "completed",
                    "cancelled"
                ]
            },
            "targetCompletion": {
                "kind": "json"
            },
            "taskKey": {
                "kind": "text"
            },
            "title": {
                "kind": "json"
            },
            "warningAt": {
                "kind": "date"
            },
            "warningBefore": {
                "kind": "json"
            }
        },
        "operationalRunTaskEvidence": {
            "mimeType": {
                "kind": "text"
            },
            "originalFileName": {
                "kind": "text"
            },
            "run": {
                "kind": "ref",
                "refEntity": "operationalRun"
            },
            "sha256": {
                "kind": "text"
            },
            "size": {
                "kind": "number"
            },
            "storageKey": {
                "kind": "text"
            },
            "task": {
                "kind": "ref",
                "refEntity": "operationalRunTask"
            },
            "uploadedAt": {
                "kind": "date"
            },
            "uploaderId": {
                "kind": "ref",
                "refEntity": "user"
            },
            "uploaderSnapshot": {
                "kind": "json"
            }
        },
        "operationalRunUpdate": {
            "actorUserId": {
                "kind": "ref",
                "refEntity": "user"
            },
            "message": {
                "kind": "text"
            },
            "run": {
                "kind": "ref",
                "refEntity": "operationalRun"
            },
            "task": {
                "kind": "ref",
                "refEntity": "operationalRunTask"
            },
            "type": {
                "kind": "enum",
                "values": [
                    "general",
                    "progress",
                    "blocker",
                    "decision"
                ]
            }
        },
        "outboxEvent": {
            "attempts": {
                "kind": "number"
            },
            "availableAt": {
                "kind": "date"
            },
            "data": {
                "kind": "json"
            },
            "envelopeId": {
                "kind": "text"
            },
            "error": {
                "kind": "text"
            },
            "lastError": {
                "kind": "text"
            },
            "leaseExpiresAt": {
                "kind": "date"
            },
            "leasedBy": {
                "kind": "text"
            },
            "meta": {
                "kind": "json"
            },
            "nextRetryAt": {
                "kind": "date"
            },
            "publishedAt": {
                "kind": "date"
            },
            "redactedAt": {
                "kind": "date"
            },
            "redactionVersion": {
                "kind": "number"
            },
            "status": {
                "kind": "enum",
                "values": [
                    "pending",
                    "processing",
                    "published",
                    "failed"
                ]
            },
            "targetTransports": {
                "kind": "json"
            },
            "tenantId": {
                "kind": "json"
            },
            "type": {
                "kind": "text"
            }
        },
        "partyInstance": {
            "assignments": {
                "kind": "json"
            },
            "entityId": {
                "kind": "ref"
            },
            "entityType": {
                "kind": "text"
            },
            "templateCode": {
                "kind": "text"
            },
            "templateId": {
                "kind": "ref",
                "refEntity": "partyTemplate"
            },
            "templateVersion": {
                "kind": "number"
            }
        },
        "partyTemplate": {
            "code": {
                "kind": "text"
            },
            "description": {
                "kind": "json"
            },
            "entityType": {
                "kind": "text"
            },
            "isActive": {
                "kind": "boolean"
            },
            "isSystemDefault": {
                "kind": "boolean"
            },
            "name": {
                "kind": "json"
            },
            "publishedAt": {
                "kind": "date"
            },
            "publishedBy": {
                "kind": "ref",
                "refEntity": "user"
            },
            "roles": {
                "kind": "json"
            },
            "version": {
                "kind": "number"
            }
        },
        "patchNote": {
            "changes": {
                "kind": "json"
            },
            "isLatest": {
                "kind": "boolean"
            },
            "version": {
                "kind": "text"
            }
        },
        "personalDataCategory": {
            "code": {
                "kind": "text"
            },
            "dataType": {
                "kind": "enum",
                "values": [
                    "genel",
                    "ozel",
                    "irk_etnik",
                    "siyasi",
                    "din_inanc",
                    "kilik_kiyafet",
                    "uyelik",
                    "saglik",
                    "cinsel_hayat",
                    "ceza",
                    "biyometrik",
                    "genetik"
                ]
            },
            "description": {
                "kind": "text"
            },
            "examples": {
                "kind": "json"
            },
            "isSpecialQualified": {
                "kind": "boolean"
            },
            "legalBasis": {
                "kind": "text"
            },
            "name": {
                "kind": "text"
            },
            "orderIndex": {
                "kind": "number"
            },
            "parentId": {
                "kind": "ref",
                "refEntity": "personalDataCategory"
            },
            "retentionPeriod": {
                "kind": "text"
            },
            "status": {
                "kind": "enum",
                "values": [
                    "active",
                    "inactive"
                ]
            }
        },
        "personalDataInventory": {
            "activity": {
                "kind": "text"
            },
            "activityCode": {
                "kind": "text"
            },
            "asset": {
                "kind": "ref",
                "refEntity": "asset"
            },
            "availabilityValue": {
                "kind": "text"
            },
            "buyerGroupId": {
                "kind": "ref",
                "refEntity": "recipientGroup"
            },
            "collectionMethod": {
                "kind": "text"
            },
            "collectionMethodId": {
                "kind": "ref",
                "refEntity": "collectionMethod"
            },
            "confidentialityValue": {
                "kind": "text"
            },
            "degreeOfConfidentiality": {
                "kind": "text"
            },
            "description": {
                "kind": "text"
            },
            "disclosureObligation": {
                "kind": "boolean"
            },
            "explicitConsentObligation": {
                "kind": "boolean"
            },
            "integrityValue": {
                "kind": "text"
            },
            "internationalTransfer": {
                "kind": "boolean"
            },
            "internationalTransferIds": {
                "kind": "json"
            },
            "legalCauses": {
                "kind": "text"
            },
            "legalReasonId": {
                "kind": "ref",
                "refEntity": "legalReason"
            },
            "partyInstanceId": {
                "kind": "ref",
                "refEntity": "partyInstance"
            },
            "personalData": {
                "kind": "text"
            },
            "personalDataCategoryId": {
                "kind": "ref",
                "refEntity": "personalDataCategory"
            },
            "personalDataCategoryIds": {
                "kind": "json"
            },
            "personalDataLocation": {
                "kind": "text"
            },
            "personalDataSource": {
                "kind": "text"
            },
            "processingPurpose": {
                "kind": "text"
            },
            "processingPurposeId": {
                "kind": "ref",
                "refEntity": "processingPurpose"
            },
            "purchaserGroup": {
                "kind": "text"
            },
            "recipientGroup": {
                "kind": "text"
            },
            "recipientGroupId": {
                "kind": "ref",
                "refEntity": "recipientGroup"
            },
            "relatedAssets": {
                "kind": "json"
            },
            "retentionDuration": {
                "kind": "text"
            },
            "retentionPeriodId": {
                "kind": "ref",
                "refEntity": "privacyRetentionPeriod"
            },
            "retentionReason": {
                "kind": "text"
            },
            "retentionStartDate": {
                "kind": "date"
            },
            "securityMeasures": {
                "kind": "json"
            },
            "status": {
                "kind": "enum",
                "values": [
                    "active",
                    "inactive",
                    "draft"
                ]
            },
            "storageEnvironment": {
                "kind": "text"
            },
            "subjectPersonGroup": {
                "kind": "text"
            },
            "subjectPersonGroupId": {
                "kind": "ref",
                "refEntity": "subjectPersonGroup"
            },
            "transferCountries": {
                "kind": "json"
            },
            "transferSafeguards": {
                "kind": "text"
            },
            "unit": {
                "kind": "ref",
                "refEntity": "unit"
            }
        },
        "privacyNotice": {
            "archivedAt": {
                "kind": "date"
            },
            "body": {
                "kind": "text"
            },
            "channels": {
                "kind": "json"
            },
            "code": {
                "kind": "text"
            },
            "confirmedElements": {
                "kind": "json"
            },
            "description": {
                "kind": "text"
            },
            "effectiveDate": {
                "kind": "date"
            },
            "elementChecklist": {
                "kind": "json"
            },
            "language": {
                "kind": "enum",
                "values": [
                    "tr",
                    "en"
                ]
            },
            "linkedInventoryItems": {
                "kind": "json"
            },
            "linkedProcessingActivities": {
                "kind": "json"
            },
            "needsReview": {
                "kind": "boolean"
            },
            "needsReviewReason": {
                "kind": "text"
            },
            "noticeType": {
                "kind": "enum",
                "values": [
                    "genel",
                    "calisan",
                    "musteri",
                    "ziyaretci",
                    "kamera",
                    "web_sitesi",
                    "cerez",
                    "tedarikci",
                    "diger"
                ]
            },
            "partyInstanceId": {
                "kind": "ref",
                "refEntity": "partyInstance"
            },
            "previousVersionId": {
                "kind": "ref",
                "refEntity": "privacyNotice"
            },
            "publishedAt": {
                "kind": "date"
            },
            "status": {
                "kind": "enum",
                "values": [
                    "draft",
                    "in_review",
                    "published",
                    "archived"
                ]
            },
            "title": {
                "kind": "text"
            },
            "version": {
                "kind": "number"
            }
        },
        "privacyPrinciple": {
            "checklist": {
                "kind": "json"
            },
            "code": {
                "kind": "text"
            },
            "description": {
                "kind": "text"
            },
            "name": {
                "kind": "text"
            },
            "order": {
                "kind": "number"
            },
            "status": {
                "kind": "enum",
                "values": [
                    "active",
                    "inactive"
                ]
            }
        },
        "problem": {
            "description": {
                "kind": "text"
            },
            "isKnownError": {
                "kind": "boolean"
            },
            "knownErrorPublishedAt": {
                "kind": "date"
            },
            "priority": {
                "kind": "enum",
                "values": [
                    "low",
                    "medium",
                    "high",
                    "critical"
                ]
            },
            "relatedTicket": {
                "kind": "ref",
                "refEntity": "ticket"
            },
            "relatedTicketId": {
                "kind": "ref",
                "refEntity": "ticket"
            },
            "rootCause": {
                "kind": "ref",
                "refEntity": "rootCause"
            },
            "serviceCatalogItem": {
                "kind": "ref",
                "refEntity": "serviceCatalogItem"
            },
            "status": {
                "kind": "enum",
                "values": [
                    "open",
                    "investigating",
                    "resolved",
                    "closed"
                ]
            },
            "title": {
                "kind": "text"
            },
            "workaround": {
                "kind": "text"
            }
        },
        "problemCandidate": {
            "cooldownUntil": {
                "kind": "date"
            },
            "createdProblemId": {
                "kind": "ref",
                "refEntity": "problem"
            },
            "dismissedAt": {
                "kind": "date"
            },
            "groupingKey": {
                "kind": "text"
            },
            "matchedProblem": {
                "kind": "ref",
                "refEntity": "problem"
            },
            "serviceCatalogItem": {
                "kind": "ref",
                "refEntity": "serviceCatalogItem"
            },
            "status": {
                "kind": "enum",
                "values": [
                    "open",
                    "accepted",
                    "dismissed",
                    "expired"
                ]
            },
            "ticketCount": {
                "kind": "number"
            },
            "ticketIds": {
                "kind": "json"
            },
            "type": {
                "kind": "enum",
                "values": [
                    "known_error_match",
                    "open_problem_match",
                    "volume_cluster"
                ]
            },
            "windowEnd": {
                "kind": "date"
            },
            "windowStart": {
                "kind": "date"
            }
        },
        "process": {
            "assets": {
                "kind": "json"
            },
            "bcps": {
                "kind": "json"
            },
            "bias": {
                "kind": "json"
            },
            "code": {
                "kind": "text"
            },
            "crisisEvents": {
                "kind": "json"
            },
            "criticality": {
                "kind": "enum",
                "values": [
                    "low",
                    "medium",
                    "high",
                    "critical"
                ]
            },
            "description": {
                "kind": "text"
            },
            "mtpd": {
                "kind": "text"
            },
            "name": {
                "kind": "text"
            },
            "processOwner": {
                "kind": "ref",
                "refEntity": "user"
            },
            "relatedObligations": {
                "kind": "json"
            },
            "rpo": {
                "kind": "text"
            },
            "rto": {
                "kind": "text"
            },
            "unit": {
                "kind": "ref",
                "refEntity": "unit"
            }
        },
        "processingPurpose": {
            "code": {
                "kind": "text"
            },
            "description": {
                "kind": "text"
            },
            "examples": {
                "kind": "json"
            },
            "legalBasis": {
                "kind": "text"
            },
            "name": {
                "kind": "text"
            },
            "status": {
                "kind": "enum",
                "values": [
                    "active",
                    "inactive"
                ]
            }
        },
        "recipientGroup": {
            "code": {
                "kind": "text"
            },
            "country": {
                "kind": "text"
            },
            "description": {
                "kind": "text"
            },
            "examples": {
                "kind": "json"
            },
            "name": {
                "kind": "text"
            },
            "status": {
                "kind": "enum",
                "values": [
                    "active",
                    "inactive"
                ]
            },
            "type": {
                "kind": "enum",
                "values": [
                    "ic",
                    "dis",
                    "kamu",
                    "tedarikci"
                ]
            }
        },
        "recoveryResources": {
            "availability": {
                "kind": "json"
            },
            "bias": {
                "kind": "json"
            },
            "contingency": {
                "kind": "text"
            },
            "crisisEvents": {
                "kind": "json"
            },
            "criticality": {
                "kind": "text"
            },
            "details": {
                "kind": "text"
            },
            "gap": {
                "kind": "number"
            },
            "linkTo": {
                "kind": "ref",
                "refEntity": "process"
            },
            "name": {
                "kind": "text"
            },
            "normalLevel": {
                "kind": "json"
            },
            "other": {
                "kind": "text"
            },
            "owner": {
                "kind": "ref",
                "refEntity": "user"
            },
            "req1w": {
                "kind": "number"
            },
            "req24h": {
                "kind": "number"
            },
            "req2d": {
                "kind": "number"
            },
            "req2h": {
                "kind": "number"
            },
            "req8h": {
                "kind": "number"
            },
            "reqOther": {
                "kind": "text"
            },
            "status": {
                "kind": "enum",
                "values": [
                    "active",
                    "inactive"
                ]
            },
            "t1w": {
                "kind": "text"
            },
            "t24h": {
                "kind": "text"
            },
            "t2d": {
                "kind": "text"
            },
            "t2h": {
                "kind": "text"
            },
            "t8h": {
                "kind": "text"
            },
            "type": {
                "kind": "text"
            }
        },
        "regulatoryClause": {
            "clauseCode": {
                "kind": "text"
            },
            "fullText": {
                "kind": "text"
            },
            "orderIndex": {
                "kind": "number"
            },
            "source": {
                "kind": "ref",
                "refEntity": "regulatorySource"
            },
            "status": {
                "kind": "enum",
                "values": [
                    "active",
                    "inactive",
                    "draft"
                ]
            },
            "summary": {
                "kind": "text"
            },
            "tags": {
                "kind": "json"
            },
            "title": {
                "kind": "text"
            }
        },
        "regulatorySource": {
            "description": {
                "kind": "text"
            },
            "effectiveFrom": {
                "kind": "date"
            },
            "effectiveTo": {
                "kind": "date"
            },
            "issuer": {
                "kind": "text"
            },
            "kind": {
                "kind": "enum",
                "values": [
                    "law",
                    "regulation",
                    "circular",
                    "standard",
                    "contract",
                    "internal"
                ]
            },
            "name": {
                "kind": "text"
            },
            "officialUrl": {
                "kind": "text"
            },
            "shortCode": {
                "kind": "text"
            },
            "status": {
                "kind": "enum",
                "values": [
                    "active",
                    "inactive",
                    "superseded"
                ]
            },
            "supersedes": {
                "kind": "ref",
                "refEntity": "regulatorySource"
            }
        },
        "reportArchive": {
            "archivedAt": {
                "kind": "date"
            },
            "definitionVersion": {
                "kind": "number"
            },
            "description": {
                "kind": "text"
            },
            "documentName": {
                "kind": "text"
            },
            "reportKey": {
                "kind": "text"
            },
            "reportType": {
                "kind": "enum",
                "values": [
                    "gap",
                    "currentSituationAnalysisSummary",
                    "currentSituationEvaluation",
                    "currentSituationEvaluationSummary",
                    "survey",
                    "implementationProcessEvaluation",
                    "measureApplicability",
                    "confidentialityCommitment",
                    "impartialityCommitment",
                    "riskDetailedPortfolio",
                    "assetDetailedPortfolio",
                    "riskRecordDossier",
                    "assetRecordDossier"
                ]
            },
            "snapshotReportName": {
                "kind": "text"
            },
            "sourceEntityId": {
                "kind": "ref"
            },
            "sourceEntityType": {
                "kind": "text"
            },
            "version": {
                "kind": "text"
            }
        },
        "reportArtifact": {
            "accessPolicy": {
                "kind": "enum",
                "values": [
                    "source-current-v1",
                    "controlled-recipient-v1",
                    "legacy-sidecar-v1"
                ]
            },
            "artifacts": {
                "kind": "json"
            },
            "definitionVersion": {
                "kind": "number"
            },
            "description": {
                "kind": "text"
            },
            "generatedAt": {
                "kind": "date"
            },
            "generatedBy": {
                "kind": "ref",
                "refEntity": "user"
            },
            "idempotencyKey": {
                "kind": "text"
            },
            "kind": {
                "kind": "enum",
                "values": [
                    "interactive",
                    "scheduled-controlled",
                    "legacy-converted"
                ]
            },
            "legacySource": {
                "kind": "json"
            },
            "publication": {
                "kind": "json"
            },
            "replacementPublication": {
                "kind": "json"
            },
            "reportId": {
                "kind": "text"
            },
            "reportKey": {
                "kind": "text"
            },
            "retentionUntil": {
                "kind": "date"
            },
            "revision": {
                "kind": "number"
            },
            "schemaVersion": {
                "kind": "number"
            }
        },
        "reportBranding": {
            "revision": {
                "kind": "ref",
                "refEntity": "reportBrandingRevision"
            },
            "snapshot": {
                "kind": "json"
            },
            "version": {
                "kind": "number"
            }
        },
        "reportBrandingRevision": {
            "digest": {
                "kind": "text"
            },
            "operationId": {
                "kind": "text"
            },
            "snapshot": {
                "kind": "json"
            },
            "version": {
                "kind": "number"
            }
        },
        "reportConfidentialityClass": {
            "code": {
                "kind": "text"
            },
            "color": {
                "kind": "text"
            },
            "description": {
                "kind": "text"
            },
            "isDefault": {
                "kind": "boolean"
            },
            "level": {
                "kind": "number"
            },
            "name": {
                "kind": "text"
            },
            "status": {
                "kind": "enum",
                "values": [
                    "active",
                    "inactive"
                ]
            }
        },
        "retentionPeriod": {
            "code": {
                "kind": "text"
            },
            "description": {
                "kind": "text"
            },
            "duration": {
                "kind": "number"
            },
            "durationUnit": {
                "kind": "enum",
                "values": [
                    "days",
                    "months",
                    "years"
                ]
            },
            "legalReference": {
                "kind": "text"
            },
            "name": {
                "kind": "text"
            },
            "status": {
                "kind": "enum",
                "values": [
                    "active",
                    "inactive"
                ]
            }
        },
        "risk": {
            "currentStatus": {
                "kind": "text"
            },
            "existingControls": {
                "kind": "json"
            },
            "impactRating": {
                "kind": "number"
            },
            "inherentImpact": {
                "kind": "number"
            },
            "inherentProbability": {
                "kind": "number"
            },
            "lastReviewedAt": {
                "kind": "date"
            },
            "lastReviewedBy": {
                "kind": "ref",
                "refEntity": "user"
            },
            "nextReviewAt": {
                "kind": "date"
            },
            "partyInstanceId": {
                "kind": "ref",
                "refEntity": "partyInstance"
            },
            "priority": {
                "kind": "enum",
                "values": [
                    "Critical",
                    "High",
                    "Medium",
                    "Low"
                ]
            },
            "relatedRisks": {
                "kind": "json"
            },
            "relatedThreats": {
                "kind": "json"
            },
            "relatedWeaknesses": {
                "kind": "json"
            },
            "residualImpact": {
                "kind": "number"
            },
            "residualProbability": {
                "kind": "number"
            },
            "reviewFrequency": {
                "kind": "enum",
                "values": [
                    "none",
                    "monthly",
                    "quarterly",
                    "semi-annual",
                    "annual",
                    "biennial"
                ]
            },
            "riskDescription": {
                "kind": "text"
            },
            "riskImprovementMethod": {
                "kind": "enum",
                "values": [
                    "Risk Mitigation",
                    "Risk Acceptance",
                    "Risk Transfer",
                    "Risk Avoidance",
                    "Risk Reduction"
                ]
            },
            "riskMethod": {
                "kind": "enum",
                "values": [
                    "Asset",
                    "Process",
                    "Assetless"
                ]
            },
            "riskName": {
                "kind": "text"
            },
            "riskRealisation": {
                "kind": "text"
            },
            "riskStatus": {
                "kind": "enum",
                "values": [
                    "Değerlendiriliyor",
                    "İzleniyor",
                    "Planlandı",
                    "Kapandı",
                    "Assessing",
                    "Monitoring",
                    "Planned",
                    "Closed"
                ]
            },
            "riskValue": {
                "kind": "number"
            },
            "selectedAsset": {
                "kind": "ref",
                "refEntity": "asset"
            },
            "selectedCategory": {
                "kind": "text"
            },
            "selectedProcess": {
                "kind": "ref",
                "refEntity": "process"
            },
            "treatments": {
                "kind": "json"
            }
        },
        "riskAnalysis": {
            "approvedAt": {
                "kind": "date"
            },
            "approvedBy": {
                "kind": "ref",
                "refEntity": "user"
            },
            "description": {
                "kind": "text"
            },
            "endDate": {
                "kind": "date"
            },
            "impactCriteria": {
                "kind": "json"
            },
            "methodology": {
                "kind": "enum",
                "values": [
                    "qualitative",
                    "quantitative",
                    "semi-quantitative"
                ]
            },
            "name": {
                "kind": "text"
            },
            "preparedBy": {
                "kind": "ref",
                "refEntity": "user"
            },
            "probabilityCriteria": {
                "kind": "json"
            },
            "reviewDate": {
                "kind": "date"
            },
            "reviewedBy": {
                "kind": "ref",
                "refEntity": "user"
            },
            "riskMatrix": {
                "kind": "json"
            },
            "risks": {
                "kind": "json"
            },
            "scope": {
                "kind": "enum",
                "values": [
                    "organization",
                    "unit",
                    "process",
                    "asset",
                    "project"
                ]
            },
            "startDate": {
                "kind": "date"
            },
            "status": {
                "kind": "enum",
                "values": [
                    "draft",
                    "in-progress",
                    "review",
                    "approved",
                    "archived"
                ]
            },
            "targetProcess": {
                "kind": "ref",
                "refEntity": "process"
            },
            "targetUnit": {
                "kind": "ref",
                "refEntity": "unit"
            }
        },
        "riskConsequence": {
            "description": {
                "kind": "text"
            },
            "name": {
                "kind": "text"
            }
        },
        "riskMitigationDefinition": {
            "code": {
                "kind": "text"
            },
            "description": {
                "kind": "text"
            },
            "mitigationCategory": {
                "kind": "text"
            },
            "name": {
                "kind": "text"
            },
            "status": {
                "kind": "enum",
                "values": [
                    "active",
                    "inactive"
                ]
            }
        },
        "riskRegister": {
            "annualizedLoss": {
                "kind": "number"
            },
            "causes": {
                "kind": "json"
            },
            "consequences": {
                "kind": "json"
            },
            "currency": {
                "kind": "enum",
                "values": [
                    "TRY",
                    "USD",
                    "EUR",
                    "GBP"
                ]
            },
            "description": {
                "kind": "text"
            },
            "existingControls": {
                "kind": "json"
            },
            "financialImpact": {
                "kind": "number"
            },
            "financialImpactRange": {
                "kind": "text"
            },
            "historyLog": {
                "kind": "json"
            },
            "impact": {
                "kind": "text"
            },
            "impactLevelId": {
                "kind": "text"
            },
            "operationalImpact": {
                "kind": "text"
            },
            "partyInstanceId": {
                "kind": "ref",
                "refEntity": "partyInstance"
            },
            "priority": {
                "kind": "text"
            },
            "probability": {
                "kind": "text"
            },
            "probabilityLevelId": {
                "kind": "text"
            },
            "relatedAssetCategories": {
                "kind": "json"
            },
            "relatedBias": {
                "kind": "json"
            },
            "relatedObjectives": {
                "kind": "json"
            },
            "relatedProcesses": {
                "kind": "json"
            },
            "reputationalImpact": {
                "kind": "text"
            },
            "residualImpact": {
                "kind": "text"
            },
            "residualImpactLevelId": {
                "kind": "text"
            },
            "residualLikelihood": {
                "kind": "text"
            },
            "residualLikelihoodLevelId": {
                "kind": "text"
            },
            "residualScore": {
                "kind": "number"
            },
            "responseDescription": {
                "kind": "text"
            },
            "responseStrategy": {
                "kind": "text"
            },
            "riskId": {
                "kind": "text"
            },
            "riskLevel": {
                "kind": "text"
            },
            "riskNature": {
                "kind": "enum",
                "values": [
                    "risk",
                    "opportunity"
                ]
            },
            "score": {
                "kind": "number"
            },
            "status": {
                "kind": "enum",
                "values": [
                    "Open",
                    "Closed"
                ]
            },
            "title": {
                "kind": "text"
            },
            "treatments": {
                "kind": "json"
            },
            "unit": {
                "kind": "ref",
                "refEntity": "unit"
            }
        },
        "riskReports": {
            "description": {
                "kind": "text"
            },
            "metadata": {
                "kind": "json"
            },
            "name": {
                "kind": "text"
            },
            "status": {
                "kind": "enum",
                "values": [
                    "active",
                    "inactive"
                ]
            }
        },
        "role": {
            "description": {
                "kind": "text"
            },
            "isDefault": {
                "kind": "boolean"
            },
            "isSystemRole": {
                "kind": "boolean"
            },
            "name": {
                "kind": "text"
            },
            "roleAuthorization": {
                "kind": "json"
            },
            "unitAssignments": {
                "kind": "json"
            },
            "units": {
                "kind": "json"
            }
        },
        "rootCause": {
            "description": {
                "kind": "text"
            },
            "name": {
                "kind": "text"
            },
            "scopeType": {
                "kind": "enum",
                "values": [
                    "tenant",
                    "units"
                ]
            },
            "scopeUnitIds": {
                "kind": "json"
            }
        },
        "scenarioTimeline": {
            "event": {
                "kind": "text"
            },
            "phase": {
                "kind": "text"
            },
            "time": {
                "kind": "text"
            }
        },
        "scfAssessmentObjective": {
            "ao_id": {
                "kind": "text"
            },
            "ao_origins": {
                "kind": "json"
            },
            "assessment_rigor": {
                "kind": "number"
            },
            "control_ref": {
                "kind": "ref",
                "refEntity": "scfControl"
            },
            "is_editable": {
                "kind": "boolean"
            },
            "notes_errata": {
                "kind": "text"
            },
            "objective_text": {
                "kind": "text"
            },
            "org_defined_params": {
                "kind": "json"
            },
            "pptdf_applicability": {
                "kind": "text"
            },
            "scf_defined_params": {
                "kind": "json"
            },
            "scf_id": {
                "kind": "text"
            }
        },
        "scfAuthoritativeSource": {
            "display_order": {
                "kind": "number"
            },
            "full_name": {
                "kind": "text"
            },
            "geography": {
                "kind": "text"
            },
            "is_editable": {
                "kind": "boolean"
            },
            "mapping_key": {
                "kind": "text"
            },
            "raw_header": {
                "kind": "text"
            },
            "source_org": {
                "kind": "text"
            },
            "strm_url": {
                "kind": "text"
            },
            "url": {
                "kind": "text"
            }
        },
        "scfControl": {
            "catalog_seed_tags": {
                "kind": "json"
            },
            "conformity_cadence": {
                "kind": "text"
            },
            "control_name": {
                "kind": "text"
            },
            "control_question": {
                "kind": "text"
            },
            "data_privacy_principles": {
                "kind": "json"
            },
            "description": {
                "kind": "text"
            },
            "domain_identifier": {
                "kind": "text"
            },
            "domain_ref": {
                "kind": "ref",
                "refEntity": "scfDomain"
            },
            "erl_ids": {
                "kind": "json"
            },
            "framework_mappings": {
                "kind": "json"
            },
            "integration_catalog_source": {
                "kind": "text"
            },
            "is_editable": {
                "kind": "boolean"
            },
            "nist_csf_function": {
                "kind": "text"
            },
            "pptdf_applicability": {
                "kind": "text"
            },
            "relative_weight": {
                "kind": "number"
            },
            "risk_ids": {
                "kind": "json"
            },
            "scf_id": {
                "kind": "text"
            },
            "threat_ids": {
                "kind": "json"
            }
        },
        "scfDomain": {
            "domain_name": {
                "kind": "text"
            },
            "identifier": {
                "kind": "text"
            },
            "is_editable": {
                "kind": "boolean"
            },
            "principle": {
                "kind": "text"
            },
            "principle_intent": {
                "kind": "text"
            }
        },
        "scfEvidenceRequest": {
            "area_of_focus": {
                "kind": "text"
            },
            "artifact_description": {
                "kind": "text"
            },
            "control_refs": {
                "kind": "json"
            },
            "documentation_artifact": {
                "kind": "text"
            },
            "erl_id": {
                "kind": "text"
            },
            "is_editable": {
                "kind": "boolean"
            },
            "scf_ids": {
                "kind": "json"
            }
        },
        "scfRisk": {
            "description": {
                "kind": "text"
            },
            "is_editable": {
                "kind": "boolean"
            },
            "nist_csf_function": {
                "kind": "text"
            },
            "risk_grouping": {
                "kind": "text"
            },
            "risk_id": {
                "kind": "text"
            },
            "risk_name": {
                "kind": "text"
            }
        },
        "scfThreat": {
            "description": {
                "kind": "text"
            },
            "is_editable": {
                "kind": "boolean"
            },
            "threat_grouping": {
                "kind": "text"
            },
            "threat_id": {
                "kind": "text"
            },
            "threat_name": {
                "kind": "text"
            }
        },
        "scopeDocument": {
            "approvedBy": {
                "kind": "text"
            },
            "approvedDate": {
                "kind": "text"
            },
            "exclusionJustification": {
                "kind": "text"
            },
            "exclusions": {
                "kind": "text"
            },
            "geographicScope": {
                "kind": "text"
            },
            "linkedDocumentId": {
                "kind": "ref",
                "refEntity": "document"
            },
            "organizationalScope": {
                "kind": "text"
            },
            "reviewDate": {
                "kind": "text"
            },
            "status": {
                "kind": "enum",
                "values": [
                    "draft",
                    "approved",
                    "under-review",
                    "archived"
                ]
            },
            "technologicalScope": {
                "kind": "text"
            },
            "title": {
                "kind": "text"
            },
            "version": {
                "kind": "text"
            }
        },
        "securityMeasure": {
            "category": {
                "kind": "text"
            },
            "code": {
                "kind": "text"
            },
            "description": {
                "kind": "text"
            },
            "evidence": {
                "kind": "json"
            },
            "implementationStatus": {
                "kind": "enum",
                "values": [
                    "not-implemented",
                    "partially-implemented",
                    "fully-implemented"
                ]
            },
            "name": {
                "kind": "text"
            },
            "responsiblePerson": {
                "kind": "text"
            },
            "status": {
                "kind": "enum",
                "values": [
                    "active",
                    "inactive"
                ]
            },
            "type": {
                "kind": "enum",
                "values": [
                    "teknik",
                    "idari"
                ]
            }
        },
        "seedTombstone": {
            "entityType": {
                "kind": "text"
            },
            "key": {
                "kind": "text"
            },
            "keyField": {
                "kind": "text"
            },
            "packId": {
                "kind": "text"
            },
            "reason": {
                "kind": "text"
            }
        },
        "serviceCatalogItem": {
            "code": {
                "kind": "text"
            },
            "description": {
                "kind": "text"
            },
            "name": {
                "kind": "text"
            },
            "ownerDisplayName": {
                "kind": "text"
            },
            "ownerName": {
                "kind": "text"
            },
            "partyInstanceId": {
                "kind": "ref",
                "refEntity": "partyInstance"
            },
            "problemCorrelationKey": {
                "kind": "text"
            },
            "serviceType": {
                "kind": "enum",
                "values": [
                    "business",
                    "technical",
                    "shared"
                ]
            },
            "status": {
                "kind": "enum",
                "values": [
                    "active",
                    "retired"
                ]
            }
        },
        "strategicInitiative": {
            "description": {
                "kind": "text"
            },
            "endDate": {
                "kind": "date"
            },
            "partyInstanceId": {
                "kind": "ref",
                "refEntity": "partyInstance"
            },
            "progress": {
                "kind": "number"
            },
            "startDate": {
                "kind": "date"
            },
            "status": {
                "kind": "text"
            },
            "title": {
                "kind": "text"
            }
        },
        "subjectPersonGroup": {
            "code": {
                "kind": "text"
            },
            "description": {
                "kind": "text"
            },
            "examples": {
                "kind": "json"
            },
            "name": {
                "kind": "text"
            },
            "relationshipInfo": {
                "kind": "text"
            },
            "status": {
                "kind": "enum",
                "values": [
                    "active",
                    "inactive"
                ]
            }
        },
        "surveyDispatch": {
            "assigneeUserIds": {
                "kind": "json"
            },
            "assignmentTemplateId": {
                "kind": "ref",
                "refEntity": "assignmentTemplate"
            },
            "endDate": {
                "kind": "text"
            },
            "formTemplate": {
                "kind": "ref",
                "refEntity": "formTemplate"
            },
            "intervalUnit": {
                "kind": "enum",
                "values": [
                    "minute",
                    "hour",
                    "day",
                    "week",
                    "month",
                    "year"
                ]
            },
            "intervalValue": {
                "kind": "number"
            },
            "lastError": {
                "kind": "text"
            },
            "lastRunAt": {
                "kind": "date"
            },
            "leaseExpiresAt": {
                "kind": "date"
            },
            "leasedBy": {
                "kind": "text"
            },
            "name": {
                "kind": "text"
            },
            "nextRunAt": {
                "kind": "date"
            },
            "periodType": {
                "kind": "enum",
                "values": [
                    "Once",
                    "Periodic"
                ]
            },
            "runCount": {
                "kind": "number"
            },
            "scheduleMode": {
                "kind": "enum",
                "values": [
                    "immediate",
                    "scheduled"
                ]
            },
            "startDate": {
                "kind": "text"
            },
            "status": {
                "kind": "enum",
                "values": [
                    "active",
                    "paused",
                    "completed",
                    "cancelled"
                ]
            }
        },
        "systemLog": {
            "accessDecisionReason": {
                "kind": "text"
            },
            "action": {
                "kind": "text"
            },
            "category": {
                "kind": "enum",
                "values": [
                    "auth",
                    "data",
                    "access",
                    "system",
                    "security",
                    "workflow",
                    "compliance"
                ]
            },
            "changesDisplay": {
                "kind": "json"
            },
            "correlationId": {
                "kind": "text"
            },
            "delegationId": {
                "kind": "ref",
                "refEntity": "delegation"
            },
            "details": {
                "kind": "json"
            },
            "duration": {
                "kind": "number"
            },
            "entityId": {
                "kind": "ref"
            },
            "entityType": {
                "kind": "text"
            },
            "errorMessage": {
                "kind": "text"
            },
            "hash": {
                "kind": "text"
            },
            "ipAddress": {
                "kind": "text"
            },
            "jitGranted": {
                "kind": "boolean"
            },
            "prevHash": {
                "kind": "text"
            },
            "requestId": {
                "kind": "text"
            },
            "resource": {
                "kind": "text"
            },
            "resourceId": {
                "kind": "ref"
            },
            "sessionId": {
                "kind": "text"
            },
            "severity": {
                "kind": "enum",
                "values": [
                    "info",
                    "warning",
                    "error",
                    "critical"
                ]
            },
            "status": {
                "kind": "enum",
                "values": [
                    "success",
                    "failure"
                ]
            },
            "user": {
                "kind": "ref",
                "refEntity": "user"
            },
            "userAgent": {
                "kind": "text"
            },
            "workflowContext": {
                "kind": "json"
            }
        },
        "systemSeed": {
            "appliedAt": {
                "kind": "date"
            },
            "contentVersion": {
                "kind": "number"
            },
            "environment": {
                "kind": "text"
            },
            "identifier": {
                "kind": "text"
            }
        },
        "systemSeedRun": {
            "actorId": {
                "kind": "ref",
                "refEntity": "user"
            },
            "applied": {
                "kind": "json"
            },
            "dryRun": {
                "kind": "boolean"
            },
            "durationMs": {
                "kind": "number"
            },
            "environment": {
                "kind": "text"
            },
            "frozenSkipped": {
                "kind": "json"
            },
            "modules": {
                "kind": "json"
            },
            "packFilter": {
                "kind": "json"
            },
            "reconciled": {
                "kind": "json"
            },
            "skipped": {
                "kind": "json"
            },
            "stats": {
                "kind": "json"
            }
        },
        "team": {
            "code": {
                "kind": "text"
            },
            "description": {
                "kind": "text"
            },
            "email": {
                "kind": "text"
            },
            "leader": {
                "kind": "ref",
                "refEntity": "user"
            },
            "leaders": {
                "kind": "json"
            },
            "members": {
                "kind": "json"
            },
            "name": {
                "kind": "text"
            },
            "status": {
                "kind": "enum",
                "values": [
                    "active",
                    "inactive"
                ]
            },
            "type": {
                "kind": "enum",
                "values": [
                    "cmt",
                    "imt",
                    "recovery",
                    "communications",
                    "other"
                ]
            },
            "unit": {
                "kind": "ref",
                "refEntity": "unit"
            }
        },
        "teamAssignment": {
            "assignmentMode": {
                "kind": "enum",
                "values": [
                    "reference",
                    "snapshot"
                ]
            },
            "clonedFromAssignment": {
                "kind": "ref",
                "refEntity": "teamAssignment"
            },
            "dutyDefinition": {
                "kind": "ref",
                "refEntity": "dutyDefinition"
            },
            "dutyProfile": {
                "kind": "ref",
                "refEntity": "teamDutyProfile"
            },
            "executionMode": {
                "kind": "enum",
                "values": [
                    "sequential",
                    "parallel"
                ]
            },
            "executionTasks": {
                "kind": "json"
            },
            "members": {
                "kind": "json"
            },
            "override": {
                "kind": "boolean"
            },
            "parent": {
                "kind": "ref"
            },
            "parentType": {
                "kind": "enum",
                "values": [
                    "Bcp",
                    "CrisisEvent",
                    "Exercise"
                ]
            },
            "sourceKind": {
                "kind": "enum",
                "values": [
                    "team",
                    "dutyDefinition"
                ]
            },
            "sourceParent": {
                "kind": "ref"
            },
            "sourceParentType": {
                "kind": "text"
            },
            "sourceProfile": {
                "kind": "ref",
                "refEntity": "teamDutyProfile"
            },
            "team": {
                "kind": "ref",
                "refEntity": "team"
            }
        },
        "teamDutyProfile": {
            "description": {
                "kind": "text"
            },
            "executionTasks": {
                "kind": "json"
            },
            "isDefault": {
                "kind": "boolean"
            },
            "members": {
                "kind": "json"
            },
            "name": {
                "kind": "text"
            },
            "situationKey": {
                "kind": "enum",
                "values": [
                    "crisis",
                    "exercise",
                    "other"
                ]
            },
            "team": {
                "kind": "ref",
                "refEntity": "team"
            }
        },
        "tenant": {
            "domain": {
                "kind": "text"
            },
            "name": {
                "kind": "text"
            },
            "slug": {
                "kind": "text"
            },
            "status": {
                "kind": "enum",
                "values": [
                    "active",
                    "suspended",
                    "trial",
                    "expired"
                ]
            }
        },
        "tenantBranding": {
            "accentColor": {
                "kind": "text"
            },
            "appName": {
                "kind": "json"
            },
            "backgroundColor": {
                "kind": "text"
            },
            "customCss": {
                "kind": "text"
            },
            "faviconUrl": {
                "kind": "text"
            },
            "legalLinks": {
                "kind": "json"
            },
            "locale": {
                "kind": "text"
            },
            "logoUrl": {
                "kind": "text"
            },
            "primaryColor": {
                "kind": "text"
            },
            "secondaryColor": {
                "kind": "text"
            },
            "shortName": {
                "kind": "text"
            },
            "supportEmail": {
                "kind": "text"
            },
            "textColor": {
                "kind": "text"
            },
            "timezone": {
                "kind": "text"
            }
        },
        "tenantBusinessHours": {
            "end": {
                "kind": "text"
            },
            "isActive": {
                "kind": "boolean"
            },
            "start": {
                "kind": "text"
            },
            "timezone": {
                "kind": "text"
            },
            "workDays": {
                "kind": "json"
            }
        },
        "tenantComplianceConfig": {
            "frameworks": {
                "kind": "json"
            }
        },
        "tenantConnectionConfig": {
            "connectionString": {
                "kind": "text"
            },
            "mode": {
                "kind": "enum",
                "values": [
                    "shared",
                    "dedicated"
                ]
            },
            "notes": {
                "kind": "text"
            },
            "region": {
                "kind": "text"
            }
        },
        "tenantControlEvaluation": {
            "change_reason": {
                "kind": "text"
            },
            "control_name_snapshot": {
                "kind": "text"
            },
            "created_by": {
                "kind": "ref",
                "refEntity": "user"
            },
            "domain_snapshot": {
                "kind": "text"
            },
            "evaluation_payload": {
                "kind": "json"
            },
            "is_current": {
                "kind": "boolean"
            },
            "scf_control_ref": {
                "kind": "ref",
                "refEntity": "scfControl"
            },
            "scf_id_snapshot": {
                "kind": "text"
            },
            "updated_by": {
                "kind": "ref",
                "refEntity": "user"
            },
            "version": {
                "kind": "number"
            }
        },
        "tenantControlScopePreference": {
            "catalog_control_ids": {
                "kind": "json"
            },
            "catalog_seed_tags_filter": {
                "kind": "json"
            },
            "category_domains": {
                "kind": "json"
            },
            "scope_standards": {
                "kind": "json"
            },
            "updated_by": {
                "kind": "ref",
                "refEntity": "user"
            }
        },
        "tenantDirectoryConfig": {
            "baseDn": {
                "kind": "text"
            },
            "bindDn": {
                "kind": "text"
            },
            "bindPassword": {
                "kind": "text"
            },
            "enabled": {
                "kind": "boolean"
            },
            "url": {
                "kind": "text"
            },
            "userSearchFilter": {
                "kind": "text"
            }
        },
        "tenantFeatureFlag": {
            "enabled": {
                "kind": "boolean"
            },
            "key": {
                "kind": "text"
            },
            "metadata": {
                "kind": "json"
            },
            "rolloutPercent": {
                "kind": "number"
            }
        },
        "tenantHoliday": {
            "date": {
                "kind": "text"
            },
            "name": {
                "kind": "text"
            },
            "recurrence": {
                "kind": "enum",
                "values": [
                    "once",
                    "yearly"
                ]
            }
        },
        "tenantMfaSettings": {
            "defaultEmailProviderId": {
                "kind": "ref",
                "refEntity": "communicationProvider"
            },
            "defaultSmsProviderId": {
                "kind": "ref",
                "refEntity": "communicationProvider"
            },
            "emailEnabled": {
                "kind": "boolean"
            },
            "smsEnabled": {
                "kind": "boolean"
            }
        },
        "threat": {
            "category": {
                "kind": "text"
            },
            "countermeasures": {
                "kind": "json"
            },
            "description": {
                "kind": "text"
            },
            "likelihood": {
                "kind": "text"
            },
            "mainThreatGroup": {
                "kind": "ref",
                "refEntity": "threat"
            },
            "orderIndex": {
                "kind": "number"
            },
            "parentId": {
                "kind": "ref",
                "refEntity": "threat"
            },
            "relatedAssets": {
                "kind": "json"
            },
            "source": {
                "kind": "text"
            },
            "status": {
                "kind": "enum",
                "values": [
                    "Active",
                    "Inactive"
                ]
            },
            "threatID": {
                "kind": "text"
            },
            "threatName": {
                "kind": "text"
            }
        },
        "ticket": {
            "acceptedAt": {
                "kind": "date"
            },
            "acceptedBy": {
                "kind": "ref",
                "refEntity": "user"
            },
            "actionId": {
                "kind": "ref",
                "refEntity": "action"
            },
            "assignedAt": {
                "kind": "date"
            },
            "assignedBy": {
                "kind": "ref",
                "refEntity": "user"
            },
            "assignedTo": {
                "kind": "ref",
                "refEntity": "user"
            },
            "assignedToPool": {
                "kind": "json"
            },
            "assignedUserIds": {
                "kind": "json"
            },
            "assignmentHistory": {
                "kind": "json"
            },
            "attachments": {
                "kind": "json"
            },
            "cancellationReason": {
                "kind": "text"
            },
            "category": {
                "kind": "ref",
                "refEntity": "ticketCategory"
            },
            "claimedAt": {
                "kind": "date"
            },
            "claimedBy": {
                "kind": "ref",
                "refEntity": "user"
            },
            "closedAt": {
                "kind": "date"
            },
            "closedBy": {
                "kind": "ref",
                "refEntity": "user"
            },
            "commitmentAppliedAt": {
                "kind": "date"
            },
            "csatSentAt": {
                "kind": "date"
            },
            "description": {
                "kind": "text"
            },
            "executionPrepPhase": {
                "kind": "enum",
                "values": [
                    "none",
                    "gated_draft",
                    "active"
                ]
            },
            "firstResponseAt": {
                "kind": "date"
            },
            "firstResponseBreached": {
                "kind": "boolean"
            },
            "firstResponseDeadline": {
                "kind": "date"
            },
            "formData": {
                "kind": "json"
            },
            "internalNotes": {
                "kind": "text"
            },
            "itsmClass": {
                "kind": "enum",
                "values": [
                    "service_request",
                    "incident"
                ]
            },
            "linkedActions": {
                "kind": "json"
            },
            "linkedChangeRequest": {
                "kind": "ref",
                "refEntity": "changeRequest"
            },
            "linkedIncident": {
                "kind": "ref",
                "refEntity": "incident"
            },
            "linkedProblem": {
                "kind": "ref",
                "refEntity": "problem"
            },
            "linkedReportName": {
                "kind": "text"
            },
            "mergedFrom": {
                "kind": "json"
            },
            "mergedInto": {
                "kind": "ref",
                "refEntity": "ticket"
            },
            "mode": {
                "kind": "enum",
                "values": [
                    "ITSM",
                    "GRC"
                ]
            },
            "onBehalfOf": {
                "kind": "ref",
                "refEntity": "user"
            },
            "onBehalfOfName": {
                "kind": "text"
            },
            "parentTicket": {
                "kind": "ref",
                "refEntity": "ticket"
            },
            "partyInstanceId": {
                "kind": "ref",
                "refEntity": "partyInstance"
            },
            "pendingCommitmentChangeId": {
                "kind": "ref",
                "refEntity": "workflowInstance"
            },
            "priority": {
                "kind": "enum",
                "values": [
                    "critical",
                    "high",
                    "medium",
                    "low"
                ]
            },
            "rejectedAt": {
                "kind": "date"
            },
            "rejectedBy": {
                "kind": "ref",
                "refEntity": "user"
            },
            "rejectionReason": {
                "kind": "text"
            },
            "relatedTickets": {
                "kind": "json"
            },
            "reportGeneratedAt": {
                "kind": "date"
            },
            "requestedBy": {
                "kind": "ref",
                "refEntity": "user"
            },
            "requestedByEmail": {
                "kind": "text"
            },
            "requestedByName": {
                "kind": "text"
            },
            "requestedByTitle": {
                "kind": "text"
            },
            "requestedByUnit": {
                "kind": "ref",
                "refEntity": "unit"
            },
            "requiresVerification": {
                "kind": "boolean"
            },
            "resolution": {
                "kind": "text"
            },
            "resolvedAt": {
                "kind": "date"
            },
            "resolvedBy": {
                "kind": "ref",
                "refEntity": "user"
            },
            "satisfactionComment": {
                "kind": "text"
            },
            "satisfactionScore": {
                "kind": "number"
            },
            "serviceCatalogItem": {
                "kind": "ref",
                "refEntity": "serviceCatalogItem"
            },
            "sla": {
                "kind": "ref",
                "refEntity": "ticketSLA"
            },
            "slaBreachNotified": {
                "kind": "boolean"
            },
            "slaBreached": {
                "kind": "boolean"
            },
            "slaBreachedAt": {
                "kind": "date"
            },
            "slaDeadline": {
                "kind": "date"
            },
            "slaEscalationFiredSteps": {
                "kind": "json"
            },
            "slaPausedAt": {
                "kind": "date"
            },
            "slaWarningSentAt": {
                "kind": "date"
            },
            "source": {
                "kind": "enum",
                "values": [
                    "service_request",
                    "manual",
                    "action",
                    "incident",
                    "change",
                    "exercise",
                    "crisis",
                    "public_document",
                    "custom"
                ]
            },
            "status": {
                "kind": "enum",
                "values": [
                    "draft",
                    "submitted",
                    "in_approval",
                    "approved",
                    "rejected",
                    "returned",
                    "assigned",
                    "in_progress",
                    "on_hold",
                    "resolved",
                    "closed",
                    "cancelled"
                ]
            },
            "statusHistory": {
                "kind": "json"
            },
            "submittedAt": {
                "kind": "date"
            },
            "tags": {
                "kind": "json"
            },
            "tasks": {
                "kind": "json"
            },
            "template": {
                "kind": "ref",
                "refEntity": "ticketTemplate"
            },
            "templateSnapshot": {
                "kind": "json"
            },
            "templateVersion": {
                "kind": "number"
            },
            "ticketNumber": {
                "kind": "text"
            },
            "title": {
                "kind": "text"
            },
            "verificationStatus": {
                "kind": "enum",
                "values": [
                    "not_required",
                    "pending",
                    "passed",
                    "failed"
                ]
            },
            "visibilityApproverUserIds": {
                "kind": "json"
            },
            "visibilityInformedUserIds": {
                "kind": "json"
            },
            "watchers": {
                "kind": "json"
            },
            "workflowInstanceId": {
                "kind": "ref",
                "refEntity": "workflowInstance"
            },
            "workflowTemplateId": {
                "kind": "ref",
                "refEntity": "workflowTemplate"
            }
        },
        "ticketCategory": {
            "allowPublicSubmission": {
                "kind": "boolean"
            },
            "code": {
                "kind": "text"
            },
            "color": {
                "kind": "text"
            },
            "defaultAssigneePool": {
                "kind": "json"
            },
            "defaultAssignmentTemplate": {
                "kind": "ref",
                "refEntity": "assignmentTemplate"
            },
            "defaultSla": {
                "kind": "ref",
                "refEntity": "ticketSLA"
            },
            "description": {
                "kind": "text"
            },
            "icon": {
                "kind": "text"
            },
            "name": {
                "kind": "text"
            },
            "orderIndex": {
                "kind": "number"
            },
            "parentId": {
                "kind": "ref",
                "refEntity": "ticketCategory"
            },
            "requiresApproval": {
                "kind": "boolean"
            },
            "status": {
                "kind": "enum",
                "values": [
                    "active",
                    "inactive"
                ]
            }
        },
        "ticketComment": {
            "attachments": {
                "kind": "json"
            },
            "author": {
                "kind": "ref",
                "refEntity": "user"
            },
            "content": {
                "kind": "text"
            },
            "editHistory": {
                "kind": "json"
            },
            "editedAt": {
                "kind": "date"
            },
            "isEdited": {
                "kind": "boolean"
            },
            "mentions": {
                "kind": "json"
            },
            "ticket": {
                "kind": "ref",
                "refEntity": "ticket"
            },
            "type": {
                "kind": "enum",
                "values": [
                    "comment",
                    "internal_note",
                    "system"
                ]
            }
        },
        "ticketConfig": {
            "notifications": {
                "kind": "json"
            },
            "numberingFormat": {
                "kind": "text"
            },
            "numberingPrefix": {
                "kind": "text"
            }
        },
        "ticketNumberSequence": {
            "seq": {
                "kind": "number"
            },
            "year": {
                "kind": "number"
            }
        },
        "ticketRecurrence": {
            "autoSubmit": {
                "kind": "boolean"
            },
            "cronExpression": {
                "kind": "text"
            },
            "description": {
                "kind": "text"
            },
            "lastRunAt": {
                "kind": "date"
            },
            "name": {
                "kind": "text"
            },
            "nextRunAt": {
                "kind": "date"
            },
            "status": {
                "kind": "enum",
                "values": [
                    "active",
                    "paused",
                    "inactive"
                ]
            },
            "template": {
                "kind": "ref",
                "refEntity": "ticketTemplate"
            },
            "timezone": {
                "kind": "text"
            },
            "totalCreated": {
                "kind": "number"
            }
        },
        "ticketSLA": {
            "businessHoursOnly": {
                "kind": "boolean"
            },
            "categories": {
                "kind": "json"
            },
            "code": {
                "kind": "text"
            },
            "description": {
                "kind": "text"
            },
            "escalations": {
                "kind": "json"
            },
            "firstResponseHours": {
                "kind": "number"
            },
            "mtpd": {
                "kind": "text"
            },
            "name": {
                "kind": "text"
            },
            "priority": {
                "kind": "enum",
                "values": [
                    "critical",
                    "high",
                    "medium",
                    "low"
                ]
            },
            "resolutionHours": {
                "kind": "number"
            },
            "rpo": {
                "kind": "text"
            },
            "rto": {
                "kind": "text"
            },
            "status": {
                "kind": "enum",
                "values": [
                    "active",
                    "inactive"
                ]
            },
            "warningHours": {
                "kind": "number"
            }
        },
        "ticketSubtaskComment": {
            "attachments": {
                "kind": "json"
            },
            "author": {
                "kind": "ref",
                "refEntity": "user"
            },
            "content": {
                "kind": "text"
            },
            "editedAt": {
                "kind": "date"
            },
            "isEdited": {
                "kind": "boolean"
            },
            "mentions": {
                "kind": "json"
            },
            "ticket": {
                "kind": "ref",
                "refEntity": "ticket"
            },
            "ticketTaskId": {
                "kind": "ref"
            }
        },
        "ticketTemplate": {
            "allowAttachments": {
                "kind": "boolean"
            },
            "allowedFileTypes": {
                "kind": "json"
            },
            "archivedAt": {
                "kind": "date"
            },
            "category": {
                "kind": "ref",
                "refEntity": "ticketCategory"
            },
            "code": {
                "kind": "text"
            },
            "confirmationMessage": {
                "kind": "text"
            },
            "createAccess": {
                "kind": "json"
            },
            "defaultAssigneePool": {
                "kind": "json"
            },
            "defaultAssignmentTemplate": {
                "kind": "ref",
                "refEntity": "assignmentTemplate"
            },
            "defaultPriority": {
                "kind": "enum",
                "values": [
                    "critical",
                    "high",
                    "medium",
                    "low"
                ]
            },
            "defaultServiceCatalogItem": {
                "kind": "ref",
                "refEntity": "serviceCatalogItem"
            },
            "defaultSla": {
                "kind": "ref",
                "refEntity": "ticketSLA"
            },
            "defaultWorkflowTemplate": {
                "kind": "ref",
                "refEntity": "workflowTemplate"
            },
            "description": {
                "kind": "text"
            },
            "fields": {
                "kind": "json"
            },
            "itsmClass": {
                "kind": "enum",
                "values": [
                    "service_request",
                    "incident"
                ]
            },
            "linkedDocumentId": {
                "kind": "ref",
                "refEntity": "document"
            },
            "linkedDocumentRevisionId": {
                "kind": "ref",
                "refEntity": "documentRevision"
            },
            "linkedReportName": {
                "kind": "text"
            },
            "maxAttachmentSizeMB": {
                "kind": "number"
            },
            "name": {
                "kind": "text"
            },
            "problemDetectionEnabled": {
                "kind": "boolean"
            },
            "publishedAt": {
                "kind": "date"
            },
            "reportDataSourceSchema": {
                "kind": "json"
            },
            "reportFieldMappings": {
                "kind": "json"
            },
            "requiresElectronicSignature": {
                "kind": "boolean"
            },
            "sections": {
                "kind": "json"
            },
            "status": {
                "kind": "enum",
                "values": [
                    "draft",
                    "published",
                    "archived"
                ]
            },
            "submitButtonText": {
                "kind": "text"
            },
            "version": {
                "kind": "number"
            },
            "visibility": {
                "kind": "json"
            }
        },
        "training": {
            "additionalNotes": {
                "kind": "text"
            },
            "assessmentQuestions": {
                "kind": "json"
            },
            "category": {
                "kind": "text"
            },
            "code": {
                "kind": "text"
            },
            "competencesGained": {
                "kind": "json"
            },
            "contentModules": {
                "kind": "json"
            },
            "deadlineDate": {
                "kind": "date"
            },
            "description": {
                "kind": "text"
            },
            "duration": {
                "kind": "text"
            },
            "evaluationMaxScore": {
                "kind": "number"
            },
            "evaluationPassingScore": {
                "kind": "number"
            },
            "evaluatorUserIds": {
                "kind": "json"
            },
            "externalInstructor": {
                "kind": "text"
            },
            "hasAssessment": {
                "kind": "boolean"
            },
            "institutionResponsible": {
                "kind": "text"
            },
            "instructor": {
                "kind": "ref",
                "refEntity": "user"
            },
            "mandatory": {
                "kind": "boolean"
            },
            "materials": {
                "kind": "json"
            },
            "objectives": {
                "kind": "json"
            },
            "passingScore": {
                "kind": "number"
            },
            "repeatFrequency": {
                "kind": "text"
            },
            "requireContentBeforeEvaluation": {
                "kind": "boolean"
            },
            "scheduledDate": {
                "kind": "date"
            },
            "scoringMode": {
                "kind": "enum",
                "values": [
                    "per_survey",
                    "per_training",
                    "per_survey_aggregate"
                ]
            },
            "status": {
                "kind": "text"
            },
            "surveyEvaluationConfig": {
                "kind": "json"
            },
            "surveyFormTemplateIds": {
                "kind": "json"
            },
            "targetRoles": {
                "kind": "json"
            },
            "targetUnits": {
                "kind": "json"
            },
            "title": {
                "kind": "text"
            },
            "topics": {
                "kind": "json"
            },
            "trainedPersons": {
                "kind": "json"
            },
            "type": {
                "kind": "text"
            }
        },
        "transferType": {
            "code": {
                "kind": "text"
            },
            "description": {
                "kind": "text"
            },
            "name": {
                "kind": "text"
            },
            "safeguards": {
                "kind": "json"
            },
            "status": {
                "kind": "enum",
                "values": [
                    "active",
                    "inactive"
                ]
            },
            "type": {
                "kind": "enum",
                "values": [
                    "yurtici",
                    "yurtdisi"
                ]
            }
        },
        "unit": {
            "code": {
                "kind": "text"
            },
            "company": {
                "kind": "ref",
                "refEntity": "company"
            },
            "description": {
                "kind": "text"
            },
            "email": {
                "kind": "text"
            },
            "employeeCount": {
                "kind": "number"
            },
            "level": {
                "kind": "number"
            },
            "location": {
                "kind": "text"
            },
            "name": {
                "kind": "text"
            },
            "parent": {
                "kind": "ref",
                "refEntity": "unit"
            },
            "phone": {
                "kind": "text"
            },
            "status": {
                "kind": "enum",
                "values": [
                    "active",
                    "inactive"
                ]
            }
        },
        "user": {
            "activationExpires": {
                "kind": "date"
            },
            "activationToken": {
                "kind": "text"
            },
            "authSource": {
                "kind": "enum",
                "values": [
                    "local",
                    "ldap",
                    "saml",
                    "oidc",
                    "scim"
                ]
            },
            "avatar": {
                "kind": "text"
            },
            "email": {
                "kind": "text"
            },
            "emailVerificationToken": {
                "kind": "text"
            },
            "emailVerified": {
                "kind": "boolean"
            },
            "externalId": {
                "kind": "text"
            },
            "fcmTokens": {
                "kind": "json"
            },
            "firstName": {
                "kind": "text"
            },
            "lastName": {
                "kind": "text"
            },
            "manager": {
                "kind": "ref",
                "refEntity": "user"
            },
            "memberships": {
                "kind": "json"
            },
            "phoneNumber": {
                "kind": "text"
            },
            "resetPasswordExpires": {
                "kind": "date"
            },
            "resetPasswordToken": {
                "kind": "text"
            },
            "standardAuthority": {
                "kind": "text"
            },
            "standardManager": {
                "kind": "text"
            },
            "status": {
                "kind": "enum",
                "values": [
                    "active",
                    "inactive",
                    "pending",
                    "suspended"
                ]
            },
            "title": {
                "kind": "text"
            },
            "userName": {
                "kind": "text"
            }
        },
        "userNavigationPreference": {
            "activeWorkspace": {
                "kind": "text"
            },
            "customWorkspaces": {
                "kind": "json"
            },
            "favoritePageUrls": {
                "kind": "json"
            },
            "user": {
                "kind": "ref",
                "refEntity": "user"
            }
        },
        "userPageLayout": {
            "layoutData": {
                "kind": "json"
            },
            "pageKey": {
                "kind": "text"
            },
            "user": {
                "kind": "ref",
                "refEntity": "user"
            }
        },
        "userTraining": {
            "assessmentAttempts": {
                "kind": "json"
            },
            "bestScore": {
                "kind": "number"
            },
            "certificateIssuedAt": {
                "kind": "date"
            },
            "certificateUrl": {
                "kind": "text"
            },
            "completedAt": {
                "kind": "date"
            },
            "evaluationAttempts": {
                "kind": "json"
            },
            "evaluationResponseAttempts": {
                "kind": "json"
            },
            "evaluationResponses": {
                "kind": "json"
            },
            "evaluationSubmitted": {
                "kind": "boolean"
            },
            "isArchived": {
                "kind": "boolean"
            },
            "overdueNotifiedAt": {
                "kind": "date"
            },
            "passed": {
                "kind": "boolean"
            },
            "progress": {
                "kind": "number"
            },
            "startedAt": {
                "kind": "date"
            },
            "status": {
                "kind": "enum",
                "values": [
                    "assigned",
                    "in-progress",
                    "completed",
                    "failed",
                    "fill-forms"
                ]
            },
            "surveyScores": {
                "kind": "json"
            },
            "training": {
                "kind": "ref",
                "refEntity": "training"
            },
            "user": {
                "kind": "ref",
                "refEntity": "user"
            }
        },
        "vendor": {
            "address": {
                "kind": "text"
            },
            "alternateVendor": {
                "kind": "text"
            },
            "bankBranch": {
                "kind": "text"
            },
            "bankIban": {
                "kind": "text"
            },
            "bankName": {
                "kind": "text"
            },
            "bcps": {
                "kind": "json"
            },
            "bias": {
                "kind": "json"
            },
            "businessOwner": {
                "kind": "ref",
                "refEntity": "user"
            },
            "category": {
                "kind": "text"
            },
            "chamberName": {
                "kind": "text"
            },
            "chamberRegistrationDate": {
                "kind": "text"
            },
            "chamberRegistrationNo": {
                "kind": "text"
            },
            "city": {
                "kind": "text"
            },
            "companyType": {
                "kind": "text"
            },
            "contactEmail": {
                "kind": "text"
            },
            "contactMobile": {
                "kind": "text"
            },
            "contactPerson": {
                "kind": "text"
            },
            "contactPhone": {
                "kind": "text"
            },
            "contactUnit": {
                "kind": "text"
            },
            "contractExpiration": {
                "kind": "date"
            },
            "crisisEvents": {
                "kind": "json"
            },
            "criticality": {
                "kind": "text"
            },
            "description": {
                "kind": "text"
            },
            "email": {
                "kind": "text"
            },
            "exercises": {
                "kind": "json"
            },
            "fax": {
                "kind": "text"
            },
            "kepAddress": {
                "kind": "text"
            },
            "linkedAssets": {
                "kind": "json"
            },
            "naceCode": {
                "kind": "text"
            },
            "name": {
                "kind": "text"
            },
            "nextAssessmentReviewDate": {
                "kind": "date"
            },
            "orderIndex": {
                "kind": "number"
            },
            "partyInstanceId": {
                "kind": "ref",
                "refEntity": "partyInstance"
            },
            "phone": {
                "kind": "text"
            },
            "position": {
                "kind": "text"
            },
            "recoveryTimeObjective": {
                "kind": "text"
            },
            "reviewFrequency": {
                "kind": "enum",
                "values": [
                    "monthly",
                    "quarterly",
                    "semi-annual",
                    "annual",
                    "biennial"
                ]
            },
            "securityOwner": {
                "kind": "ref",
                "refEntity": "user"
            },
            "slaDetails": {
                "kind": "text"
            },
            "status": {
                "kind": "text"
            },
            "taxNumber": {
                "kind": "text"
            },
            "taxOffice": {
                "kind": "text"
            },
            "type": {
                "kind": "text"
            },
            "vendorBusinessImpact": {
                "kind": "text"
            },
            "vendorProductService": {
                "kind": "text"
            },
            "website": {
                "kind": "text"
            }
        },
        "vendorAssessment": {
            "assessmentDate": {
                "kind": "date"
            },
            "findingsSummary": {
                "kind": "text"
            },
            "nextReviewDate": {
                "kind": "date"
            },
            "overallScore": {
                "kind": "number"
            },
            "remediationNotes": {
                "kind": "text"
            },
            "status": {
                "kind": "enum",
                "values": [
                    "draft",
                    "submitted",
                    "reviewed",
                    "closed"
                ]
            },
            "surveySubmission": {
                "kind": "ref",
                "refEntity": "formSubmission"
            },
            "surveyTemplate": {
                "kind": "ref",
                "refEntity": "formTemplate"
            },
            "title": {
                "kind": "text"
            },
            "vendor": {
                "kind": "ref",
                "refEntity": "vendor"
            }
        },
        "vulnerability": {
            "description": {
                "kind": "text"
            },
            "identifier": {
                "kind": "text"
            },
            "relatedAssets": {
                "kind": "json"
            },
            "severity": {
                "kind": "enum",
                "values": [
                    "critical",
                    "high",
                    "medium",
                    "low",
                    "informational"
                ]
            },
            "title": {
                "kind": "text"
            }
        },
        "weakness": {
            "affectedAssets": {
                "kind": "json"
            },
            "affectedProcesses": {
                "kind": "json"
            },
            "code": {
                "kind": "text"
            },
            "description": {
                "kind": "text"
            },
            "exploitability": {
                "kind": "enum",
                "values": [
                    "high",
                    "medium",
                    "low"
                ]
            },
            "name": {
                "kind": "text"
            },
            "relatedThreats": {
                "kind": "json"
            },
            "remediationDeadline": {
                "kind": "date"
            },
            "remediationPlan": {
                "kind": "text"
            },
            "remediationStatus": {
                "kind": "enum",
                "values": [
                    "open",
                    "in-progress",
                    "remediated",
                    "accepted"
                ]
            },
            "severity": {
                "kind": "enum",
                "values": [
                    "critical",
                    "high",
                    "medium",
                    "low"
                ]
            },
            "status": {
                "kind": "enum",
                "values": [
                    "active",
                    "inactive"
                ]
            }
        },
        "webhookDelivery": {
            "attempt": {
                "kind": "number"
            },
            "durationMs": {
                "kind": "number"
            },
            "error": {
                "kind": "text"
            },
            "eventData": {
                "kind": "json"
            },
            "eventMetadata": {
                "kind": "json"
            },
            "eventName": {
                "kind": "text"
            },
            "expiresAt": {
                "kind": "date"
            },
            "requestBody": {
                "kind": "text"
            },
            "requestHeaders": {
                "kind": "json"
            },
            "requestMethod": {
                "kind": "text"
            },
            "requestUrl": {
                "kind": "text"
            },
            "responseBody": {
                "kind": "text"
            },
            "responseHeaders": {
                "kind": "json"
            },
            "responseStatus": {
                "kind": "number"
            },
            "signature": {
                "kind": "text"
            },
            "skipped": {
                "kind": "boolean"
            },
            "subscriptionId": {
                "kind": "ref",
                "refEntity": "webhookSubscription"
            },
            "success": {
                "kind": "boolean"
            }
        },
        "webhookSubscription": {
            "bodyTemplate": {
                "kind": "text"
            },
            "enabled": {
                "kind": "boolean"
            },
            "eventPattern": {
                "kind": "text"
            },
            "failureCount": {
                "kind": "number"
            },
            "headers": {
                "kind": "json"
            },
            "lastError": {
                "kind": "text"
            },
            "lastSuccessAt": {
                "kind": "date"
            },
            "lastTriggeredAt": {
                "kind": "date"
            },
            "method": {
                "kind": "enum",
                "values": [
                    "POST",
                    "PUT",
                    "PATCH"
                ]
            },
            "name": {
                "kind": "text"
            },
            "urlTemplate": {
                "kind": "text"
            }
        },
        "workflowInformedReceipt": {
            "assignmentTemplateId": {
                "kind": "ref",
                "refEntity": "assignmentTemplate"
            },
            "chainStepIndex": {
                "kind": "number"
            },
            "entityId": {
                "kind": "ref"
            },
            "entityType": {
                "kind": "text"
            },
            "instanceId": {
                "kind": "ref",
                "refEntity": "workflowInstance"
            },
            "nodeId": {
                "kind": "text"
            },
            "nodeLabel": {
                "kind": "text"
            },
            "notifiedAt": {
                "kind": "date"
            },
            "readAt": {
                "kind": "date"
            },
            "requestedBy": {
                "kind": "ref",
                "refEntity": "user"
            },
            "status": {
                "kind": "enum",
                "values": [
                    "active",
                    "read"
                ]
            },
            "userId": {
                "kind": "ref",
                "refEntity": "user"
            }
        },
        "workflowInstance": {
            "cancelledAt": {
                "kind": "date"
            },
            "completedAt": {
                "kind": "date"
            },
            "correlationId": {
                "kind": "text"
            },
            "currentNodes": {
                "kind": "json"
            },
            "entityId": {
                "kind": "ref"
            },
            "entityType": {
                "kind": "text"
            },
            "error": {
                "kind": "text"
            },
            "failedAt": {
                "kind": "date"
            },
            "outcome": {
                "kind": "enum",
                "values": [
                    "accept",
                    "reject",
                    "neutral"
                ]
            },
            "parentInstanceId": {
                "kind": "ref",
                "refEntity": "workflowInstance"
            },
            "status": {
                "kind": "enum",
                "values": [
                    "RUNNING",
                    "COMPLETED",
                    "CANCELLED",
                    "FAILED",
                    "SUSPENDED"
                ]
            },
            "suspendedAt": {
                "kind": "date"
            },
            "templateCode": {
                "kind": "text"
            },
            "templateId": {
                "kind": "ref",
                "refEntity": "workflowTemplate"
            },
            "templateSnapshot": {
                "kind": "json"
            },
            "templateVersion": {
                "kind": "number"
            },
            "traceId": {
                "kind": "text"
            }
        },
        "workflowScheduledTrigger": {
            "entityId": {
                "kind": "ref"
            },
            "entityType": {
                "kind": "text"
            },
            "firstRun": {
                "kind": "enum",
                "values": [
                    "on-creation",
                    "date"
                ]
            },
            "firstRunAt": {
                "kind": "date"
            },
            "intervalUnit": {
                "kind": "enum",
                "values": [
                    "minute",
                    "day",
                    "week",
                    "month"
                ]
            },
            "intervalValue": {
                "kind": "number"
            },
            "lastRunAt": {
                "kind": "date"
            },
            "leaseExpiresAt": {
                "kind": "date"
            },
            "leasedBy": {
                "kind": "text"
            },
            "nextRunAt": {
                "kind": "date"
            },
            "periodic": {
                "kind": "boolean"
            },
            "runCount": {
                "kind": "number"
            },
            "status": {
                "kind": "enum",
                "values": [
                    "active",
                    "inactive",
                    "completed"
                ]
            },
            "templateId": {
                "kind": "ref",
                "refEntity": "workflowTemplate"
            },
            "triggerNodeId": {
                "kind": "text"
            }
        },
        "workflowTask": {
            "assignedTo": {
                "kind": "ref",
                "refEntity": "user"
            },
            "attachments": {
                "kind": "json"
            },
            "completedAt": {
                "kind": "date"
            },
            "completedBy": {
                "kind": "ref",
                "refEntity": "user"
            },
            "decision": {
                "kind": "enum",
                "values": [
                    "approved",
                    "rejected",
                    "returned",
                    "info_requested",
                    "acknowledged",
                    "reviewed",
                    "needs_changes",
                    "escalate",
                    "submitted"
                ]
            },
            "decisionCategory": {
                "kind": "enum",
                "values": [
                    "INCOMPLETE_DATA",
                    "POLICY_VIOLATION",
                    "BUDGET_EXCEEDED",
                    "INCORRECT_INFO",
                    "OUT_OF_SCOPE",
                    "RETURN",
                    "REVIEW_NEEDS_CHANGES",
                    "REVIEW_ESCALATE",
                    "OTHER"
                ]
            },
            "decisionComment": {
                "kind": "text"
            },
            "delegationId": {
                "kind": "ref",
                "refEntity": "delegation"
            },
            "dueAt": {
                "kind": "date"
            },
            "entityId": {
                "kind": "ref"
            },
            "entityType": {
                "kind": "text"
            },
            "escalationPolicy": {
                "kind": "json"
            },
            "formSubmission": {
                "kind": "ref",
                "refEntity": "formSubmission"
            },
            "forwardReason": {
                "kind": "text"
            },
            "forwardedFromUserId": {
                "kind": "ref",
                "refEntity": "user"
            },
            "infoRequestPayload": {
                "kind": "json"
            },
            "instanceId": {
                "kind": "ref",
                "refEntity": "workflowInstance"
            },
            "linkedFollowUpTaskId": {
                "kind": "ref",
                "refEntity": "workflowTask"
            },
            "nodeId": {
                "kind": "text"
            },
            "nodeLabel": {
                "kind": "text"
            },
            "onBehalfOf": {
                "kind": "ref",
                "refEntity": "user"
            },
            "order": {
                "kind": "number"
            },
            "originalAssignee": {
                "kind": "ref",
                "refEntity": "user"
            },
            "requestInfoParentTaskId": {
                "kind": "ref",
                "refEntity": "workflowTask"
            },
            "requiresSignature": {
                "kind": "boolean"
            },
            "slaBreachedAt": {
                "kind": "date"
            },
            "slaEscalatedAt": {
                "kind": "date"
            },
            "slaWarnedAt": {
                "kind": "date"
            },
            "status": {
                "kind": "enum",
                "values": [
                    "PENDING",
                    "WAITING",
                    "IN_PROGRESS",
                    "COMPLETED",
                    "REJECTED",
                    "EXPIRED",
                    "REASSIGNED"
                ]
            },
            "strategy": {
                "kind": "text"
            },
            "strategyConfig": {
                "kind": "json"
            },
            "taskType": {
                "kind": "enum",
                "values": [
                    "APPROVAL",
                    "ACKNOWLEDGMENT",
                    "REVIEW",
                    "SIGN",
                    "NOTIFY",
                    "FORM_FILL",
                    "INFORMATIONAL"
                ]
            },
            "uniqueByUserInChain": {
                "kind": "boolean"
            },
            "warnBeforeHours": {
                "kind": "number"
            }
        },
        "workflowTemplate": {
            "code": {
                "kind": "text"
            },
            "compensationMap": {
                "kind": "json"
            },
            "description": {
                "kind": "text"
            },
            "edgeEvaluationMode": {
                "kind": "enum",
                "values": [
                    "all-matching",
                    "first-match"
                ]
            },
            "edges": {
                "kind": "json"
            },
            "entityType": {
                "kind": "text"
            },
            "failurePolicy": {
                "kind": "enum",
                "values": [
                    "stop",
                    "continue"
                ]
            },
            "globalEscalation": {
                "kind": "json"
            },
            "isActive": {
                "kind": "boolean"
            },
            "isPublished": {
                "kind": "boolean"
            },
            "isSystemDefault": {
                "kind": "boolean"
            },
            "name": {
                "kind": "text"
            },
            "nodes": {
                "kind": "json"
            },
            "publishedAt": {
                "kind": "date"
            },
            "publishedBy": {
                "kind": "ref",
                "refEntity": "user"
            },
            "rejectionRoutes": {
                "kind": "json"
            },
            "variables": {
                "kind": "json"
            },
            "version": {
                "kind": "number"
            }
        }
    }
});
